import type { Dict } from '../types';

export const ptBR: Dict = {
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in OpenDesign.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening OpenDesign so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open OpenDesign",
  'invite.open.opening': "Opening OpenDesign…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have OpenDesign installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download OpenDesign",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "Este workspace não tem mais assentos. Adicione assentos para convidar colegas.",
  "workspaceInvite.seatsExhaustedAction": "Ver assentos e plano",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "Este e-mail já é membro da equipe.",
  "workspaceInvite.errorPendingInvite": "Este e-mail já tem um convite pendente.",
  "workspaceInvite.errorNoSession": "Entre na sua conta Vela antes de convidar membros.",
  "workspaceInvite.errorNoWorkspace": "Ainda não há um espaço de equipe para convidar membros.",
  "workspaceInvite.errorUnreachable": "Não foi possível enviar o convite. Tente novamente mais tarde.",
  'chat.amrCard.switchTitle': 'Falha ao chamar o modelo — esta execução está pausada',
  'chat.amrCard.switchBody': 'Mude para o serviço oficial de modelos do OpenDesign Cloud — sem precisar configurar API Key. Após entrar, autorizar e recarregar, esta execução será repetida automaticamente.',
  'chat.amrCard.chipOfficial': 'Hospedagem oficial',
  'chat.amrCard.chipNoKey': 'Sem API Key',
  'chat.amrCard.chipAutoRetry': 'Nova tentativa automática após entrar',
  'chat.amrCard.switchCta': 'Mudar para OpenDesign Cloud e tentar novamente',
  'chat.amrError.authMessage': 'Sua conta OpenDesign Cloud ainda não está autorizada. Autorize-a e esta execução será repetida automaticamente.',
  'chat.amrError.balanceMessage': 'Seu saldo OpenDesign Cloud acabou. Recarregue para continuar esta execução.',
  'chat.amrError.authorizeCta': 'Autorizar e tentar novamente',
  'chat.amrError.rechargeCta': 'Recarregar',
  'chat.amrBalanceGate.title': 'Faça upgrade e continue criando',
  'chat.amrBalanceGate.message': 'Créditos insuficientes (restam {balance}). Faça upgrade do plano ou recarregue e a tarefa pode começar na hora.',
  'chat.amrBalanceGate.benefitsTitle': 'O que o OpenDesign Cloud oferece',
  'chat.amrBalanceGate.benefit1': 'Sem chave de API, vários modelos à escolha',
  'chat.amrBalanceGate.benefit2': 'Agente de design SOTA integrado, sem configuração',
  'chat.amrBalanceGate.benefit3': 'Serviço oficial e confiável',
  'chat.amrBalanceGate.benefit4': 'Sempre evoluindo: deploy em 1 clique, multimodal, equipes e mais',
  'chat.amrBalanceGate.laterCta': 'Agora não',
  'chat.amrBalanceGate.plansCta': 'Fazer upgrade',
  'chat.amrBalanceGate.signedOutTitle': 'Entre para começar a criar',
  'chat.amrBalanceGate.signedOutMessage': 'Você está usando o agente OpenDesign Cloud — entre e esta tarefa pode começar na hora.',
  'chat.amrBalanceGate.signInCta': 'Entrar',
  'chat.amrBalanceGate.watchingWallet': 'Continuaremos automaticamente assim que seu saldo for atualizado.',
  'chat.amrLowBalance.title': 'Créditos acabando',
  'chat.amrLowBalance.message': 'Restam apenas {balance} — provavelmente não é o bastante para concluir esta tarefa. Recarregue ou faça upgrade antes.',
  'chat.amrLowBalance.rechargeCta': 'Recarregar',
  'chat.amrLowBalance.proceedCta': 'Iniciar mesmo assim',
  'chat.amrLowBalance.dontRemind': 'Não perguntar novamente',
  'chat.amrArtifactUpgrade.title': 'Continue refinando com modelos mais potentes',
  'chat.amrArtifactUpgrade.message': 'Desbloqueie modelos avançados, mais tarefas paralelas e mais créditos mensais.',
  'chat.amrArtifactUpgrade.benefit1': 'Mais modelos avançados, incluindo Fable 5 e GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Até 10 vezes mais tarefas simultâneas',
  'chat.amrArtifactUpgrade.benefit3': 'Até 300 vezes mais créditos mensais',
  'chat.amrArtifactUpgrade.benefit4': 'Fila prioritária nos horários de pico para gerar mais rápido',
  'chat.amrArtifactUpgrade.promoBanner': 'Por tempo limitado: economize até 67% nos planos de assinatura',
  'chat.amrArtifactUpgrade.countdownLabel': 'Termina em',
  'chat.amrArtifactUpgrade.plansCta': 'Faça upgrade agora, até 67% de desconto',
  'chat.amrArtifactUpgrade.homePlansCta': 'Economize 67%',
  'chat.amrArtifactUpgrade.laterCta': 'Continuar com Free e enviar',
  'chat.amrArtifactUpgrade.homeTitle': 'Sua criação está pronta. Leve a próxima ideia ainda mais longe.',
  'chat.amrArtifactUpgrade.homeMessage': 'Faça upgrade para modelos mais potentes, mais tarefas paralelas e mais créditos.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Ver criação',
  'chat.antigravityError.launchTerminalCta': 'Entrar pelo terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Alternar modelo no terminal',
  'chat.connectionDropped': 'A conexão com o serviço do modelo caiu antes de a resposta terminar — geralmente uma rede ou proxy instável. Tente novamente.',
  'chat.runError.title.authRequired': 'Autorização necessária',
  'chat.runError.title.balance': 'Saldo insuficiente',
  'chat.runError.title.connectionDropped': 'Conexão interrompida',
  'chat.runError.title.signInRequired': 'Login necessário',
  'chat.runError.title.rateLimited': 'Limite de uso atingido',
  'chat.runError.title.modelWindowLimit': 'Alta demanda',
  'chat.runError.title.generic': 'A tarefa falhou',
  'chat.runError.title.artifactMissing': 'Nenhum entregável gerado',
  'chat.runError.signInMessage.amr': 'O agente OpenDesign Cloud ainda não fez login — faça login para começar a usá-lo.',
  'chat.runError.signInMessage.other': '{agent} não fez login. Verifique o status de login localmente. Recomendamos o agente OpenDesign Cloud — mais estável e econômico.',
  'chat.runError.agentFallback': 'o agente',
  'chat.runError.sourceLabel': 'Detalhes do erro',
  'chat.runError.sourceExpandAria': 'Expandir origem do erro',
  'chat.runError.sourceCollapseAria': 'Recolher origem do erro',
  'chat.runError.title.cliMissing': 'Agente não instalado',
  'chat.runError.title.promptTooLarge': 'Entrada muito longa',
  'chat.runError.title.modelUnavailable': 'Modelo indisponível',
  'chat.runError.title.upstreamUnavailable': 'Serviço temporariamente indisponível',
  'chat.runError.title.toolLoop': 'Preso em um loop',
  'chat.runError.title.outputInvalid': 'Saída do modelo inválida',
  'chat.runError.title.runtimeConfig': 'Erro de configuração',
  'chat.runError.cliMissingMessage': 'A ferramenta de linha de comando do {agent} não foi encontrada. Instale-a e verifique se está no PATH, depois tente novamente.',
  'chat.runError.promptTooLargeMessage': 'Este turno excedeu o limite de contexto do modelo. Encurte o prompt, remova anexos ou inicie uma nova conversa e tente novamente.',
  'chat.runError.modelUnavailableMessage': 'O modelo selecionado está indisponível ou não existe. Troque para outro modelo em Configurações e tente novamente.',
  'chat.runError.rateLimitedMessage': 'Você atingiu o limite de uso do serviço do modelo. Aguarde um momento e tente novamente, ou troque para outro modelo ou serviço.',
  'chat.runError.modelWindowLimitMessage': 'Alta demanda no momento. Tente novamente após {retryAt}. Esta solicitação não foi cobrada.',
  'chat.runError.modelWindowLimitMessageNoTime': 'Alta demanda no momento. Tente novamente em instantes. Esta solicitação não foi cobrada.',
  'chat.runError.upstreamUnavailableMessage': 'O serviço do modelo está temporariamente indisponível — geralmente instabilidade upstream ou um problema de rede/proxy. Tente novamente em instantes.',
  'chat.runError.toolLoopMessage': 'O {agent} repetiu a mesma ação sem progredir e foi interrompido. Verifique o arquivo ou comando de destino e tente novamente.',
  'chat.runError.outputInvalidMessage': 'O modelo produziu uma saída inválida e este turno foi interrompido. Tentar novamente costuma resolver.',
  'chat.runError.runtimeConfigMessage': 'A configuração de runtime do agente selecionado é inválida, então a execução não pôde iniciar. Atualize para a versão mais recente ou contate o suporte.',
  'chat.runError.title.quotaExhausted': "Cota esgotada",
  'chat.runError.title.timedOut': "Tempo esgotado",
  'chat.runError.title.emptyOutput': "Sem saída",
  'chat.runError.title.sessionExpired': "Sessão expirada",
  'chat.runError.title.gitBashMissing': "Git Bash ausente",
  'chat.runError.title.cpuUnsupported': "Processador não compatível",
  'chat.runError.quotaExhaustedMessage': "A cota ou o limite de cobrança do seu serviço de modelo acabou, então tentar de novo não vai ajudar. Recarregue com seu provedor ou mude para outro modelo ou serviço.",
  'chat.runError.workspaceCreditsMessage': "Seu espaço de trabalho ficou sem créditos. Adicione créditos (ou peça ao proprietário do espaço para recarregar) ou mude para outro modelo ou serviço.",
  'chat.runError.timedOutMessage': "Esta execução demorou demais e foi interrompida. Tente novamente ou reduza a tarefa e repita.",
  'chat.runError.inactivityTimeoutMessage': "O agente ficou sem nova saída por tempo demais e foi interrompido por tempo esgotado. Tentar de novo costuma retomá-lo.",
  'chat.runError.emptyOutputMessage': "O agente terminou sem produzir nenhuma saída. Isso costuma ser temporário, tente novamente.",
  'chat.runError.sessionExpiredMessage': "A sessão retomada havia expirado. Ela foi redefinida, então tente novamente para iniciar uma nova execução.",
  'chat.runError.gitBashMissingMessage': "O Git Bash é necessário para executar este agente no Windows, mas não foi encontrado. Instale o Git para Windows e tente novamente.",
  'chat.runError.cpuUnsupportedMessage': "O runtime deste agente precisa de um conjunto de instruções de CPU (AVX2) que este dispositivo não possui, por isso não consegue iniciar. Atualize o OpenDesign para a versão mais recente, que inclui um runtime compatível.",
  'common.cancel': 'Cancelar',
  'chat.selectFromLibrary': 'Importar da biblioteca',
  'chat.importFigma': 'Importar do Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the OpenDesign project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Importar da biblioteca',
  'designFiles.library.title': 'Importar da biblioteca',
  'libraryPicker.title': 'Importar da biblioteca',
  'libraryPicker.searchPlaceholder': 'Pesquisar na biblioteca…',
  'libraryPicker.empty': 'Ainda não há recursos na sua biblioteca',
  'libraryPicker.allKinds': 'Todos',
  'libraryPicker.add': 'Importar',
  'libraryPicker.loading': 'Carregando…',
  'common.save': 'Salvar',
  'common.close': 'Fechar',
  'common.clear': 'Limpar',
  'common.delete': 'Excluir',
  'common.rename': 'Renomear',
  'common.edit': 'Editar',
  'common.preview': 'Prévia',
  'common.share': 'Compartilhar',
  'common.search': 'Buscar',
  'common.searchEllipsis': 'Buscar…',
  'common.loading': 'Carregando…',
  'common.all': 'Todos',
  'common.none': 'Nenhum',
  'common.default': 'Padrão',
  'common.installed': 'instalado',
  'common.notInstalled': 'não instalado',
  'common.active': 'ativo',
  'common.inactive': 'inativo',
  'common.offline': 'off-line',
  'common.selected': 'selecionado',
  'common.create': 'Criar',
  'common.openPreview': 'Abrir prévia',
  'common.exitFullscreen': 'Sair da tela cheia',
  'common.fullscreen': 'Tela cheia',
  'common.openInNewTab': 'Abrir em nova aba',
  'common.exportPdf': 'Exportar como PDF',
  'common.exportZip': 'Baixar como .zip',
  'common.exportHtml': 'Exportar como HTML independente',
  'common.exportImage': 'Exportar como imagem',
  'common.exportImageFailed': 'Falha ao capturar imagem. Tente novamente ou use a ferramenta de captura de tela do seu navegador.',
  'common.justNow': 'agora mesmo',
  'common.minutesAgo': 'há {n} min',
  'common.hoursAgo': 'há {n} h',
  'common.daysAgo': 'há {n} d',
  'common.weeksAgo': 'há {n}sem',
  'common.now': 'agora',
  'common.minutesShort': '{n} min',
  'common.hoursShort': '{n} h',
  'common.daysShort': '{n} d',
  'common.untitled': 'Sem título',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'Desktop',
  'designBrowser.viewport.desktopTitle': 'Usar o tamanho completo da aba do navegador',
  'designBrowser.viewport.tablet': 'Tablet',
  'designBrowser.viewport.tabletTitle': 'Pré-visualizar com 820px de largura',
  'designBrowser.viewport.mobile': 'Celular',
  'designBrowser.viewport.mobileTitle': 'Pré-visualizar com 390px de largura',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'Adicionar ao chat',
  'designBrowser.status.imageAddedToChat': 'Imagem adicionada ao chat.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Procedência',
  'plugins.availableDetails.provenanceLine': 'de {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'de {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Instalar',
  'plugins.availableDetails.version': 'Versão',
  'plugins.availableDetails.pluginVersion': 'Versão do plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copiar comando de instalação',
  'plugins.availableDetails.copied': 'Copiado',
  'plugins.availableDetails.deprecatedPrefix': 'Obsoleto: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Esta versão foi marcada como obsoleta.',
  'plugins.availableDetails.yanked': 'Removida.',
  'plugins.availableDetails.yankedWithReason': 'Removida: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (obsoleto)',
  'plugins.availableDetails.versionYankedSuffix': ' (removido)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Permissões',
  'plugins.availableDetails.capabilitySummary': 'Resumo de recursos',
  'plugins.actions.copyInstallCommand': 'Copiar comando de instalação',
  'plugins.actions.copyPluginId': 'Copiar ID do plugin',
  'plugins.actions.copyReadmeBadge': 'Copiar selo do README',
  'plugins.actions.openSourceGithub': 'Abrir fonte no GitHub',
  'plugins.actions.openSource': 'Abrir fonte',
  'plugins.actions.openHomepage': 'Abrir homepage',
  'plugins.actions.openMarketplace': 'Abrir no marketplace',
  'app.brand': 'OpenDesign',
  'app.brandPill': 'Prévia de pesquisa',
  'app.brandSubtitle': 'por Nexu Labs',
  'app.welcomeLoading': 'Carregando área de trabalho…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Boas-vindas ao OpenDesign',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Comece com um briefing',
  'settings.onboardingCreateBody': 'Descreva o site, app, apresentação, imagem ou vídeo que você quer. O OpenDesign vai criar um projeto e manter o trabalho editável.',
  'settings.onboardingMemoryTitle': 'Salvar contexto de trabalho',
  'settings.onboardingMemoryBody': 'Adicione preferências, informações do projeto e regras recorrentes para que conversas futuras assumam o contexto certo.',
  'settings.onboardingMemoryCalloutTitle': 'Salvo na sua Memória',
  'settings.onboardingMemoryCalloutBody': 'Estas respostas formam a base do seu perfil de Memória. O OpenDesign reutiliza isso em cada tarefa — e continua aprendendo conforme você trabalha.',
  'settings.onboardingMemoryBenefitIntent': 'Entende o que você quer a partir de um pedido curto',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Pula perguntas de configuração repetidas',
  'settings.onboardingMemoryBenefitPersonalized': 'Adapta os resultados ao seu papel, público e gosto',
  'settings.onboardingSystemsTitle': 'Traga seu design system',
  'settings.onboardingSystemsBody': 'Escolha ou crie um sistema de marca para que o trabalho gerado siga as cores, a tipografia e a linguagem real do produto.',
  'settings.onboardingExecutionTitle': 'Escolha a origem do modelo',
  'settings.onboardingExecutionBody': 'Use o OpenDesign Hosted, conecte um agente local ou utilize sua própria chave de modelo.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Recomendado oficialmente',
  'settings.onboardingAmrCloudBenefitReady': 'Sem deploy',
  'settings.onboardingAmrCloudBenefitModels': 'Acesse Claude, GPT, Fable 5 e 5.6 sol com desconto por tempo limitado e alta simultaneidade.',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'Em breve',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Imagem e vídeo',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills em massa',
  'settings.onboardingAmrCloudUpcomingRouting': 'Roteamento inteligente',
  'settings.onboardingAmrModelSourceLabel': 'OpenDesign Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autorizar OpenDesign Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorizado',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Criar um sistema de design',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Fique por dentro',
  'settings.onboardingNewsletterTitle': 'Fique por dentro',
  'settings.onboardingNewsletterBody': 'Receba novidades do produto, novos templates, design systems e trabalho de embaixadores no seu e-mail. Opcional — você pode pular.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Entrar no OpenDesign',
  'settings.onboardingCloudBody': 'Entre e comece a criar na hora com IA na nuvem, sem configurações complicadas.',
  'settings.onboardingCloudSignIn': 'Entrar no OpenDesign',
  'settings.onboardingCloudContinue': 'Continuar (conectado)',
  'settings.onboardingCloudAlternative': 'Usar uma CLI local ou sua própria chave de API',
  'settings.onboardingCloudRights': 'Todos os direitos reservados.',
  'settings.onboardingCloudOr': 'ou',
  'settings.onboardingGateTooltipNoRuntime': 'As próximas etapas rodam em IA — escolha um runtime para continuar.',
  'settings.onboardingGateTooltipAmr': 'As próximas etapas rodam em IA — faça login no OpenDesign Cloud para continuar.',
  'settings.onboardingGateTooltipLocal': 'As próximas etapas rodam em IA — selecione uma CLI local disponível para continuar.',
  'settings.onboardingGateTooltipByok': 'As próximas etapas rodam em IA — adicione e teste sua chave de modelo para continuar.',
  'settings.onboardingRecommended': 'Recomendado',
  'settings.onboardingAmrCloudOfficialBadge': 'Oficial',
  'settings.onboardingLocalTitle': 'Agente local',
  'settings.onboardingLocalBody': 'Use Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro e outros.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Use sua própria chave',
  'settings.onboardingByokBody': 'Conecte seu provedor de modelos preferido com segurança usando sua própria chave de API.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'Sobre você',
  'settings.onboardingProfileBody': 'Detalhes opcionais para melhores padrões.',
  'settings.onboardingRoleLabel': 'Sua função',
  'settings.onboardingOrgSizeLabel': 'Tamanho da organização',
  'settings.onboardingUseCaseLabel': 'Caso de uso',
  'settings.onboardingSourceLabel': 'Como você ficou sabendo da gente?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Busca (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 Ferramenta de IA (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Amigo ou colega',
  'settings.onboardingSourceCommunity': '💬 Discord / comunidade',
  'settings.onboardingSourceEmail': '✉️ E-mail / Newsletter',
  'settings.onboardingSourceBlog': '📝 Blog / artigo',
  'settings.onboardingSourceOther': '✨ Outro',
  'settings.onboardingSourceOtherPlaceholder': 'Diga onde (opcional)',
  'settings.onboardingSelectPlaceholder': 'Selecione uma opção',
  'settings.onboardingSelectMultiplePlaceholder': 'Selecione uma ou mais',
  'settings.onboardingOrgSolo': 'Individual / pessoal (1)',
  'settings.onboardingOrgTeam': 'Equipe pequena (2-10)',
  'settings.onboardingOrgStartup': 'Startup / PME (11-50)',
  'settings.onboardingOrgGrowth': 'Empresa em crescimento (51-200)',
  'settings.onboardingOrgMidMarket': 'Médio porte (201-1000)',
  'settings.onboardingOrgEnterprise': 'Grande empresa (1000+)',
  'settings.onboardingRolePm': '📋 Gerente de produto',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engenheiro',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Agência de marketing',
  'settings.onboardingRoleGrowth': '📈 Crescimento',
  'settings.onboardingRoleOps': '⚙️ Operações',
  'settings.onboardingRoleFounder': '🚀 Fundador / executivo',
  'settings.onboardingRoleStudent': '🎓 Estudante / educador',
  'settings.onboardingRoleOther': '✨ Outro',
  'settings.onboardingUseProduct': '🎨 Design de produto',
  'settings.onboardingUseDesignSystem': '🧩 Sistema de design',
  'settings.onboardingUsePrototype': '📱 Protótipo / UI de app',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Anúncios / conteúdo social',
  'settings.onboardingUseDashboard': '📊 Dashboards / ferramentas internas',
  'settings.onboardingUseDeck': '🖥️ Apresentação / slides',
  'settings.onboardingUseMarketing': '📈 Marketing / crescimento',
  'settings.onboardingUseEngineering': '🤝 Handoff de engenharia',
  'settings.onboardingUseAgency': '💼 Agência / trabalho para clientes',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Configurações',
  'settings.title': 'Modelos e provedores',
  'settings.subtitle': 'Escolha entre CLI local e BYOK.',
  'settings.general': 'Geral',
  'settings.generalHint': 'Idioma, aparência, notificações, locais dos projetos, privacidade e detalhes do app.',
  'settings.modeAria': 'Modo de execução',
  'settings.protocolAria': 'Protocolo de API',
  'settings.modeDaemon': 'CLI local',
  'settings.modeDaemonHelp': 'Execute por uma CLI de agente de código na sua máquina',
  'settings.modeDaemonOffline': 'Daemon não está em execução',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} instalados',
  'settings.modeApi': 'Provedor de API',
  'settings.cloudCalloutTitle': 'Use OpenDesign Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'Provedores de API',
  'settings.byokNoFileToolsNotice': 'O BYOK não consegue ler, gravar ou editar arquivos do projeto. Use o Local CLI quando precisar fazer alterações no código.',
  'settings.byokDraftNotice': 'Preencha os campos obrigatórios para salvar este provedor. Sua configuração atual continuará ativa.',
  'settings.codeAgent': 'Agente de código',
  'settings.codeAgentHint': 'Detectado ao escanear seu PATH. Escolha a CLI por onde as gerações devem passar.',
  'settings.rescan': '↻ Reescanear',
  'settings.rescanTitle': 'Reescanear PATH',
  'settings.rescanRunning': 'Escaneando...',
  'settings.rescanSuccess': 'Escaneamento concluido. {count} disponiveis.',
  'settings.designSystemRenameFailed': 'Falha ao renomear. Verifique o daemon e tente novamente.',
  'settings.rescanFailed': 'Falha ao escanear. Verifique o daemon e tente novamente.',
  'settings.test': 'Testar',
  'settings.testTitle': 'Envie um pequeno prompt de teste para verificar a conexão',
  'settings.testRunning': 'Testando conexão…',
  'settings.byokReadyToTest': 'Pronto para testar',
  'settings.testCancel': 'Cancelar',
  'settings.testRetry': 'Testar novamente',
  'settings.required': 'obrigatório',
  'settings.testMissingFields': 'Preencha {fields} para testar a conexão.',
  'settings.testSuccessApi': 'Conectado. Respondeu em {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} respondeu em {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Falha na autenticação. Verifique sua chave de API.',
  'settings.testForbidden': 'Acesso proibido. Verifique conta, região ou organização.',
  'settings.testNotFoundModel': 'Modelo \'{model}\' não encontrado neste endpoint.',
  'settings.testInvalidModelId': 'O id de modelo \'{model}\' é inválido. IDs personalizados devem começar com letra ou número e não conter espaços.',
  'settings.testInvalidBaseUrl': 'Base URL inválida ou inacessível.',
  'settings.testRateLimited': 'Provedor limitou o teste. Configuração parece válida.',
  'settings.testUpstream': 'Provedor retornou {status}. Tente novamente em instantes.',
  'settings.testTimeout': 'Teste expirou após {ms} ms.',
  'settings.testAgentMissing': '{agentName} não está instalado ou não está no PATH.',
  'settings.testAgentSpawn': 'Não foi possível iniciar {agentName}: {detail}.',
  'settings.testUnknown': 'Falha no teste: {detail}',
  'settings.agentInstall.install': 'Instalar',
  'settings.agentInstall.docs': 'Documentação',
  'settings.agentInstall.pathHint': 'Se você instalou uma CLI com npm ou Homebrew e ela ainda aparece como não instalada, garanta que o diretório bin da ferramenta esteja no PATH herdado pelo daemon do OpenDesign (Terminal e apps GUI podem diferir no macOS). Veja QUICKSTART.md (seção "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Abra Instalar ou Docs para o agente desejado.',
  'settings.agentInstall.stepAuth': 'Autentique-se na CLI do fornecedor (faça login ou adicione credenciais de API) antes de voltar ao OpenDesign.',
  'settings.agentInstall.stepRescan': 'Clique em Reescanear nesta seção.',
  'settings.agentInstall.stepSelect': 'Selecione o cartão do agente quando ele aparecer como instalado.',
  'settings.noAgentsDetected': 'Nenhum agente detectado ainda. Instale Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen ou GitHub Copilot CLI e clique em Reescanear.',
  'settings.agentInstalledGroup': 'Suas CLIs ({count})',
  'settings.agentInstallGroup': 'Disponíveis para instalar ({count})',
  'settings.agentAuthRequired': 'Autenticação necessária',
  'settings.agentAuthUnknown': 'Status de autenticação desconhecido',
  'settings.amrCloud': 'OpenDesign Cloud',
  'settings.amrAuthorize': 'Autorizar',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Vários modelos',
  'settings.amrPromoBonus': 'Bônus limitado: +100%',
  'settings.amrSignInToContinue': 'Faça login para continuar',
  'settings.amrSignIn': 'Entrar',
  'settings.amrSignedIn': 'Conectado',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh OpenDesign Cloud wallet balance',
  'settings.amrNotSignedIn': 'Não conectado',
  'settings.amrSigningIn': 'Entrando…',
  'settings.amrActivationHint': 'A página de login não abriu? Toque no botão abaixo para abri-la novamente.',
  'settings.amrActivationBrowserFailed': 'Não foi possível abrir o navegador automaticamente. Abra a página de login abaixo para continuar.',
  'settings.amrActivationOpen': 'Abrir página de login',
  'settings.amrCancelSignIn': 'Cancelar login',
  'settings.amrAccountStatus': 'Status da conta OpenDesign Cloud',
  'settings.amrConsole': 'Gerenciar',
  'settings.amrBalance': 'Cota',
  'settings.amrPlan': 'Plano',
  'settings.amrUpgrade': 'Fazer upgrade',
  'settings.amrModelUpgradeHint': 'Faça upgrade para usar',
  'settings.amrLoginErrorCompact': 'Falha no login do OpenDesign Cloud.',
  'settings.advanced': 'Avançado',
  'settings.amrLogin': 'Entrar',
  'settings.amrLogout': 'Sair',
  'settings.amrLoggingIn': 'Entrando…',
  'settings.amrLoggingOut': 'Saindo…',
  'settings.amrLoggedInAs': 'Conectado como {email}',
  'settings.amrLoggedInWithPlan': 'Conectado como {email} · {plan}',
  'settings.amrLoggedInPill': 'Conectado',
  'settings.amrNotLoggedIn': 'Não conectado',
  'settings.apiSection': 'API da Anthropic',
  'settings.quickFillProvider': 'Preencher provedor',
  'settings.providerPreset': 'Predefinição do provedor',
  'settings.protocolGroupProtocols': 'Protocolos',
  'settings.protocolGroupGateways': 'Gateways',
  'settings.customProvider': 'Provedor personalizado',
  'settings.apiKey': 'Chave de API',
  'settings.apiKeyGetLink': 'Obter chave ↗',
  'settings.showKey': 'Mostrar chave',
  'settings.hideKey': 'Ocultar chave',
  'settings.show': 'Mostrar',
  'settings.hide': 'Ocultar',
  'settings.model': 'Modelo',
  'settings.apiKeyInvalid': 'API key inválida.',
  'settings.apiKeyCleaned': 'Espaços em branco extras foram removidos da API key.',
  'settings.modelsLoadedFromAccount': '✓ {count} modelos carregados da sua conta.',
  'settings.modelsLoadedCount': '✓ {count} modelos carregados.',
  'settings.modelSourceAccount': 'Da sua conta',
  'settings.modelSourceSuggested': 'Sugerido',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Custo baixo',
  'modelCost.halfToOne': 'Custo médio',
  'modelCost.oneToFour': 'Custo alto',
  'modelCost.overFour': 'Custo máximo',
  'settings.fetchModels': 'Buscar modelos',
  'settings.fetchModelsTitle': 'Buscar modelos disponíveis deste provedor',
  'settings.fetchModelsRunning': 'Buscando modelos…',
  'settings.fetchModelsMissingFields': 'Preencha {fields} para buscar modelos.',
  'settings.fetchModelsInvalidBaseUrl': 'Insira uma Base URL válida para buscar modelos.',
  'settings.fetchModelsUnsupportedAzure': 'O Azure OpenAI usa nomes de deployment, então a descoberta de modelos não está disponível aqui.',
  'settings.fetchModelsUnsupportedOllama': 'A descoberta de modelos do Ollama Cloud ainda não está disponível. Escolha ou digite um modelo.',
  'settings.fetchModelsSuccess': '{count} modelos encontrados.',
  'settings.fetchModelsEmpty': 'Nenhum modelo de texto compatível foi retornado.',
  'settings.fetchModelsUnsupported': 'A descoberta de modelos não está disponível para este protocolo.',
  'settings.fetchModelsFailed': 'Não foi possível buscar os modelos: {detail}',
  'settings.suggestedModelsHint': 'Estes são modelos sugeridos para este protocolo. Seu provedor pode oferecer suporte a modelos diferentes.',
  'settings.baseUrl': 'URL base',
  'settings.baseUrlInvalid': 'Use uma URL pública http:// ou https://.',
  'settings.baseUrlCustomize': 'Personalizar URL',
  'settings.baseUrlDefaultHint': 'Altere somente se você usar um proxy ou gateway compatível.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Encontre isto no portal do Azure → seu recurso → Endpoint.',
  'settings.azureDeploymentModel': 'Nome do deployment',
  'settings.azureCustomDeploymentName': 'Nome de deployment personalizado',
  'settings.azureDeploymentModelHint': 'No Azure OpenAI, este campo e usado como nome do deployment em /openai/deployments/<model>. Informe o nome do deployment criado no Azure.',
  'settings.azureModelFetchHint': 'Insira o nome da implantação do seu recurso do Azure. As implantações do Azure não podem ser obtidas automaticamente.',
  'settings.apiVersion': 'Versão da API',
  'settings.byokImageModel': 'Modelo de geração de imagens',
  'settings.byokVideoModel': 'Modelo de geração de vídeo',
  'settings.byokVideoI2vHint': 'Modelo de imagem para vídeo: é necessária uma imagem de referência (caso contrário, usa a imagem mais recente do projeto)',
  'settings.byokSpeechModel': 'Modelo de voz',
  'settings.byokSpeechVoice': 'Voz',
  'settings.byokModelDefaultOption': 'Padrão',
  'settings.maxTokens': 'Tokens máx. (opcional)',
  'settings.maxTokensHint': 'Comprimento máximo da resposta. Deixe em branco para usar o padrão do modelo.',
  'settings.apiHint': 'Armazenada localmente neste dispositivo.',
  'settings.skipForNow': 'Pular por enquanto',
  'settings.getStarted': 'Começar',
  'settings.envConfigure': 'Modelos e provedores',
  'settings.localCli': 'CLI local',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'OpenDesign will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the OpenDesign profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'API da Anthropic',
  'settings.noAgentSelected': 'nenhum agente selecionado',
  'settings.language': 'Idioma',
  'settings.languageHint': 'Altere o idioma da interface. Salvo neste navegador.',
  'settings.agentModelHead': 'Modelo para:',
  'settings.modelPicker': 'Modelo',
  'settings.modelSourceLive': 'Ao vivo da CLI',
  'settings.modelUsesCliDefault': 'Padrão da CLI',
  'settings.modelSourceFallback': 'Lista integrada',
  'settings.reasoningPicker': 'Esforço de raciocínio',
  'settings.serviceTierPicker': 'Camada de serviço',
  'settings.modelPickerHint': 'Buscado na CLI quando ela expõe um comando `models`. "Padrão" deixa a escolha para a configuração da própria CLI; "Personalizado…" permite digitar qualquer id de modelo aceito pela CLI.',
  'settings.modelPickerLiveHint': 'Os modelos foram atualizados a partir da CLI instalada. O padrão ainda usa a configuração da CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Os modelos foram atualizados a partir da CLI instalada.',
  'settings.modelPickerFallbackHint': 'Mostrando padrões integrados. Clique em Reescanear para buscar modelos ao vivo da CLI.',
  'settings.cliEnvTitle': 'Avançado: proxy e caminhos personalizados',
  'settings.cliEnvHint': 'Use estes campos para sobrescrever o ambiente da CLI selecionada: API keys, base URLs de proxy, homes personalizados ou caminhos de binários fora do padrão. Sem base URL, a CLI usa seu endpoint padrão. Segredos ficam na configuração local do app e apenas a CLI selecionada os vê.',
  'settings.cliEnvClaudeConfigDir': 'Diretório de configuração do Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL do proxy do Claude',
  'settings.cliEnvClaudeApiKey': 'API key da Claude CLI',
  'settings.cliEnvCodexHome': 'Home do Codex',
  'settings.cliEnvCodexBin': 'Caminho do executável do Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL do proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key da Codex/OpenAI CLI',
  'settings.modelCustom': 'Personalizado (digite abaixo)…',
  'settings.modelCustomLabel': 'Id do modelo personalizado',
  'settings.modelCustomPlaceholder': 'ex.: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Provedores de mídia',
  'settings.mediaProvidersHint': 'Chaves de API para geração de imagem, vídeo e áudio. Salvas localmente e sincronizadas com o daemon local.',
  'settings.mcpServerTitle': 'OpenDesign MCP',
  'settings.mcpServerHint': 'Exponha o OpenDesign como servidor MCP para o seu agente de código.',
  'settings.externalMcpTitle': 'MCP externo',
  'settings.externalMcpHint': 'Adicione ferramentas MCP de serviços externos (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'Configurado',
  'settings.mediaProviderUnset': 'Não configurado',
  'settings.mediaProviderClear': 'Limpar',
  'settings.mediaProviderClearConfirm': 'Remover as configurações salvas de {name}? Você precisará inseri-las novamente para usar {name}.',
  'settings.mediaProviderPlaceholder': 'Cole a API key',
  'settings.mediaProviderBaseUrlPlaceholder': 'Sobrescrever Base URL padrão',
  'settings.mediaProviderReload': 'Recarregar do daemon',
  'settings.mediaProviderReloadError': 'Não foi possível recarregar as configurações dos provedores de mídia do daemon local.',
  'settings.mediaProviderReloadSuccess': 'As configurações dos provedores de mídia foram recarregadas do daemon local.',
  'settings.mediaProviderLoadError': 'Não foi possível carregar as configurações dos provedores de mídia do daemon local. Usando por enquanto as configurações salvas no navegador.',
  'settings.mediaProviderComingSoonHint': 'Rastreamos estes para o roteiro; o daemon ainda não fornece um cliente, então não há nada para configurar.',
  'settings.privacy': 'Privacidade',
  'settings.privacyHint': 'Quais dados são compartilhados com a equipe do OpenDesign',
  'settings.privacyConsentKicker': 'Ajude-nos a melhorar o OpenDesign',
  'settings.privacyConsentLead': 'Compartilhar dados de uso nos ajuda a entender como o OpenDesign funciona em fluxos de trabalho reais, para melhorarmos as partes que mais impactam sua experiência.',
  'settings.privacyConsentFooter': 'Você pode alterar essas opções a qualquer momento em Configurações → Privacidade.',
  'settings.privacyConsentShare': 'Compartilhar',
  'settings.privacyConsentDecline': 'Não compartilhar',
  'settings.privacyConsentAccept': 'Entendi',
  'settings.privacyConsentBannerFooter': 'O compartilhamento de dados está ativado por padrão. Você pode desativá-lo a qualquer momento em Configurações → Privacidade.',
  'settings.privacyConsentPolicyLink': 'Ler a política de privacidade',
  'settings.privacyMetrics': 'Métricas anônimas',
  'settings.privacyMetricsHint': 'Contagem de execuções, uso de tokens, taxa de erros e duração como métricas básicas de uso.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'Depois que segredos e outras informações sensíveis são removidos, usamos prompts, respostas do assistente, entrada/saída de ferramentas e contexto necessário para revisão de qualidade.',
  'settings.privacyInstallationId': 'ID anônimo',
  'settings.privacyOptedOut': 'optou por não participar',
  'settings.privacyDataDeletion': 'Excluir meus dados',
  'settings.privacyDataDeletionHint': 'Rotaciona seu ID anônimo e interrompe os envios. Os rastros existentes expiram conforme nossa política de retenção.',
  'settings.about': 'Sobre',
  'settings.aboutHint': 'Versão e detalhes de execução',
  'settings.appVersion': 'Versão',
  'settings.appChannel': 'Canal',
  'settings.appRuntime': 'Runtime',
  'settings.appPlatform': 'Plataforma',
  'settings.appArchitecture': 'Arquitetura',
  'settings.runtimePackaged': 'App empacotado',
  'settings.runtimeDevelopment': 'Desenvolvimento',
  'settings.versionUnavailable': 'Os detalhes de versão ficam indisponíveis enquanto o daemon está offline.',
  "settings.allowSilentUpdates": "Permitir instalação automática de futuras atualizações no app",
  "settings.allowSilentUpdatesDesc": "Quando uma atualização no app estiver pronta, instale automaticamente na próxima abertura. Não atualiza a sessão atual. Atualizações com instalador ainda pedem confirmação.",
  'settings.installLatest': 'Instalar a versão mais recente',
  'settings.alreadyLatest': 'Você já está na versão mais recente',
  'settings.updateCheck': 'Verificar atualizações',
  'settings.updateNow': 'Atualizar agora',
  'settings.updateRecheck': 'Verificar novamente',
  'settings.updateRetry': 'Tentar novamente',
  'settings.updateViewReleases': 'Notas da versão',
  'settings.updateActionFailed': 'Não foi possível concluir a ação de atualização.',
  'settings.updateQuitFailed': 'O instalador foi aberto, mas o OpenDesign não conseguiu sair automaticamente.',
  'settings.updateStatusNotChecked': 'Ainda não verificado',
  'settings.updateStatusDevelopment': 'Builds de desenvolvimento não aceitam atualizações no app.',
  'settings.updateStatusUnsupported': 'Este ambiente não aceita atualizações no app.',
  'settings.updateStatusChecking': 'Verificando atualizações...',
  'settings.updateStatusUpToDate': 'Você já está na versão mais recente.',
  'settings.updateStatusAvailable': 'Nova versão {version} encontrada. Preparando download.',
  'settings.updateStatusAvailableUnknown': 'Nova versão encontrada. Preparando download.',
  'settings.updateStatusDownloading': 'Baixando atualização...',
  'settings.updateStatusDownloadingPercent': 'Baixando atualização {percent}%.',
  'settings.updateStatusReady': 'Versão {version} pronta para instalar.',
  'settings.updateStatusReadyUnknown': 'Atualização pronta para instalar.',
  'settings.updateStatusInstalling': 'Instalando atualização...',
  'settings.updateStatusFailed': 'Falha ao verificar. Tente novamente.',
  'settings.mcpTitle': 'Servidor MCP',
  'settings.mcpHint': 'Permita que agentes de programação (Cursor, Claude Code, VS Code…) leiam seus projetos do OpenDesign diretamente.',
  'settings.mcpDaemonError': 'Não foi possível alcançar o daemon local para resolver os caminhos de instalação ({error}). Verifique se o OpenDesign está em execução e reabra este painel.',
  'settings.mcpBuildDaemon': 'Compile o daemon primeiro.',
  'settings.mcpNodeMissing': 'O binário do Node está ausente.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js está ausente. Execute `pnpm --filter @open-design/daemon build` e atualize.',
  'settings.mcpMethodCli': 'Comando da CLI',
  'settings.mcpInstructionCli': 'Execute isto no seu terminal.',
  'settings.mcpMethodToml': 'Configuração TOML',
  'settings.mcpInstructionCodex': 'Anexe esta tabela a {path}. A mesma configuração é compartilhada entre a Codex CLI e a extensão de IDE do Codex.',
  'settings.mcpMethodOneClick': 'Instalação com um clique',
  'settings.mcpInstructionCursor': 'Clique em "Install in Cursor" para instalar com um diálogo de aprovação, ou mescle este JSON em {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Instalar no Cursor',
  'settings.mcpMethodJson': 'Configuração JSON',
  'settings.mcpInstructionKiro': 'Abra {path} e mescle este JSON. Para configuração no nível do workspace, use .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Abra a Command Palette ({shortcut}), execute "MCP: Open User Configuration" e mescle este JSON. O Copilot Chat precisa estar em modo Agent para que as ferramentas apareçam.',
  'settings.mcpInstructionAntigravity': 'No Antigravity: menu "..." do painel do Agent → MCP Servers → Manage MCP Servers → View raw config. Mescle este JSON.',
  'settings.mcpInstructionZed': 'Abra as Zed Settings ({shortcut}) e mescle isto no objeto de nível superior. O Zed usa "context_servers", não "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Abra {path} (ou use o ícone de MCPs no Cascade → Configure) e mescle:',
  'settings.mcpCopyAria': 'Copiar trecho de configuração do MCP',
  'settings.mcpResolvingFailed': '# a resolução de caminhos falhou, veja o erro acima',
  'settings.mcpLoadingPaths': '# carregando caminhos de instalação do daemon local…',
  'settings.mcpCopied': 'Copiado',
  'settings.mcpCopy': 'Copiar',
  'settings.mcpCursorApproval': 'O Cursor exibe um diálogo de aprovação antes de gravar a configuração.',
  'settings.mcpCodexOneClickInstall': 'Instalar no Codex',
  'settings.mcpCodexOneClickUninstall': 'Remover do Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI não encontrado no PATH — instale o Codex ou cole o trecho manualmente.',
  'settings.mcpCodexInstallSuccess': 'Instalado. Reinicie o Codex para carregar o novo servidor.',
  'settings.mcpCodexUninstallSuccess': 'Removido do Codex.',
  'settings.mcpCodexBusy': 'Trabalhando…',
  'settings.mcpCodexInstallError': 'A operação falhou: {error}',
  'settings.mcpRestartNote': 'Reinicie seu cliente para detectar o novo servidor.',
  'settings.mcpRestartDetail': 'A maioria dos editores só carrega servidores MCP na inicialização. No Cursor / VS Code / Antigravity / Windsurf você pode executar `Developer: Reload Window` na command palette em vez de um reinício completo. Zed e Claude Code exigem fechar e reabrir.',
  'settings.mcpCapabilitiesTitle': 'O que seu agent pode fazer',
  'settings.mcpCapabilityRead': 'Ler ou pesquisar qualquer arquivo em um projeto (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Obter um bundle de design em uma única chamada: o arquivo de entrada mais todas as variáveis CSS, componentes e fontes que ele referencia.',
  'settings.mcpCapabilityDefault': 'Usar por padrão o projeto e o arquivo que você tem aberto no OpenDesign, para que você possa dizer "crie isto no meu app" sem precisar repetir qual design.',
  'settings.mcpRunningNote': 'O OpenDesign precisa estar em execução para que as chamadas de ferramentas MCP funcionem. Se você iniciou seu agent de programação antes de abrir o OpenDesign, reinicie o agent para que ele consiga alcançar o daemon ativo.',
  'entry.tabDesigns': 'Designs',
  'entry.tabTemplates': 'Modelos',
  'entry.tabDesignSystems': 'Sistemas de design',
  'entry.tabConnectors': 'Conectores',
  'entry.openSettingsTitle': 'Configurações',
  'entry.openSettingsAria': 'Abrir configurações',
  'entry.discordLabel': 'Entrar no Discord',
  'entry.discordAria': 'Entre no Discord do OpenDesign',
  'entry.discordAriaWithOnline': 'Entre no Discord do OpenDesign - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.feishuAria': 'Entre no grupo do Feishu do OpenDesign',
  'entry.mailAria': 'Enviar e-mail para o OpenDesign',
  'entry.accountSettings': 'Configurações',
  'chat.collapsePane': 'Recolher o painel de conversa',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Siga @OpenDesignHQ no X',
  'entry.followThreadsLabel': 'Follow OpenDesign on Threads',
  'entry.youtubeLabel': 'OpenDesign on YouTube',
  'entry.followInstagramLabel': 'Siga @opendesign.ai no Instagram',
  'entry.followLinkedinLabel': 'Siga a OpenDesign no LinkedIn',
  'entry.followXiaohongshuLabel': 'Siga a OpenDesign no Xiaohongshu',
  'entry.resizeAria': 'Redimensionar barra lateral',
  'entry.loadingWorkspace': 'Carregando área de trabalho…',
  'entry.useEverywhereTitle': 'Usar em qualquer lugar',
  'entry.useEverywhereAria': 'Abrir o guia “Usar em qualquer lugar” (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.team': 'Team',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "Projetos pessoais",
  "workspaceSwitcher.allProjectsTooltip": "Projetos da equipe",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingFamilyCreator": "Creator",
  "entry.upgradeTitle": "Upgrade plan",
  "entry.upgradeCreditsExhaustedTitle": "Credits exhausted",
  "entry.upgradeAutoRechargeTitle": "Auto recharge",
  "entry.upgradeDialogAria": "Upgrade plan",
  "entry.upgradeSubtitle": "Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeCreditsExhaustedSubtitle": "You need more credits to continue. Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeAutoRechargeMemberSubtitle": "Enable a separate allowance for {member}. Saving this setting will not charge immediately; credits refill only when this member falls below the threshold.",
  "entry.upgradeAutoRechargeTeamSubtitle": "Enable an allowance for all teammates. Saving this setting will not charge immediately; team credits refill only when the balance falls below the threshold.",
  "entry.upgradeScopeLabel": "Scope",
  "entry.upgradeScopeMember": "{member} · single-member allowance",
  "entry.upgradeScopeTeam": "All teammates · shared allowance",
  "entry.upgradePaymentHint": "Uses the subscription payment method by default. You can manage it anytime.",
  "entry.upgradeManagePayment": "Manage payment method",
  "entry.upgradeMonthlyLimit": "Monthly limit",
  "entry.upgradeLimitCustom": "",
  "entry.upgradeLimitUnlimited": "∞ unlimited (no monthly cap)",
  "entry.upgradeBillingCycleAria": "Billing cycle",
  "entry.upgradeAnnual": "Annual",
  "entry.upgradeAnnualSave": "Save 20%",
  "entry.upgradeMonthly": "Monthly",
  "entry.upgradePlanPlus": "Personal Plus",
  "entry.upgradePlanPlusDesc": "Basic token allowance · SOTA models",
  "entry.upgradePlanPro": "Personal Pro",
  "entry.upgradePlanProDesc": "3x token allowance · top multimodal models",
  "entry.upgradePlanMax": "Personal Max",
  "entry.upgradePlanMaxDesc": "10x token allowance · top multimodal models",
  "entry.upgradePlanTeam": "Teams",
  "entry.upgradePlanTeamDesc": "Collaboration · shared assets · role permissions",
  "entry.upgradePriceUnitMonth": "/mo",
  "entry.upgradePriceUnitSeat": "/seat/mo",
  "entry.upgradeProrateAnnualPrefix": "Annual billing saves 20%; ",
  "entry.upgradeProrateMonthlyPrefix": "Monthly billing; ",
  "entry.upgradeProrateSuffix": "upgrades are prorated for the current billing cycle and take effect immediately.",
  "entry.upgradeBack": "Back",
  "entry.upgradeAutoRechargeSaved": "Auto recharge settings saved",
  "entry.upgradeConfirm": "Confirm payment and upgrade",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Upgrade",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "Cota",
  "entry.creditsUsage": "View usage",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Toggle theme",
  "entry.accountSwitchLanguage": "Switch language",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Get help on GitHub",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountAddAccount": "Add account",
  "entry.accountSignOut": "Sign out",
  "signOut.confirmTitle": "Sair",
  "signOut.confirmMessage": "Tem certeza de que deseja sair?",
  "signOut.confirmAction": "Sair",
  "entry.navRecents": "Início",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace para Times — conte o que sua equipe precisa',
  'entry.workspaceTeamsAria': 'Abrir a página do Workspace para Times',
  'entry.navExpand': 'Expandir barra lateral',
  'entry.navCollapse': 'Recolher barra lateral',
  'entry.navNewProject': 'Novo projeto',
  'entry.navHome': 'Início',
  'entry.navProjects': 'Projetos',
  'entry.navTasks': 'Automações',
  'entry.navPlugins': 'Plugins',
  'entry.navDesignSystems': 'Design systems',
  'entry.navBrands': 'Kit de marca',
  'entry.navIntegrations': 'Integrações',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'Projetos pessoais',
  'entry.navAllProjects': 'Projetos da equipe',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "OpenDesign Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'Your sign-in has expired. Sign in to continue using OpenDesign Cloud.',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'Local service connection interrupted. Recovering automatically…',
  "entry.cloudCalloutBody": "Entre para usar o OpenDesign Cloud e colaborar na nuvem",
  "entry.cloudCalloutDismissAria": "Dispensar o aviso do OpenDesign Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'OpenDesign updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'workspaceTabs.project': 'Projeto',
  'workspaceTabs.pluginDetails': 'Detalhes do plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'O que você vai projetar hoje com seu agente?',
  'homeHero.startWithTemplate': 'Começar com um modelo…',
  'homeHero.startBlankProject': 'começar um projeto em branco',
  'homeHero.templatePicker.label': 'Tipo de criação',
  'homeHero.templatePicker.searchPlaceholder': 'Buscar modelos',
  'homeHero.templatePicker.projectTypes': 'Tipos de projeto',
  'homeHero.templatesScrollHint': 'Role para cima para explorar mais modelos',
  'homeHero.templatesCollapse': 'Recolher modelos',
  'homeHero.subtitlePrefix': 'A alternativa ao Claude Design com código-fonte disponível.',
  'homeHero.placeholder': 'Descreva o que você quer gerar…',
  'homeHero.placeholderActive': 'Edite a consulta de exemplo ou escreva a sua própria…',
  'homeHero.carousel.hint': 'Anexe um arquivo, vincule seu design system ou descreva o que você quer criar',
  'homeHero.carousel.onePageBrief': 'Escrever um briefing de projeto de uma página',
  'homeHero.carousel.notesToDeck': 'Transformar minhas anotações em uma apresentação',
  'homeHero.carousel.signupFlow': 'Prototipar um fluxo de cadastro',
  'homeHero.carousel.improveBrief': 'Melhorar um briefing de projeto existente',
  'homeHero.carousel.loadingAnimation': 'Criar uma animação de carregamento',
  'homeHero.carousel.teamUpdateSlides': 'Criar slides para uma atualização da equipe',
  'homeHero.carousel.ordersDashboard': 'Prototipar um painel para acompanhar pedidos',
  'homeHero.carousel.productDetail': 'Diagramar uma página de detalhes do produto',
  'homeHero.carousel.caseStudy': 'Esboçar um estudo de caso',
  'homeHero.carousel.landingIntro': 'Criar uma breve introdução para uma landing page',
  'homeHero.carousel.pitchDeck': 'Criar um pitch deck para um novo produto',
  'homeHero.carousel.appIdea': 'Descrever uma ideia de app',
  'homeHero.carousel.landingLayout': 'Esboçar o layout de uma landing page',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'Adicionar contexto',
  'homeHero.addPlugin': 'Adicionar plugin',
  'homeHero.addConnectors': 'Adicionar conectores',
  'homeHero.addMcp': 'Adicionar servidor MCP',
  'homeHero.noPlugins': 'Nenhum plugin instalado',
  'homeHero.noMcp': 'Nenhum servidor MCP',
  'homeHero.noConnectors': 'Nenhum conector conectado',
  'homeHero.applying': 'Aplicando…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Remover plugin',
  'homeHero.removePluginAria': 'Remover plugin {title}',
  'homeHero.clearActivePlugin': 'Limpar plugin ativo',
  'homeHero.clearActiveSkill': 'Limpar skill ativa',
  'homeHero.contextItemsResolved': '{n} itens de contexto resolvidos',
  'homeHero.removeFile': 'Remover arquivo',
  'homeHero.contextSearchResults': 'Resultados da busca de contexto',
  'homeHero.contextSurfaces': 'Superfícies de contexto',
  'homeHero.loadingContext': 'Carregando contexto…',
  'homeHero.noResults': 'Nenhum resultado para "{query}".',
  'homeHero.searchPrompt': 'Busque arquivos, plugins, skills, servidores MCP e conectores.',
  'homeHero.parameters': '{n} parâmetros',
  'homeHero.details': 'Detalhes',
  'homeHero.toRun': 'para executar',
  'homeHero.forNewLine': 'para nova linha',
  'homeHero.run': 'Executar',
  'homeHero.typeSomethingToRun': 'Digite algo para executar',
  'homeHero.promptExamples': 'Exemplos',
  'homeHero.footer.designSystem': 'Estilo',
  'homeHero.footer.autoDesignSystem': 'Automático',
  'homeHero.footer.autoDesignSystemSummary': 'Seleciona automaticamente o design system e o estilo visual mais adequados para o prompt atual.',
  'homeHero.footer.ratio': 'Proporção',
  'homeHero.footer.duration': 'Duração',
  'homeHero.footer.resolution': 'Resolução',
  'homeHero.footer.speakerNotes': 'Notas',
  'homeHero.footer.noSpeakerNotes': 'Sem notas',
  'homeHero.footer.availableCount': '{n} disponíveis',
  'homeHero.footer.noMatches': 'Nenhuma correspondência',
  'homeHero.moreShortcuts': 'Mais',
  'homeHero.railAria': 'Escolha uma categoria de projeto ou atalho inicial',
  'homeHero.subTypeAria': 'Escolha um subtipo',
  'homeHero.subTypeMore': 'Mais',
  'homeHero.confirmReplaceTitle': 'Substituir o prompt atual?',
  'homeHero.confirmReplaceBody': 'Usar {title} substituirá o texto que está atualmente no campo de entrada.',
  'homeHero.confirmReplace': 'Substituir',
  'homeHero.chip.prototype': 'Protótipo',
  'homeHero.chip.webClone': 'Clone de site',
  'homeHero.chip.liveArtifact': 'Artefato ao vivo',
  'homeHero.chip.deck': 'Apresentação de slides',
  'homeHero.chip.image': 'Imagem',
  'homeHero.chip.video': 'Vídeo',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'Shaders, 3D e visuais GPU generativos',
  'homeHero.chip.worker': 'Visualizador Worker',
  'homeHero.chip.workerDesc': 'Sims fora da thread, partículas e data viz',
  'homeHero.chip.audio': 'Áudio',
  'homeHero.chip.createBrandKit': 'Criar kit de marca',
  'homeHero.chip.createPlugin': 'Criar plugin',
  'homeHero.chip.figma': 'Do Figma',
  'homeHero.chip.folder': 'De uma pasta',
  'homeHero.chip.template': 'De um modelo',
  'homeHero.chip.liveArtifactHint': 'Crie um artefato interativo em HTML/CSS/JS que você pode visualizar ao vivo.',
  'homeHero.chip.hyperframesHint': 'Crie animações baseadas em HTML: legendas, visuais reativos ao áudio, transições de cena.',
  'homeHero.chip.createBrandKitHint': 'Extraia um kit de marca de um site e aplique-o em qualquer chat.',
  'homeHero.chip.createPluginHint': 'Crie um plugin reutilizável do OpenDesign e adicione-o aos Meus plugins.',
  'homeHero.chip.figmaHint': 'Migre um frame do Figma para o design system ativo.',
  'homeHero.chip.folderHint': 'Importe uma pasta local existente e continue editando.',
  'homeHero.chip.templateHint': 'Comece a partir de um modelo incluído.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.triggerShort': 'Working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Pasta',
  'workingDirPicker.homeTitle': 'Salvo no armazenamento local — clique para escolher uma pasta',
  'workingDirPicker.processing': 'Processando…',
  'workingDirPicker.select': 'Armazenamento local',
  'workingDirPicker.clearAria': 'Limpar diretório de trabalho',
  'workingDirPicker.replaceFailed': 'Não foi possível substituir o diretório de trabalho',
  'workingDirPicker.unavailable': 'O seletor de pastas não está disponível nesta versão. Execute o app desktop para escolher uma pasta.',
  'workingDirPicker.openUnavailable': 'Abra este projeto no app desktop para mostrar a pasta.',
  'workingDirPicker.openFailed': 'Não foi possível mostrar esta pasta',
  'workingDirPicker.showInFileManager': 'Mostrar no gerenciador de arquivos',
  'workingDirPicker.replace': 'Escolher pasta…',
  'workingDirPicker.recent': 'Diretórios recentes',
  'workingDirPicker.defaultLabel': 'Armazenamento local',
  'handoff.toTarget': 'Transferir para {target}',
  'handoff.openInTarget': 'Abrir em {target}',
  'handoff.openAction': 'Abrir',
  'handoff.menuTitle': 'Abrir em qual editor?',
  'handoff.action': 'Transferir',
  'handoff.fallbackTitle': 'Nenhum editor encontrado no $PATH - abre em {target}',
  'handoff.chooseTargetAria': 'Escolher destino da transferência',
  'handoff.optionsAria': 'Opções de transferência',
  'handoff.editorSection': 'Abrir com editor',
  'handoff.cliSection': 'Copiar para CLI',
  'handoff.clickOpen': 'Clique para abrir',
  'handoff.framework': 'Framework de código',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript puro, HTML e CSS',
  'handoff.amrWebsite': 'Abrir site da OpenDesign Cloud',
  'handoff.copyPrompt': 'Copiar prompt',
  'handoff.copyPromptForTarget': 'Copiar prompt para {target}',
  'handoff.copied': 'Copiado',
  'handoff.projectPathUnavailable': 'O caminho do projeto ainda está carregando. Tente novamente em instantes.',
  'handoff.copyFailed': 'A gravação na área de transferência foi bloqueada. Tente novamente em instantes.',
  'handoff.promptIntro': 'Continuar a partir desta pasta de projeto local do OpenDesign:',
  'handoff.promptTarget': 'Destino',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Você está assumindo no {cli}. Por favor:',
  'handoff.promptReadFiles': 'Entre ou leia este diretório primeiro. Priorize DESIGN.md, README, HTML/CSS/JS existentes, assets e package.json, se houver.',
  'handoff.promptKeepDesign': 'Preserve o design visual, layout, interações e assets atuais. Não pare em um plano.',
  'handoff.promptProduceCode': 'Gere ou modifique código {framework} real e executável. Se o projeto já tiver uma stack mais clara, aponte o conflito e mantenha o resultado executável.',
  'handoff.promptVerify': 'Finalize me informando os comandos de execução, prévia e verificação.',
  'handoff.promptCommandHint': 'Para começar a partir do diretório do projeto, use:',
  'handoff.promptProject': 'Projeto',
  'handoff.promptProjectId': 'ID do projeto',
  'handoff.notInstalled': 'Não instalado',
  'handoff.notDetectedTitle': '{target} - não detectado no $PATH',
  'designSystemPicker.select': 'Escolher design system',
  'designSystemPicker.loading': 'Carregando design systems…',
  'designSystemPicker.searchPlaceholder': 'Pesquisar design systems (título / categoria / resumo)',
  'designSystemPicker.searchCompactPlaceholder': 'Pesquisar design systems',
  'designSystemPicker.noneTitle': 'Nenhum design system',
  'designSystemPicker.noneSummary': 'Deixe o modelo escolher livremente',
  'designSystemPicker.empty': 'Nenhum design system correspondente',
  'designSystemPicker.openPreview': 'Abrir prévia',
  'designSystemPicker.loadingPreview': 'Carregando pré-visualização…',
  'designSystemPicker.noPreview': 'Nenhuma página de prévia. Abra os Design Systems para ver a prévia completa.',
  'designSystemPicker.previewHint': 'Passe o cursor sobre um design system para visualizá-lo',
  'designSystemPicker.fullscreenAria': 'Prévia em tela cheia de {title}',
  'designSystemPicker.closeFullscreen': 'Fechar pré-visualização em tela cheia',
  'designSystemPicker.closeEsc': 'Fechar (Esc)',
  'designSystemPicker.previewFrameTitle': 'Pré-visualização de {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Pré-visualização de {title} em tela cheia',
  'recentProjects.title': 'Projetos recentes',
  'recentProjects.viewAll': 'Ver tudo',
  'recentProjects.empty': 'Nenhum projeto ainda — digite um prompt para começar um.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Limpar filtros',
  'pluginsHome.title': 'Comunidade',
  'pluginsHome.subtitle': 'Fluxos de trabalho do OpenDesign prontos para uso e incluídos neste runtime. Escolha um para carregar um prompt inicial ou navegue pelo registro para ver mais.',
  'pluginsHome.browseRegistry': 'Navegar no registro',
  'pluginsHome.count': '{filtered} de {total}',
  'pluginsHome.loadingCatalog': 'Carregando catálogo…',
  'pluginsHome.emptyCatalog': 'O catálogo está vazio. Os plugins integrados vêm com o OpenDesign e devem aparecer aqui automaticamente — tente reiniciar o daemon se isso persistir.',
  'pluginsHome.emptyFiltered': 'Nenhum plugin corresponde aos filtros atuais.',
  'pluginsHome.clearFilters': 'Limpar filtros',
  'pluginsHome.modeAria': 'Modo de plugin',
  'pluginsHome.featured': 'Salvo',
  'pluginsHome.totalInCatalog': '{n} no catálogo',
  'pluginsHome.categoryFilterAria': 'Filtro de categoria',
  'pluginsHome.subcategoryFilterAria': 'Filtro de subcategoria de {label}',
  'pluginsHome.allCategory': 'Todos: {label}',
  'pluginsHome.searchPlaceholder': 'Pesquisar plugins…',
  'pluginsHome.searchAria': 'Pesquisar plugins',
  'pluginsHome.clearSearch': 'Limpar pesquisa',
  'pluginsHome.sortAria': 'Ordem de classificação',
  'pluginsHome.sortHot': 'Em alta',
  'pluginsHome.sortNewest': 'Mais recentes',
  'pluginsHome.facet.import': 'Importar',
  'pluginsHome.facet.create': 'Criar',
  'pluginsHome.facet.export': 'Exportar',
  'pluginsHome.facet.share': 'Compartilhar',
  'pluginsHome.facet.deploy': 'Implantar',
  'pluginsHome.facet.refine': 'Refinar',
  'pluginsHome.facet.extend': 'Estender',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Código / pasta',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Captura de tela',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slides',
  'pluginsHome.facet.publicLink': 'Link público',
  'pluginsHome.facet.githubPr': 'PR do GitHub',
  'pluginsHome.facet.githubGist': 'Gist do GitHub',
  'pluginsHome.subfacet.business-dashboards': 'Dashboards',
  'pluginsHome.subfacet.app-prototypes': 'Apps',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Ferramentas dev',
  'pluginsHome.subfacet.docs-reports': 'Docs / relatórios',
  'pluginsHome.subfacet.brand-design': 'Marca / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / negócios',
  'pluginsHome.subfacet.course-training': 'Cursos / treinamento',
  'pluginsHome.subfacet.reports-briefings': 'Relatórios / briefings',
  'pluginsHome.subfacet.product-sales': 'Produto / vendas',
  'pluginsHome.subfacet.engineering-talks': 'Talks técnicas',
  'pluginsHome.subfacet.creative-decks': 'Decks criativos',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockups',
  'pluginsHome.subfacet.brand-visuals': 'Marca / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboards',
  'pluginsHome.subfacet.social-content': 'Social / conteúdo',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / retrato',
  'pluginsHome.subfacet.illustration-style': 'Ilustração / estilo',
  'pluginsHome.subfacet.motion-effects': 'Motion / efeitos',
  'pluginsHome.subfacet.social-short-form': 'Social / formato curto',
  'pluginsHome.subfacet.marketing-product': 'Marketing / produto',
  'pluginsHome.subfacet.data-explainers': 'Dados / explicativos',
  'pluginsHome.subfacet.cinematic-story': 'Cinemático / narrativa',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Navegue pelos fluxos de trabalho instalados, descubra entradas do registro, gerencie fontes e prepare plugins para distribuição em equipe.',
  'pluginsView.importPlugin': 'Importar plugin',
  'pluginsView.agentContext': 'Contexto do Agent',
  'pluginsView.summaryAria': 'Resumo do plugin',
  'pluginsView.areasAria': 'Áreas do plugin',
  'pluginsView.loading': 'Carregando plugins…',
  'pluginsView.tab.installed': 'Instalado',
  'pluginsView.tab.available': 'Disponível',
  'pluginsView.tab.sources': 'Fontes',
  'pluginsView.tab.team': 'Equipe',
  'pluginsView.tabHint.installed': 'Seus plugins',
  'pluginsView.tabHint.available': 'De fontes',
  'pluginsView.tabHint.sources': 'Catálogos',
  'pluginsView.tabHint.team': 'Empresarial',
  'pluginsView.installedTitle': 'Plugins instalados',
  'pluginsView.installedSubtitle': 'Plugins que você importou ou instalou a partir de fontes do marketplace.',
  'pluginsView.installedEmpty': 'Nenhum plugin de usuário instalado ainda. Use Criar / Importar ou instale uma entrada Disponível.',
  'pluginsView.availableTitle': 'Disponível em fontes',
  'pluginsView.availableSubtitle': 'Entradas de catálogo descobertas a partir dos marketplaces configurados.',
  'pluginsView.availableFiltersAria': 'Filtros de plugins disponíveis',
  'pluginsView.searchAvailableAria': 'Pesquisar plugins disponíveis',
  'pluginsView.searchAvailablePlaceholder': 'Pesquisar plugins disponíveis',
  'pluginsView.clearAvailableSearch': 'Limpar pesquisa de plugins disponíveis',
  'pluginsView.source': 'Origem',
  'pluginsView.availableEmptyInstalled': 'Nenhuma entrada disponível ainda. As entradas de catálogo instaladas são removidas de Disponíveis; desinstale uma para torná-la disponível novamente.',
  'pluginsView.availableEmptyFiltered': 'Nenhuma entrada disponível corresponde aos seus filtros.',
  'pluginsView.availableEmptyNoSources': 'Nenhuma entrada disponível ainda. Adicione uma origem na aba Origens.',
  'pluginsView.installing': 'Instalando…',
  'pluginsView.installWaiting': 'Aguardando…',
  'pluginsView.installQueuedHint': 'Outro plugin está sendo instalado. As instalações acontecem uma por vez — este botão ficará disponível quando ela terminar.',
  'pluginsView.install': 'Instalar',
  'pluginsView.sourcesTitle': 'Origens de registro',
  'pluginsView.sourcesSubtitle': 'Catálogos de marketplace que alimentam as entradas de plugins Disponíveis.',
  'pluginsView.sourceUrl': 'URL da origem',
  'pluginsView.defaultTrust': 'Confiança padrão',
  'pluginsView.trust.restricted': 'Restrito',
  'pluginsView.trust.trusted': 'Confiável',
  'pluginsView.trust.official': 'Oficial',
  'pluginsView.adding': 'Adicionando…',
  'pluginsView.addSource': 'Adicionar origem',
  'pluginsView.sourcesEmpty': 'Nenhuma origem de registro configurada ainda.',
  'pluginsView.pluginsCount': '{n} plugins',
  'pluginsView.catalogVersion': 'catálogo v{version}',
  'pluginsView.trustFor': 'Confiança para {name}',
  'pluginsView.refreshing': 'Atualizando…',
  'pluginsView.removing': 'Removendo…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to OpenDesign.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "OpenDesign official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. OpenDesign will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from OpenDesign official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Sincronizar com a equipe",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "A versão mais recente de \"{title}\" foi sincronizada com a equipe.",
  "pluginsView.syncUnavailable": "Ainda não foi possível sincronizar \"{title}\". Confirme se você está em um workspace de equipe.",
  "pluginsView.syncFailed": "Falha ao sincronizar \"{title}\" com a equipe. Tente novamente mais tarde.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Marketplaces privados de equipe',
  'pluginsView.teamBody': 'Esta área é reservada para catálogos corporativos e de equipe, políticas de confiança privadas e controles compartilhados do ciclo de vida de plugins.',
  'pluginCard.details': 'Detalhes',
  'pluginCard.use': 'Usar',
  'pluginCard.useWithQuery': 'Usar com consulta',
  'pluginCard.applying': 'Aplicando…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remixando…',
  'pluginCard.duplicateFailed': 'Nao foi possivel remixar este template.',
  'pluginCard.saved': 'Salvo',
  'pluginCard.publish': 'Publicar',
  'pluginCard.contribute': 'Contribuir',
  'pluginCard.starting': 'Iniciando…',
  'pluginCard.detailsAria': 'Ver detalhes de {title}',
  'pluginCard.chooseUseAria': 'Escolha como usar {title}',
  'pluginCard.useOptionsAria': 'Opções de uso para {title}',
  'pluginCard.duplicateAria': 'Remixar {title} como um novo projeto',
  'pluginCard.saveAria': 'Salvar {title}',
  'pluginCard.savedAria': '{title} está salvo',
  'pluginCard.shareAria': 'Compartilhar {title}',
  'pluginCard.publishAria': 'Publicar {title} como um repositório do GitHub',
  'pluginCard.publishTitle': 'Publicar plugin como um repositório do GitHub',
  'pluginCard.contributeAria': 'Contribuir com {title} para o OpenDesign',
  'pluginCard.contributeTitle': 'Contribuir com plugin para o OpenDesign por meio de um pull request',
  'skillPluginCandidate.createForMe': 'Criar plugin/modelo',
  'skillPluginCandidate.contributeToMain': 'Contribuir para o open-design',
  'skillPluginCandidate.repoDescription': 'Este repositório parece que poderia funcionar como um plugin.',
  'integrations.kicker': 'Integração',
  'integrations.lede': 'Conecte sistemas externos, traga ferramentas MCP para o loop do seu agent e use o OpenDesign a partir de outras IDEs, scripts e automações.',
  'integrations.agentReady': 'Pronto para agent',
  'integrations.areasAria': 'Áreas de integração',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'Ferramentas externas',
  'integrations.tabHint.connectors': 'Contas e APIs',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integrações de Skills',
  'integrations.skillsBody': 'O gerenciamento de integração em nível de Skill está sendo migrado de outro branch. Esta aba está reservada para que MCP, Connectors e a futura configuração de Skills fiquem na mesma rota de Integração.',
  'mcpClient.title': 'Servidores MCP externos',
  'mcpClient.subtitle': 'Ferramentas de terceiros para o seu agent de programação.',
  'mcpClient.addServer': 'Adicionar servidor',
  'mcpClient.emptyTitle': 'Nenhum servidor MCP configurado.',
  'mcpClient.emptyBody': 'Clique em "Adicionar servidor" para começar — escolha um modelo (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) ou configure um servidor stdio / HTTP personalizado.',
  'mcpClient.saveChanges': 'Salvar alterações',
  'mcpClient.storedAt': 'Armazenado em',
  'mcpClient.daemonError': 'Não foi possível acessar o daemon local. Verifique se o OpenDesign está em execução e reabra este painel.',
  'mcpClient.saveFailed': 'Falha ao salvar. Verifique se o daemon está em execução e tente novamente.',
  'useEverywhere.modalAria': 'Use o OpenDesign em qualquer lugar',
  'useEverywhere.modalTitle': 'Use o OpenDesign em qualquer lugar',
  'useEverywhere.modalSubtitle': 'Use o OpenDesign em qualquer IDE, agent ou script — CLI, HTTP, MCP e Skills. Use “Copiar guia para um agent” e cole no Claude Code, Codex, Cursor, openclaw ou hermes para configurar tudo.',
  'useEverywhere.closeAria': 'Fechar uso em todos os lugares',
  'useEverywhere.closeTitle': 'Fechar (Esc)',
  'useEverywhere.tabsAria': 'Superfícies de integração',
  'useEverywhere.footStrong': 'Transferência com um clique.',
  'useEverywhere.footBody': 'Copia um guia estruturado em markdown sobre o qual seu agent pode agir imediatamente — instalar, verificar e usar.',
  'useEverywhere.configureMcp': 'Configurar servidor MCP',
  'useEverywhere.copyGuide': 'Copiar guia para um agent',
  'useEverywhere.copy': 'Copiar',
  'useEverywhere.copied': 'Copiado',
  'useEverywhere.copyFailed': 'Falha ao copiar',
  'useEverywhere.copySnippetAria': 'Copiar trecho: {label}',
  'useEverywhere.section.overview.tab': 'Visão geral',
  'useEverywhere.section.overview.heading': 'O OpenDesign funciona onde quer que seu agent funcione',
  'useEverywhere.section.overview.intro': 'O OpenDesign é mais do que uma janela — é um daemon local privilegiado (`od`) mais um registro de Skills + Design Systems + Atoms. Quando ele estiver rodando na sua máquina, qualquer code agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, seu próprio script) pode acionar gerações, inspecionar projetos e produzir artefatos de design por meio de quatro superfícies intercambiáveis.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` para scripts headless, CI e automação de shell.',
  'useEverywhere.section.overview.bullet2': 'Servidor MCP — conecta o OpenDesign como um servidor Model Context Protocol para que qualquer agent compatível com MCP possa listar skills, executar cenários e ler artefatos.',
  'useEverywhere.section.overview.bullet3': 'API HTTP — endpoints REST + SSE em `http://127.0.0.1:7456/api/*`; a mesma superfície que a UI web usa.',
  'useEverywhere.section.overview.bullet4': 'Skills — pacotes `SKILL.md` plug-and-play (compatíveis com Claude) que qualquer agent já no seu PATH pode invocar sem o OpenDesign.',
  'useEverywhere.section.overview.bullet5': 'Artefatos padrão — inicialize projetos HTML reais a partir de Skills, plugins padrão integrados e exemplos de plugins da comunidade antes de o daemon iniciar.',
  'useEverywhere.section.overview.snippet1': 'Inicie o daemon (e a UI web) localmente',
  'useEverywhere.section.overview.snippet2': 'Confirme que está acessível',
  'useEverywhere.section.overview.snippet3': 'Ingira artefatos padrão antes do boot',
  'useEverywhere.section.overview.footer': 'Por padrão, o daemon escreve em `./.od/` (local do projeto). Defina `OD_DATA_DIR=~/.open-design` para compartilhar dados entre projetos.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Controle o OpenDesign a partir de qualquer shell',
  'useEverywhere.section.cli.intro': 'O bin `od` acompanha o daemon e é o mesmo binário usado pelo Claude Code / Codex quando executam uma geração. A maioria dos subcomandos são clientes leves que fazem POST para o daemon local, então funcionam da mesma forma, seja você o tenha iniciado via `pnpm tools-dev` ou como um app empacotado.',
  'useEverywhere.section.cli.bullet1': '`od` (sem argumentos) — inicia o daemon e abre a UI web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — produz bytes de imagem / vídeo / áudio por meio do protocolo de mídia unificado.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — inicia a execução de um projeto a partir de um prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — instala e aplica plugins da comunidade.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — inspeciona o que está disponível localmente.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — verifica a integridade do daemon e detecta CLIs de agent no seu PATH.',
  'useEverywhere.section.cli.snippet1': 'Gerar uma imagem (delega ao provedor de mídia configurado)',
  'useEverywhere.section.cli.snippet2': 'Execute um plugin de cenário em modo headless e transmita eventos como linhas JSON',
  'useEverywhere.section.cli.snippet3': 'Liste skills e design systems disponíveis localmente',
  'useEverywhere.section.cli.snippet4': 'Verifique os artefatos seeded pela CLI',
  'useEverywhere.section.cli.snippet5': 'Verificar ambiente + agents detectados (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Todos os subcomandos aceitam `--daemon-url http://127.0.0.1:<port>` para direcionar a um daemon específico em execução — útil ao rodar uma segunda instância em sandbox para testes.',
  'useEverywhere.section.mcp.tab': 'Servidor MCP',
  'useEverywhere.section.mcp.heading': 'Exponha o OpenDesign como um servidor MCP para qualquer agent de codificação',
  'useEverywhere.section.mcp.intro': 'O OpenDesign vem com um servidor Model Context Protocol (`od mcp`) que permite que qualquer cliente compatível com MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — descubra as ferramentas do OpenDesign (listar skills, renderizar pré-visualizações, gerar mídia, executar plugins) sem usar o shell manualmente. O daemon publica um trecho de instalação pronto para colar via `GET /api/mcp/install-info` para cada cliente principal.',
  'useEverywhere.section.mcp.bullet1': 'Transporte stdio — sem porta extra, o cliente executa `od mcp` diretamente.',
  'useEverywhere.section.mcp.bullet2': 'Descobre automaticamente a URL do daemon ativo via o socket de status IPC local quando iniciado como sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Recorre a `--daemon-url http://127.0.0.1:<port>` em instalações simples, para que o processo MCP sempre encontre um daemon em execução.',
  'useEverywhere.section.mcp.bullet4': 'Fixa `OD_DATA_DIR` para que o processo MCP gerado escreva no mesmo lugar que o daemon já usa (evita EPERM em bundles de app empacotados no macOS).',
  'useEverywhere.section.mcp.snippet1': 'Configuração genérica de cliente MCP (funciona no Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Ou: peça ao daemon o trecho personalizado para sua instalação',
  'useEverywhere.section.mcp.snippet3': 'Variante MCP de artefatos ao vivo (ler e atualizar dashboards)',
  'useEverywhere.section.mcp.footer': 'No app OpenDesign, abra Configurações → Integrações para copiar um comando de instalação específico do cliente (Cursor, Claude Code, Antigravity, VS Code) em vez de editar JSON manualmente.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'A mesma superfície REST + SSE que a UI web usa',
  'useEverywhere.section.http.intro': 'O daemon local serve uma API HTTP em `http://127.0.0.1:7456` (porta configurável). Todo endpoint que a UI web chama também está disponível para seus scripts. Endpoints de streaming (turnos de chat, execuções de projeto) emitem Server-Sent Events com os tipos de contrato em `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — disponibilidade do daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` e `GET /api/design-systems` — registros disponíveis.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` e `POST /api/projects` — lista e cria projetos (POST retorna o projeto + a primeira conversa).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — stream SSE de eventos do agent para uma conversa.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — vincula um plugin instalado e obtém sua consulta de exemplo renderizada + entradas.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — CLIs de code agent detectadas no seu PATH.',
  'useEverywhere.section.http.snippet1': 'Liste as skills instaladas (o agent as usará como templates)',
  'useEverywhere.section.http.snippet2': 'Crie um projeto a partir de um prompt (fluxo completo no servidor)',
  'useEverywhere.section.http.snippet3': 'Transmita um turno de chat (SSE — cada linha é compatível com JSON-Lines)',
  'useEverywhere.section.http.footer': 'Tipos TypeScript puros para cada requisição/resposta ficam em `@open-design/contracts` — importe-os no seu script para autocompletar completo sem configurar um gerador.',
  'useEverywhere.section.skills.tab': 'Skills e headless',
  'useEverywhere.section.skills.heading': 'Skills plug-and-play para qualquer agent — mesmo sem o OpenDesign em execução',
  'useEverywhere.section.skills.intro': 'Uma Skill é um diretório com um `SKILL.md` compatível com Claude (front-matter YAML + corpo). O OpenDesign estende o formato com o namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, …) para que o mesmo artefato possa ser usado tanto dentro do OpenDesign quanto por um agent comum como Claude Code, Codex, openclaw ou hermes. A descoberta segue uma cadeia de precedência para que os projetos possam sobrescrever suas próprias skills.',
  'useEverywhere.section.skills.bullet1': 'Descoberta: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (o projeto prevalece).',
  'useEverywhere.section.skills.bullet2': 'Crie um symlink de uma skill em múltiplos projetos para compartilhá-la sem copiar.',
  'useEverywhere.section.skills.bullet3': 'Cada skill pode declarar connectors, atoms, requisitos de design system e um exemplo de saída `preview` para a galeria.',
  'useEverywhere.section.skills.bullet4': 'Headless: um agent com `od` no seu PATH pode chamar `od skills list` e depois executar qualquer skill; o daemon é opcional para fluxos somente leitura.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` exercita o mesmo formato de artefato com exemplos de plugins padrão e exemplos de plugins da comunidade, e depois armazena os projetos `index.html` resultantes como dados de teste reutilizáveis.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md mínimo (front matter compatível com Claude + extras do OpenDesign)',
  'useEverywhere.section.skills.snippet2': 'Crie um symlink de uma skill compartilhada em um projeto (estilo cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: liste as skills que o daemon vê agora',
  'useEverywhere.section.skills.snippet4': 'Bundle de fixtures de artefatos headless',
  'useEverywhere.section.skills.footer': 'Spec: `docs/skills-protocol.md` e `docs/agent-adapters.md` cobrem toda a superfície de adapters (Claude Code, Codex, Cursor, agents compatíveis com MCP, fallback de API BYOK) e as estratégias de injeção de skill por adapter.',
  'tasks.kicker': 'Workspace de automação',
  'tasks.comingSoon': 'Em breve',
  'tasks.lede': 'As automações transformam prompts em trabalho durável: o Orbit as executa, as routines as mantêm, os schedules decidem quando elas disparam e os artefatos ao vivo mostram o que mudou.',
  'tasks.newAutomation': 'Nova automação',
  'tasks.previewNote': 'Apenas superfície de pré-visualização. As configurações do Orbit já estão disponíveis hoje; routines, schedules e a integração de artefatos ao vivo chegarão à medida que os branches do backend forem mesclados.',
  'tasks.primitivesAria': 'Primitivas de automação',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Um runtime persistente para trabalho de agent de longa duração ou recorrente.',
  'tasks.primitive.orbit.enabled': 'Resumo diário ativado',
  'tasks.primitive.orbit.manualOnly': 'Apenas manual',
  'tasks.primitive.routines.title': 'Rotinas',
  'tasks.primitive.routines.body': 'Definições de tarefas duráveis que sobrevivem após o fim de um único chat.',
  'tasks.primitive.routines.meta': 'Shell do produto pronto',
  'tasks.primitive.schedules.title': 'Agendamentos',
  'tasks.primitive.schedules.body': 'Gatilhos de tempo ou evento que decidem quando uma routine deve ser executada.',
  'tasks.primitive.schedules.meta': 'Branch pendente',
  'tasks.primitive.liveArtifacts.title': 'Artefatos ao vivo',
  'tasks.primitive.liveArtifacts.body': 'Relatórios e notas que continuam sendo atualizados enquanto um agent trabalha.',
  'tasks.primitive.liveArtifacts.meta': 'Pré-visualizar modelo',
  'tasks.listAria': 'Lista de automações',
  'tasks.routinesAndRuns': '{n} rotinas e execuções',
  'tasks.filtersAria': 'Filtros de automação',
  'tasks.filter.scheduled': 'Agendado',
  'tasks.filter.running': 'Em execução',
  'tasks.filter.done': 'Concluído',
  'tasks.configurationAria': 'Configuração da automação',
  'tasks.slot.trigger': 'Gatilho',
  'tasks.slot.pattern': 'Padrão',
  'tasks.slot.runtime': 'Tempo de execução',
  'tasks.slot.output': 'Saída',
  'tasks.liveArtifact': 'Artefato ao vivo',
  'tasks.viewProgress': 'Ver progresso',
  'tasks.pause': 'Pausar',
  'tasks.runNow': 'Executar agora',
  'tasks.openArtifact': 'Abrir artefato',
  'tasks.status.dailyAt': 'Diário · {time}',
  'tasks.status.pausedManual': 'Pausado · apenas manual',
  'tasks.sample.orbit.title': 'Resumo do conector Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'O resumo do conector está agendado',
  'tasks.sample.orbit.metaDisabled': 'Abra as configurações do Orbit para ativar',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefato ao vivo',
  'tasks.sample.orbit.previewDisabled': 'Nenhuma execução agendada',
  'tasks.sample.orbit.triggerEnabled': 'Agendamento · diariamente às {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manual · executar sob demanda',
  'tasks.sample.orbit.pattern': 'Rotina · resumo de conectores',
  'tasks.sample.orbit.runtime': 'Orbit · agendado pelo daemon',
  'tasks.sample.orbit.output': 'Artefato ao vivo · relatório atualizável',
  'tasks.sample.orbit.artifactMetaEnabled': 'Atualiza após cada execução',
  'tasks.sample.orbit.artifactMetaDisabled': 'Aguardando agendamento',
  'tasks.sample.orbit.body1': '# Resumo de atividades do Orbit Daily',
  'tasks.sample.orbit.body2': 'Conectores verificados · sucessos, ignorados e falhas',
  'tasks.sample.orbit.body3': 'Os destaques se tornam um artefato ao vivo atualizável.',
  'tasks.sample.mcp.title': 'Pesquisa de alternativas ao MCP',
  'tasks.sample.mcp.status': 'Em execução na orbit · 2h 14min',
  'tasks.sample.mcp.meta': '14 / 30 fontes processadas',
  'tasks.sample.mcp.preview': 'research_notes.md · ao vivo',
  'tasks.sample.mcp.trigger': 'Manual · execução única',
  'tasks.sample.mcp.pattern': 'Prompt de pesquisa aprofundada',
  'tasks.sample.mcp.runtime': 'Remoto · persistente',
  'tasks.sample.mcp.output': 'Relatório ao vivo · atualização automática',
  'tasks.sample.mcp.artifactMeta': 'Atualizado há 12s',
  'tasks.sample.mcp.body1': '# Alternativas ao MCP - conclusões preliminares',
  'tasks.sample.mcp.body2': '14 fontes revisadas · 3 candidatos pré-selecionados',
  'tasks.sample.mcp.body3': '## Lista de finalistas',
  'tasks.sample.mcp.body4': '- Esquemas de chamada de ferramentas via JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protocolos de agent baseados em gRPC...',
  'tasks.sample.weekly.title': 'Resumo semanal da equipe',
  'tasks.sample.weekly.status': 'Próxima: seg 9:00',
  'tasks.sample.weekly.meta': 'Atualiza o documento semanal da equipe',
  'tasks.sample.weekly.preview': 'team_weekly.md · próximo artefato',
  'tasks.sample.weekly.trigger': 'Agendamento · semanal',
  'tasks.sample.weekly.pattern': 'Rotina · resumo da equipe',
  'tasks.sample.weekly.runtime': 'Remoto · recorrente',
  'tasks.sample.weekly.output': 'Artefato ao vivo · markdown',
  'tasks.sample.weekly.artifactMeta': 'Última atualização há 4d',
  'tasks.sample.weekly.body1': '# Semanal da equipe',
  'tasks.sample.weekly.body2': '## Em andamento',
  'tasks.sample.weekly.body3': '- Rodada de integração do sistema de design',
  'tasks.sample.weekly.body4': '- Revisão de qualidade dos conectores',
  'tasks.sample.weekly.body5': '## Riscos',
  'tasks.sample.pr.title': 'Lembrete de revisão de PR',
  'tasks.sample.pr.status': 'Em novo PR · disparado há 23min',
  'tasks.sample.pr.meta': 'Envia DM no Slack',
  'tasks.sample.pr.preview': 'A última entrega foi bem-sucedida',
  'tasks.sample.pr.trigger': 'Evento · novo PR',
  'tasks.sample.pr.pattern': 'Rotina · notificação',
  'tasks.sample.pr.runtime': 'Local · execução rápida',
  'tasks.sample.pr.output': 'Mensagem · DM no Slack',
  'tasks.sample.pr.artifactMeta': 'Disparado pela última vez há 23m',
  'tasks.sample.pr.body1': 'PR #184 aberto para revisão',
  'tasks.sample.pr.body2': 'Revisores correspondentes: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Entrega: DM no Slack enviada',
  'tasks.sample.meeting.title': 'Preparação pré-reunião',
  'tasks.sample.meeting.status': 'Amanhã · 10:00',
  'tasks.sample.meeting.meta': 'Execução única · envia resumo',
  'tasks.sample.meeting.preview': 'meeting_brief.md · na fila',
  'tasks.sample.meeting.trigger': 'Agendamento · execução única',
  'tasks.sample.meeting.pattern': 'Prompt de briefing',
  'tasks.sample.meeting.runtime': 'Remoto · limitado',
  'tasks.sample.meeting.output': 'Artefato + mensagem',
  'tasks.sample.meeting.artifactMeta': 'Na fila para geração',
  'tasks.sample.meeting.body1': '# Briefing da reunião',
  'tasks.sample.meeting.body2': 'Fonte da pauta: evento do calendário + documentos vinculados',
  'tasks.sample.meeting.body3': 'A saída incluirá decisões, bloqueios e perguntas.',
  'tasks.sample.candidate.title': 'Acompanhamento de candidatos',
  'tasks.sample.candidate.status': 'Falhou · requer atenção',
  'tasks.sample.candidate.meta': 'Autenticação expirada',
  'tasks.sample.candidate.preview': 'Reconecte o Greenhouse para retomar',
  'tasks.sample.candidate.trigger': 'Agendamento · diário',
  'tasks.sample.candidate.pattern': 'Rotina · sincronização de candidatos',
  'tasks.sample.candidate.runtime': 'Remoto · recorrente',
  'tasks.sample.candidate.output': 'Artefato ao vivo · tabela',
  'tasks.sample.candidate.artifactMeta': 'Pausado até a autenticação ser restaurada',
  'tasks.sample.candidate.body1': '# Pipeline de candidatos',
  'tasks.sample.candidate.body2': 'Última sincronização bem-sucedida: 2d atrás',
  'tasks.sample.candidate.body3': 'Ação necessária: reconecte a conta de origem.',
  'routines.title': 'Automações',
  'routines.subtitle': 'Automações agendadas que rodam sem supervisão.',
  'routines.newAutomation': 'Nova automação',
  'routines.loading': 'Carregando…',
  'routines.empty': 'Nenhuma automação ainda.',
  'routines.emptyHint': 'Clique em Nova automação para agendar uma execução de Agent sem supervisão.',
  'routines.runHistoryLoading': 'Carregando execuções…',
  'routines.runHistoryEmpty': 'Nenhuma execução ainda.',
  'routines.fieldName': 'Nome',
  'routines.fieldNamePlaceholder': 'Briefing matinal',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Buscar a atividade de ontem no GitHub + Linear e resumir o que mudou.',
  'routines.fieldSchedule': 'Agendamento',
  'routines.fieldMinute': 'Minuto de cada hora',
  'routines.fieldTime': 'Horário',
  'routines.fieldTimezone': 'Fuso horário',
  'routines.fieldsetProject': 'Projeto',
  'routines.kind.hourly': 'De hora em hora',
  'routines.kind.daily': 'Diariamente',
  'routines.kind.weekdays': 'Dias úteis',
  'routines.kind.weekly': 'Semanalmente',
  'routines.weekday.short.0': 'Dom',
  'routines.weekday.short.1': 'Seg',
  'routines.weekday.short.2': 'Ter',
  'routines.weekday.short.3': 'Qua',
  'routines.weekday.short.4': 'Qui',
  'routines.weekday.short.5': 'Sex',
  'routines.weekday.short.6': 'Sáb',
  'routines.weekday.long.0': 'Domingo',
  'routines.weekday.long.1': 'Segunda-feira',
  'routines.weekday.long.2': 'Terça-feira',
  'routines.weekday.long.3': 'Quarta-feira',
  'routines.weekday.long.4': 'Quinta-feira',
  'routines.weekday.long.5': 'Sexta-feira',
  'routines.weekday.long.6': 'Sábado',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Roda a cada hora aos :{minute}',
  'routines.describe.daily': 'Roda diariamente às {time} {tz}',
  'routines.describe.weekdays': 'Executa de seg. a sex. às {time} {tz}',
  'routines.describe.weekly': 'Roda toda {day} às {time} {tz}',
  'routines.modeCreate': 'Criar um novo projeto a cada execução',
  'routines.modeCreateHint': 'Um workspace novo e isolado a cada disparo.',
  'routines.modeReuse': 'Reutilizar um projeto existente',
  'routines.modeReuseHint': 'Cada execução fica como uma nova conversa dentro do projeto.',
  'routines.pickProject': '— Escolha um projeto —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ novo projeto a cada execução',
  'routines.tagPaused': 'pausado',
  'routines.metaNext': 'próxima: {when}',
  'routines.metaLast': 'última:',
  'routines.triggerManual': 'manual',
  'routines.triggerScheduled': 'agendada',
  'routines.openProject': 'Abrir projeto',
  'routines.openProjectTitle': 'Abra o projeto em que esta execução gravou',
  'routines.runNow': 'Executar agora',
  'routines.edit': 'Editar',
  'routines.pause': 'Pausar',
  'routines.resume': 'Retomar',
  'routines.history': 'Histórico',
  'routines.hideHistory': 'Ocultar histórico',
  'routines.delete': 'Excluir',
  'routines.deleteTitle': 'Excluir esta automação',
  'routines.cancel': 'Cancelar',
  'routines.save': 'Salvar',
  'routines.saving': 'Salvando…',
  'routines.create': 'Criar',
  'routines.creating': 'Criando…',
  'routines.status.queued': 'na fila',
  'routines.status.running': 'em execução',
  'routines.status.succeeded': 'concluído',
  'routines.status.failed': 'falhou',
  'routines.status.canceled': 'cancelado',
  'routines.confirmDelete': 'Excluir esta automação? As execuções anteriores e seus projetos serão mantidos.',
  'routines.errorPickProject': 'Escolha um projeto para reutilizar ou alterne para “Criar novo a cada execução”',
  'routines.errorAgentEmptyOutput': 'O agent foi concluído sem produzir nenhuma saída. O modelo ou provedor pode ter retornado uma resposta vazia — verifique os logs do agent em busca de erros upstream.',
  'entry.helpAria': 'Ajuda',
  'entry.helpMenuAria': 'Menu de ajuda',
  'entry.helpGetHelp': 'Obter ajuda no GitHub',
  'entry.helpSubmitFeature': 'Sugerir um recurso',
  'entry.helpWhatsNew': 'Novidades',
  'entry.helpDownloadDesktop': 'Baixar app para desktop',
  'entry.githubStarLabel': 'Favoritar',
  'entry.githubStarTitle': 'Clique para nos dar uma estrela no GitHub',
  'entry.githubStarAria': 'Dar uma estrela ao OpenDesign no GitHub',
  'entry.tabImageTemplates': 'Modelos de imagem',
  'entry.tabVideoTemplates': 'Modelos de vídeo',
  'promptTemplates.searchPlaceholder': 'Buscar templates…',
  'promptTemplates.countLabel': '{n} resultados',
  'promptTemplates.emptyImage': 'Nenhum template de prompt de imagem instalado.',
  'promptTemplates.emptyVideo': 'Nenhum template de prompt de vídeo instalado.',
  'promptTemplates.emptyNoMatch': 'Nenhum template corresponde à busca.',
  'promptTemplates.attributionFooter': 'Adaptado de bibliotecas públicas de prompts. Cada card aponta para o autor original.',
  'promptTemplates.openPreviewTitle': 'Abrir prompt e prévia',
  'promptTemplates.sourcePrefix': 'Fonte:',
  'promptTemplates.fetchError': 'Não foi possível carregar o corpo deste template.',
  'promptTemplates.promptLabel': 'Corpo do prompt',
  'promptTemplates.copyPrompt': 'Copiar prompt',
  'promptTemplates.copyDone': 'Copiado!',
  'promptTemplates.modelHint': 'Modelo sugerido: {model}',
  'promptTemplates.openSource': 'Ver original',
  'promptTemplates.openFullscreen': 'Abrir prévia em tela cheia',
  'promptTemplates.closeFullscreen': 'Fechar prévia em tela cheia',
  'promptTemplates.allSources': 'Todas as fontes',
  'promptTemplates.sourceFilterAria': 'Filtrar por fonte',
  'promptTemplates.retry': 'Tentar novamente',
  'connectors.title': 'Conectores',
  'connectors.subtitle': 'Fontes locais e futuras que podem alimentar artefatos live.',
  'connectors.account': 'Conta',
  'connectors.noAccount': 'Não conectado',
  'connectors.tools': 'Ferramentas',
  'connectors.connect': 'Conectar',
  'connectors.disconnect': 'Desconectar',
  'connectors.authorizationPending': 'Aguardando autorização...',
  'connectors.authorizationPendingHint': 'Conclua a autorização na janela aberta.',
  'connectors.cancelAuthorization': 'Cancelar',
  'connectors.configure': 'Configurar',
  'connectors.unavailable': 'Indisponível',
  'connectors.phaseStubTitle': 'As APIs de conectores chegam na Phase 3; esta é uma superfície de prévia.',
  'connectors.statusAvailable': 'Disponível',
  'connectors.statusConnected': 'Conectado',
  'connectors.statusError': 'Erro',
  'connectors.statusDisabled': 'Desativado',
  'connectors.gateTitle': 'Adicione sua chave de API do Composio para continuar',
  'connectors.gateBody': 'Cole sua chave acima e clique em Salvar chave para carregar as integrações disponíveis.',
  'connectors.aboutLabel': 'Sobre',
  'connectors.detailsLabel': 'Detalhes',
  'connectors.statusLabel': 'Status',
  'connectors.category.aiAgents': 'Agentes de IA',
  'connectors.category.aiInfrastructure': 'Infraestrutura de IA',
  'connectors.category.accounting': 'Contabilidade',
  'connectors.category.admin': 'Administração',
  'connectors.category.advertising': 'Publicidade',
  'connectors.category.analytics': 'Análises',
  'connectors.category.automation': 'Automação',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendário',
  'connectors.category.commerce': 'Comércio',
  'connectors.category.communication': 'Comunicação',
  'connectors.category.contacts': 'Contatos',
  'connectors.category.dataPlatform': 'Plataforma de dados',
  'connectors.category.database': 'Banco de dados',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Ferramentas de desenvolvedor',
  'connectors.category.documentation': 'Documentação',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Educação',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Eventos',
  'connectors.category.fieldService': 'Serviço de campo',
  'connectors.category.finance': 'Finanças',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formulários',
  'connectors.category.gaming': 'Jogos',
  'connectors.category.hr': 'RH',
  'connectors.category.hospitality': 'Hospitalidade',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integração',
  'connectors.category.localization': 'Localização',
  'connectors.category.logistics': 'Logística',
  'connectors.category.maps': 'Mapas',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Mídia',
  'connectors.category.meetings': 'Reuniões',
  'connectors.category.nonprofit': 'Sem fins lucrativos',
  'connectors.category.observability': 'Observabilidade',
  'connectors.category.payments': 'Pagamentos',
  'connectors.category.personal': 'Pessoal',
  'connectors.category.presentations': 'Apresentações',
  'connectors.category.procurement': 'Compras',
  'connectors.category.product': 'Produto',
  'connectors.category.productivity': 'Produtividade',
  'connectors.category.projectManagement': 'Gerenciamento de projetos',
  'connectors.category.recruiting': 'Recrutamento',
  'connectors.category.research': 'Pesquisa',
  'connectors.category.salesIntelligence': 'Inteligência de vendas',
  'connectors.category.scheduling': 'Agendamento',
  'connectors.category.search': 'Busca',
  'connectors.category.security': 'Segurança',
  'connectors.category.signing': 'Assinatura',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Planilhas',
  'connectors.category.storage': 'Armazenamento',
  'connectors.category.support': 'Suporte',
  'connectors.category.surveys': 'Pesquisas',
  'connectors.category.tasks': 'Tarefas',
  'connectors.category.timeTracking': 'Controle de tempo',
  'connectors.category.video': 'Vídeo',
  'connectors.category.whiteboard': 'Quadro branco',
  'connectors.categoryLabel': 'Categoria',
  'connectors.providerLabel': 'Provedor',
  'connectors.toolsSection': 'Ferramentas',
  'connectors.toolsLoading': 'Carregando ferramentas…',
  'connectors.noToolsAvailable': 'Nenhuma ferramenta disponível ainda. Conecte-se para descobrir o que esta integração oferece.',
  'connectors.toolDetailsUnavailable': 'Os detalhes das ferramentas estão indisponíveis, mas este conector informa {n} ferramentas.',
  'connectors.loadMoreTools': 'Carregar mais ferramentas',
  'connectors.openDetailsAria': 'Abrir detalhes de {name}',
  'connectors.toolsBadgeNone': 'Sem ferramentas',
  'connectors.toolsBadgeOne': '{n} ferramenta',
  'connectors.toolsBadgeMany': '{n} ferramentas',
  'connectors.searchPlaceholder': 'Buscar conectores…',
  'connectors.searchAriaLabel': 'Buscar conectores por nome, provedor ou ferramenta',
  'connectors.searchClear': 'Limpar busca',
  'connectors.emptyNoMatchTitle': 'Nenhum conector corresponde a “{query}”',
  'connectors.emptyNoMatchBody': 'Tente outra palavra-chave ou limpe a busca para ver o catálogo completo.',
  'connectors.emptyNoMatchAction': 'Limpar busca',
  'newproj.tabPrototype': 'Protótipo',
  'newproj.tabLiveArtifact': 'Novo artefato live',
  'newproj.tabDeck': 'Apresentação',
  'newproj.tabTemplate': 'A partir de template',
  'newproj.tabMedia': 'Mídia',
  'newproj.tabOther': 'Outro',
  'newproj.titlePrototype': 'Novo protótipo',
  'newproj.titleLiveArtifact': 'Novo artefato live',
  'newproj.titleDeck': 'Nova apresentação',
  'newproj.titleTemplate': 'Começar de um template',
  'newproj.titleImage': 'Nova imagem',
  'newproj.titleVideo': 'Novo vídeo',
  'newproj.titleAudio': 'Novo áudio',
  'newproj.titleMedia': 'Nova mídia',
  'newproj.titleOther': 'Novo projeto',
  'newproj.namePlaceholder': 'Nome do projeto',
  'newproj.fidelityLabel': 'Fidelidade',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'Alta fidelidade',
  'newproj.toggleSpeakerNotes': 'Usar notas do apresentador',
  'newproj.toggleSpeakerNotesHint': 'Menos texto nos slides — deixe os pontos de fala nas notas.',
  'newproj.toggleAnimations': 'Incluir animações',
  'newproj.toggleAnimationsHint': 'Adicionar movimento (entrada, hover, transições) sobre o template.',
  'newproj.targetPlatformsLabel': 'Plataformas de destino',
  'newproj.targetPlatformsHint': 'Escolha uma ou mais. A web responsiva cobre apenas breakpoints de navegador; adicione app iOS, Android, tablet ou desktop para variantes nativas multiplataforma.',
  'newproj.platform.responsive.label': 'Web responsiva',
  'newproj.platform.responsive.hint': 'Uma experiência web adaptada para navegadores de desktop, tablet e celular',
  'newproj.platform.webDesktop.label': 'Web desktop',
  'newproj.platform.webDesktop.hint': 'Produto ou página de destino voltado para navegador',
  'newproj.platform.mobileIos.label': 'App iOS',
  'newproj.platform.mobileIos.hint': 'Frames de iPhone e regras de interação do iOS',
  'newproj.platform.mobileAndroid.label': 'App Android',
  'newproj.platform.mobileAndroid.hint': 'Frames de Pixel e regras de interação do Material',
  'newproj.platform.tablet.label': 'App de tablet',
  'newproj.platform.tablet.hint': 'Experiência de tablet em estilo nativo com visualizações divididas',
  'newproj.platform.desktopApp.label': 'App de desktop',
  'newproj.platform.desktopApp.hint': 'Interface de app macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Superfícies complementares',
  'newproj.includeLandingPage': 'Incluir página de destino',
  'newproj.includeLandingPageHint': 'Adicione uma página de marketing responsiva para anúncios, listas de espera, campanhas de lançamento, downloads de app ou explicação do produto.',
  'newproj.includeOsWidgets': 'Incluir widgets do SO',
  'newproj.includeOsWidgetsHint': 'Adicione widgets nativos da plataforma para tela inicial, tela de bloqueio ou acesso rápido em apps de celular/tablet.',
  'newproj.includeOsWidgetsDisabledHint': 'Disponível quando um app iOS, Android ou de tablet é selecionado como plataforma de destino.',
  'newproj.templateLabel': 'Modelo',
  'newproj.noTemplatesTitle': 'Ainda não há templates',
  'newproj.noTemplatesBody': 'Abra qualquer projeto e use o menu Compartilhar no visualizador de arquivos para convertê-lo em template. Os templates aparecem aqui.',
  'newproj.savedTemplate': 'Template salvo',
  'newproj.fileSingular': 'arquivo',
  'newproj.filePlural': 'arquivos',
  'newproj.create': 'Criar',
  'newproj.locationLabel': 'Salvar em',
  'newproj.locationDefault': 'Projetos OpenDesign',
  'newproj.locationExternalBase': 'Base externa',
  'newproj.createLiveArtifact': 'Criar artefato live',
  'newproj.createFromTemplate': 'Criar a partir do template',
  'newproj.createDisabledTitle': 'Salve primeiro um projeto como template (menu Compartilhar dentro de qualquer projeto).',
  'newproj.openFolder': 'Abrir pasta',
  'newproj.openingFolder': 'Abrindo…',
  'newproj.importClaudeZip': 'Importar ZIP do Claude Design',
  'newproj.importClaudeZipTitle': 'Importar uma exportação .zip do Claude Design',
  'newproj.importingClaudeZip': 'Importando…',
  'newproj.privacyFooter': 'Por padrão, só você pode ver seu projeto.',
  'newproj.designSystem': 'Sistema de design',
  'newproj.dsNoneFreeform': 'Nenhum — livre',
  'newproj.dsNoneSubtitleEmpty': 'Sem tokens de sistema, escolha sua própria paleta',
  'newproj.dsNoneSubtitleSelected': 'Pular tokens de sistema. O agente escolhe a própria paleta.',
  'newproj.dsCategoryFallback': 'Sistema de design',
  'newproj.dsSearch': 'Buscar sistemas de design…',
  'newproj.dsModeAria': 'Modo de seleção',
  'newproj.dsModeSingle': 'Único',
  'newproj.dsModeMulti': 'Múltiplo',
  'newproj.dsNoneTitle': 'Nenhum — livre',
  'newproj.dsNoneSub': 'Pular tokens de sistema. O agente escolhe a própria paleta.',
  'newproj.dsEmpty': 'Nenhum sistema de design corresponde a “{query}”.',
  'newproj.dsFootSingular': 'é apenas inspiração.',
  'newproj.dsFootPlural': 'são apenas inspiração.',
  'newproj.dsFootClear': 'Limpar',
  'newproj.dsBadgeDefault': 'PADRÃO',
  'newproj.dsPrimaryFallback': 'Principal',
  'newproj.surfaceImage': 'Imagem',
  'newproj.surfaceVideo': 'Vídeo',
  'newproj.surfaceAudio': 'Áudio',
  'newproj.modelLabel': 'Modelo',
  'newproj.modelSearch': 'Buscar modelos…',
  'newproj.modelEmpty': 'Nenhum modelo corresponde.',
  'newproj.modelRecommended': 'Recomendado',
  'newproj.modelMissingTitle': 'Escolher um modelo',
  'newproj.modelMissingSub': 'Escolha um modelo para esta superfície.',
  'newproj.aspectLabel': 'Proporção',
  'newproj.videoLengthLabel': 'Duração',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Tipo de áudio',
  'newproj.audioKindMusic': 'Música',
  'newproj.audioKindSpeech': 'Voz / TTS',
  'newproj.audioKindSfx': 'Efeito sonoro',
  'newproj.audioDurationLabel': 'Duração',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Voz',
  'newproj.voicePlaceholder': 'Voice id do provedor, opcional',
  'newproj.connectorsLabel': 'Conectores',
  'newproj.connectorsHint': 'Fontes de dados que este artefato pode consultar.',
  'newproj.connectorsEmptyTitle': 'Nenhum conector configurado',
  'newproj.connectorsEmptyBody': 'Conecte uma fonte de dados para que o artefato live use dados reais em vez de placeholders.',
  'newproj.connectorsEmptyCta': 'Configurar conectores →',
  'newproj.connectorsLoading': 'Carregando conectores…',
  'newproj.connectorsCountOne': '{n} conectado',
  'newproj.connectorsCountMany': '{n} conectados',
  'newproj.connectorsManage': 'Gerenciar',
  'newproj.promptTemplateLabel': 'Modelo de referência',
  'newproj.promptTemplateNoneTitle': 'Nenhum — escreva o seu',
  'newproj.promptTemplateNoneSub': 'Pule a galeria e descreva o próprio briefing',
  'newproj.promptTemplateRefSub': 'Modelo de referência',
  'newproj.promptTemplateSearch': 'Buscar modelos…',
  'newproj.promptTemplateEmpty': 'Nenhum modelo instalado para este formato ainda.',
  'newproj.promptTemplateBodyLabel': 'Prompt (você pode ajustar)',
  'newproj.promptTemplateOptimizeHint': 'Edite o que quiser — suas alterações entram no briefing do agente.',
  'newproj.promptTemplateBodyEmpty': 'Corpo vazio — o agente não receberá nenhuma referência de modelo.',
  'newproj.deleteTemplateTitle': 'Excluir template',
  'newproj.deleteTemplateConfirm': 'Excluir "{name}"? Esta ação não pode ser desfeita.',
  'newproj.deleteTemplateConfirmCta': 'Excluir template',
  'newproj.deleteTemplateError': 'Não foi possível excluir este template. Tente novamente.',
  'designs.subRecent': 'Recentes',
  'designs.subYours': 'Seus designs',
  'designs.filterAria': 'Filtrar projetos',
  'designs.searchPlaceholder': 'Buscar…',
  'designs.emptyNoProjects': 'Ainda não há projetos.',
  'designs.emptyNoMatch': 'Nenhum projeto corresponde à sua busca.',
  'designs.deleteTitle': 'Excluir projeto',
  'designs.deleteConfirm': 'Excluir "{name}"?',
  'designs.cardFreeform': 'livre',
  'designs.badgeLive': 'Ao vivo',
  'designs.liveArtifactBadgesAria': 'Marcadores de artefato live',
  'designs.liveCount': '{n} ao vivo',
  'designs.statusLive': 'Artefato live',
  'designs.statusArchived': 'Arquivado',
  'designs.statusError': 'Erro',
  'designs.statusRefreshing': 'Atualizando…',
  'designs.statusRefreshFailed': 'Falha ao atualizar',
  'designs.statusRefreshed': 'Atualizado',
  'designs.status.notStarted': 'Não iniciado',
  'designs.status.queued': 'Na fila',
  'designs.status.running': 'Em execução',
  'designs.status.awaitingInput': 'Aguardando resposta',
  'designs.status.incomplete': 'Incompleto',
  'designs.status.succeeded': 'Concluído',
  'designs.status.published': 'Publicado',
  'designs.status.failed': 'Falhou',
  'designs.status.canceled': 'Cancelado',
  'designs.viewToggleAria': 'Modo de visualização',
  'designs.viewGrid': 'Visualização em grade',
  'designs.viewKanban': 'Visualização em quadro',
  'designs.kanbanEmptyColumn': 'Sem designs',
  'designs.deleteAria': 'Excluir projeto {name}',
  'designs.menuMore': 'Mais ações',
  'designs.menuRename': 'Renomear',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Excluir',
  'designs.renamePrompt': 'Novo nome para "{name}"',
  'designs.selectMode': 'Selecionar',
  'designs.cancelSelect': 'Cancelar',
  'designs.deleteSelected': 'Excluir selecionados',
  'designs.selectedCount': '{n} selecionado(s)',
  'designs.deleteSelectedConfirm': 'Excluir {n} projeto(s)?',
  'designs.deleteSelectedSuccess': '{n} projeto(s) excluído(s) com sucesso.',
  'designs.deleteSelectedPartial': '{deleted} projeto(s) excluído(s); {failed} falharam.',
  'designs.tagPrototype': 'Protótipo',
  'designs.tagLiveArtifact': 'Artefato ao vivo',
  'designs.tagWebClone': 'Clone de site',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Mídia',
  'designs.renameTitle': 'Renomear projeto',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancelar',
  'examples.typeLabel': 'Tipo',
  'examples.surfaceLabel': 'Superfície',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Imagem',
  'examples.surfaceVideo': 'Vídeo',
  'examples.surfaceAudio': 'Áudio',
  'examples.scenarioLabel': 'Cenário',
  'examples.modeAll': 'Todos',
  'examples.modePrototypeDesktop': 'Protótipos · Desktop',
  'examples.modePrototypeMobile': 'Protótipos · Mobile',
  'examples.modeDeck': 'Slides',
  'examples.modeDocument': 'Docs e templates',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Ao vivo',
  'examples.scenarioGeneral': 'Geral',
  'examples.scenarioEngineering': 'Engenharia',
  'examples.scenarioProduct': 'Produto',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Vendas',
  'examples.scenarioFinance': 'Finanças',
  'examples.scenarioHr': 'RH',
  'examples.scenarioOperations': 'Operações',
  'examples.scenarioSupport': 'Suporte',
  'examples.scenarioLegal': 'Jurídico',
  'examples.scenarioEducation': 'Educação',
  'examples.scenarioPersonal': 'Pessoal',
  'examples.searchPlaceholder': 'Buscar exemplos…',
  'examples.searchAria': 'Buscar exemplos por nome',
  'examples.emptyNoSkills': 'Nenhuma skill disponível. O daemon está em execução?',
  'examples.emptyNoMatch': 'Nenhum exemplo corresponde a esses filtros.',
  'examples.openPreview': '⤢ Abrir prévia',
  'examples.loadingPreview': 'Carregando prévia…',
  'examples.hoverPreview': 'Passe o cursor para ver a prévia',
  'examples.usePrompt': 'Usar este prompt',
  'examples.previewModalTitle': 'Abrir prévia completa (modal)',
  'examples.shareTitle': 'Compartilhar este exemplo',
  'examples.shareLoadFirst': 'Passe o cursor para carregar a prévia primeiro',
  'examples.unavailablePlaceholder': 'Sem prévia {kind} incluída — abra para saber mais',
  'examples.shareUnavailable': 'Sem prévia {kind} incluída para compartilhar',
  'examples.shareMenu': 'Compartilhar ▾',
  'examples.exportPdfAllSlides': 'Exportar como PDF (todos os slides)',
  'examples.exportPptxLocked': 'Exportar como PPTX… (abra o template primeiro)',
  'examples.tagSlideDeck': 'Apresentação',
  'examples.tagTemplate': 'Modelo',
  'examples.tagDesignSystem': 'Sistema de design',
  'examples.tagMobilePrototype': 'Protótipo mobile',
  'examples.tagDesktopPrototype': 'Protótipo desktop',
  'examples.tagImage': 'Imagem',
  'examples.tagVideo': 'Vídeo',
  'examples.tagAudio': 'Áudio',
  'examples.previewLabel': 'Prévia',
  'ds.surfaceLabel': 'Superfície',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Imagem',
  'ds.surfaceVideo': 'Vídeo',
  'ds.surfaceAudio': 'Áudio',
  'ds.searchPlaceholder': 'Buscar sistemas de design…',
  'ds.emptyNoMatch': 'Nenhum sistema de design corresponde à sua busca.',
  'ds.badgeDefault': 'PADRÃO',
  'ds.preview': 'Prévia',
  'ds.previewTitle': 'Prévia do sistema de design',
  'ds.categoryAll': 'Todos',
  'ds.categoryUncategorized': 'Sem categoria',
  'ds.showcase': 'Vitrine',
  'ds.tokens': 'Tokens',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Carregando DESIGN.md…',
  'avatar.title': 'Conta e configurações',
  'avatar.localCli': 'CLI local',
  'avatar.anthropicApi': 'API da Anthropic',
  'avatar.useLocal': 'Usar CLI local',
  'avatar.useApi': 'Usar API · BYOK',
  'avatar.codeAgent': 'Agente de código',
  'avatar.rescan': 'Reescanear PATH',
  'avatar.amrConsole': 'Conta OpenDesign Cloud',
  'avatar.amrConsoleMeta': 'Saldo e recarga',
  'avatar.settings': 'Configurações',
  'avatar.backToProjects': 'Voltar aos projetos',
  'avatar.metaActive': 'ativo',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'selecionado',
  'avatar.noAgentSelected': 'nenhum agente selecionado',
  'avatar.modelSection': 'Modelo',
  'avatar.modelLabel': 'Modelo',
  'avatar.reasoningLabel': 'Raciocínio',
  'avatar.serviceTierLabel': 'Camada de serviço',
  'avatar.customSuffix': '(personalizado)',
  'socialShare.openDesignSection': 'Compartilhar OpenDesign',
  'socialShare.openDesignTitle': 'OpenDesign no GitHub',
  'socialShare.openDesignText': 'OpenDesign é um espaço de trabalho com código-fonte disponível para criar, editar, implantar e entregar artefatos de design.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'COMPARTILHAMENTO SOCIAL',
  'socialShare.publishPageTitle': 'Publicar página de compartilhamento',
  'socialShare.publishPageSubtitle': 'Publique esta prévia para que ela possa ser compartilhada nas plataformas sociais.',
  'socialShare.projectTitle': '{title} · OpenDesign',
  'socialShare.projectText': 'Feito com OpenDesign: {title}. Veja o artefato implantado e dê uma estrela no repositório: {repo}',
  'socialShare.projectCopyText': 'Feito com OpenDesign: {title}\n{url}\nRepositório do OpenDesign: {repo}',
  'socialShare.deployFirst': 'Faça o deploy e compartilhe…',
  'socialShare.copied': 'Copiado',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Trocar CLI / modelo',
  'inlineSwitcher.chipCli': 'CLI local',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'padrão',
  'inlineSwitcher.noAgent': 'sem agente',
  'inlineSwitcher.modeLabel': 'Modo',
  'inlineSwitcher.agentLabel': 'Agente',
  'inlineSwitcher.providerLabel': 'Provedor',
  'inlineSwitcher.modelLabel': 'Modelo',
  'inlineSwitcher.useCli': 'Usar CLI local',
  'inlineSwitcher.useByok': 'Usar chave de API BYOK',
  'inlineSwitcher.daemonOffline': 'Daemon offline — abrir configurações',
  'inlineSwitcher.noAgentsDetected': 'Nenhum CLI detectado no PATH',
  'inlineSwitcher.openSettingsForModel': 'Configure o provedor em Configurações',
  'inlineSwitcher.missingApiKey': 'Chave de API ausente — abra Configurações.',
  'inlineSwitcher.openFullSettings': 'Abrir configurações de execução',
  'inlineSwitcher.customSuffix': '(personalizado)',
  'inlineSwitcher.unlimitedBadge': 'Ilimitado',
  'project.backToProjects': 'Voltar aos projetos',
  'project.brandReadyTitle': 'O design system {name} está pronto',
  'project.brandReadyTitleGeneric': 'Seu design system está pronto',
  'project.brandReadyCta': 'Visualizar em Design systems',
  'project.brandReadyDismiss': 'Dispensar',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Prévia do sistema de design aberta.',
  'project.previewCommentSaveFailed': 'Não foi possível salvar o comentário. Tente novamente.',
  'project.previewCommentReorderFailed': 'Não foi possível salvar a ordem dos comentários; ela pode ser redefinida ao recarregar.',
  'project.metaFreeform': 'livre',
  'project.typePrototype': 'Protótipo',
  'project.typeDeck': 'Slides',
  'project.typeTemplate': 'Modelo',
  'project.typeImage': 'Imagem',
  'project.typeVideo': 'Vídeo',
  'project.typeAudio': 'Áudio',
  'project.customInstructions': 'Instruções do projeto',
  'project.customInstructionsPlaceholder': 'Instruções para este projeto (injetadas em cada mensagem)…',
  'project.resizeChatPanel': 'Redimensionar painel de chat',
  'project.instructionsActive': 'Ativo — incluído em cada mensagem',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Comentários',
  'chat.commentsSoon': 'Comentários — em breve',
  'chat.comments.attached': 'Anexado ao chat',
  'chat.comments.emptyAttached': 'Nenhum comentário anexado.',
  'chat.comments.saved': 'Comentários salvos',
  'chat.comments.emptySaved': 'Nenhum comentário salvo.',
  'chat.comments.add': 'Adicionar',
  'chat.comments.addAll': 'Adicionar todos',
  'chat.comments.remove': 'Remover',
  'chat.comments.placeholder': 'Comente neste elemento…',
  'chat.comments.addSend': 'Adicionar e enviar',
  'chat.comments.updateSend': 'Atualizar e enviar',
  'chat.comments.removeAttachment': 'Remover anexo de comentário',
  'chat.comments.removeAttachmentAria': 'Remover anexo de comentário de {name}',
  'chat.comments.comment': 'Comentar',
  'chat.comments.sendToChat': 'Enviar para o chat',
  'chat.comments.viewAll': 'Ver todos os comentários',
  'chat.comments.sending': 'Enviando…',
  'chat.comments.edit': 'Editar',
  'chat.comments.select': 'Selecionar',
  'chat.comments.selectAll': 'Selecionar tudo',
  'chat.comments.deselect': 'Desmarcar',
  'chat.comments.nSelected': '{n} selecionados',
  'chat.comments.pin': 'Fixar',
  'chat.comments.addNote': 'Adicionar nota',
  'chat.comments.savedToast': 'Comentário salvo',
  'chat.comments.pinSavedToast': 'Fixado salvo',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} itens capturados',
  'chat.comments.clear': 'Limpar',
  'chat.comments.targetImage': 'Imagem',
  'chat.comments.targetControl': 'Controle',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Texto',
  'chat.comments.targetSection': 'Seção',
  'chat.comments.targetPage': 'Página',
  'chat.comments.targetArea': 'Área',
  'chat.annotationNotePlaceholder': 'Adicionar uma nota para esta marcação',
  'chat.annotationAttachImage': 'Anexar imagem',
  'chat.annotationAttachedImages': 'Imagens anexadas',
  'chat.annotationAttachedRemove': 'Remover última imagem',
  'chat.annotationAddToInput': 'Adicionar à entrada',
  'chat.annotationAddingToInput': 'Adicionando...',
  'chat.annotationQueue': 'Fila',
  'chat.annotationQueueing': 'Enfileirando...',
  'chat.annotationSubmitOptions': 'Opções de envio',
  'chat.annotationSending': 'Enviando...',
  'chat.annotationSendDisabledReason': 'Uma tarefa está em execução no momento',
  'chat.annotationPreviewMissing': 'Não foi possível capturar a prévia. Tente novamente.',
  'chat.annotationPreviewMissingInk': 'Não foi possível capturar a prévia. Tente novamente para evitar enviar apenas o traçado.',
  'chat.annotationSentWithoutScreenshot': 'Não foi possível capturar a pré-visualização. A anotação foi enviada sem captura de tela.',
  'chat.annotationTimeout': 'O envio da anotação expirou. Tente novamente.',
  'chat.annotationFailed': 'Falha ao enviar a anotação. Tente novamente.',
  'chat.annotationProjectCreateFailed': 'Não foi possível criar um projeto, então a anotação não foi enviada.',
  'chat.annotationUploadFailed': 'Falha ao enviar o anexo. Tente novamente.',
  'chat.conversationsTitle': 'Conversas',
  'chat.conversationsAria': 'Histórico de conversas',
  'chat.newConversation': 'Nova conversa',
  'chat.newConversationsTitle': 'Nova conversa',
  'chat.conversationsHeading': 'Conversas',
  'chat.new': 'Nova',
  'chat.emptyConversations': 'Ainda não há conversas.',
  'chat.deleteConversation': 'Excluir conversa',
  'chat.renameConversationLabel': 'Renomear "{title}"',
  'chat.deleteConversationConfirm': 'Excluir "{title}"? Isso remove as mensagens.',
  'chat.untitledConversation': 'Conversa sem título',
  'chat.forkedConversationTitle': 'Fork de {title}',
  'chat.forkConversationFailed': 'Não foi possível bifurcar esta conversa.',
  'chat.startTitle': 'Comece uma conversa',
  'chat.startHint': 'Descreva o que você quer gerar ou comece por um destes exemplos:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so OpenDesign can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'OpenDesign needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "Otimização com IA",
  'brandEnrichment.body': "O OpenDesign executará uma extração mais profunda em segundo plano, aplicará automaticamente as skills certas de design system e atualizará este sistema no lugar. Isso pode levar de 10 a 20 minutos; você pode continuar trabalhando.",
  'brandEnrichment.cta': "Otimizar com IA",
  'brandEnrichment.busy': "Iniciando otimização com IA...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md colado',
  'brandExtractionTranscript.user': 'Extraia um sistema de design de {source}.',
  'brandExtractionTranscript.doneTitle': 'A extração programática de {name} terminou.',
  'brandExtractionTranscript.doneBody': 'Criei e registrei o sistema de design {designSystemId} a partir de {source}. Ele já está pronto para pré-visualização e pode ser usado em novos designs.',
  'brandExtractionTranscript.next': 'Em seguida, você pode executar o AI Optimize para uma extração mais profunda ou criar um novo design com este sistema.',
  'chat.fillInputTitle': 'Clique para preencher o campo',
  'chat.jumpToLatest': 'Ir para a mais recente',
  'chat.scrollToLatest': 'Rolar para a mais recente',
  'chat.messageRail.aria': 'Navegação de mensagens do usuário',
  'chat.messageRail.jumpAria': 'Ir para a mensagem do usuário {index}',
  'chat.messageRail.empty': '(Sem conteúdo)',
  'chat.you': 'Você',
  'chat.openFile': 'Abrir {name}',
  'chat.copyPrompt': 'Copiar prompt',
  'chat.copyErrorDiagnostic': 'Copiar diagnóstico do erro',
  'chat.copyDone': 'Copiado!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Descreva o que você quer gerar…',
  'chat.activeFileEditingLabel': 'Editando',
  'chat.activeFilePlaceholder': 'Peça ao OpenDesign para alterar {file}...',
  'chat.designArtifactsShowMore': 'Mostrar mais {count} arquivos de design',
  'chat.mode.chat.label': 'Perguntar',
  'chat.mode.chat.title': 'Modo Ask',
  'chat.mode.chat.summary': 'Para respostas rápidas, ajustes, planejamento e conversa sem presumir que um artefato de design precisa ser criado.',
  'chat.mode.chat.solves': 'Use para esclarecer ideias, melhorar prompts, comparar opções ou perguntar sobre trabalho existente.',
  'chat.mode.chat.query1': 'Resuma este rascunho e aponte as lacunas.',
  'chat.mode.chat.query2': 'Ajude-me a decidir a melhor estrutura para esta landing page.',
  'chat.mode.chat.query3': 'Revise este design e sugira melhorias concretas.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Modo Design',
  'chat.mode.design.summary': 'Para criar ou alterar saídas concretas: páginas, protótipos, artefatos ao vivo, slides, imagens, vídeos, HyperFrames, áudio, dashboards e arquivos de projeto.',
  'chat.mode.design.solves': 'Use quando quiser que o OpenDesign gere arquivos, atualize o workspace ou transforme um brief em entregáveis multimodais.',
  'chat.mode.design.query1': 'Crie uma landing page de lançamento de produto e um protótipo HyperFrames a partir deste brief.',
  'chat.mode.design.query2': 'Crie um deck para investidores com 10 slides e notas de apresentação.',
  'chat.mode.design.query3': 'Gere conceitos de imagem, vídeo e áudio para esta campanha.',
  'chat.mode.cardBestFor': 'Ideal para',
  'chat.mode.cardTry': 'Experimente pedir',
  'chat.mode.cardCost': 'Consumo típico',
  'chat.mode.chat.cost': 'Baixo',
  'chat.mode.chat.costNote': 'Apenas uma conversa — nada é gerado, então consome o mínimo.',
  'chat.mode.plan.cost': 'Padrão',
  'chat.mode.plan.costNote': 'Cria primeiro um documento de plano editável antes de qualquer geração.',
  'chat.mode.design.cost': 'Alto',
  'chat.mode.design.costNote': 'Gera arquivos e mídia multimodal, então uma execução pode consumir mais.',
  'chat.modePicker.choose': 'Escolher um modo',
  'chat.modePicker.current': 'Modo: {name}',
  'chat.modePicker.clear': 'Limpar modo',
  'chat.modePicker.mode': 'Modo',
  'chat.composerHint': '⌘/Ctrl + Enter para enviar · inclua objetivo, conteúdo, estilo e formato',
  'chat.cliSettingsTitle': 'Configurações de CLI e modelo',
  'chat.cliSettingsAria': 'Abrir configurações de CLI e modelo',
  'chat.attachTitle': 'Anexar arquivos (ou colar / arrastar)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Anexar arquivos',
  'chat.importTitle': 'Importar fontes (em breve)',
  'chat.importLabel': 'Importar',
  'chat.importComingSoon': 'Em breve',
  'chat.importSoon': 'Em breve',
  'chat.importFig': 'Enviar arquivo .fig',
  'chat.importGitHub': 'Conectar GitHub',
  'chat.importWeb': 'Capturar elemento web',
  'chat.importFolder': 'Vincular pasta de código',
  'chat.importSkills': 'Skills e sistemas de design',
  'chat.importProject': 'Referenciar outro projeto',
  'chat.importDesignSystemHeader': 'Escolher um design system',
  'chat.importDesignSystemBack': 'Voltar',
  'chat.importDesignSystemSearch': 'Pesquisar design systems…',
  'chat.importDesignSystemEmpty': 'Nenhum design system corresponde a "{query}"',
  'chat.importDesignSystemNone': 'Nenhum — livre',
  'chat.importDesignSystemNoneSub': 'Não vincular a um sistema desta vez',
  'chat.importDesignSystemActive': 'Ativo',
  'chat.importDesignSystemSwitched': 'Design system alterado para {title}',
  'chat.importDesignSystemFailed': 'Não foi possível mudar o design system. Tente novamente.',
  'chat.importDesignSystemLoadFailed': 'Não foi possível carregar os sistemas de design.',
  'browserUse.title': 'Inspiração',
  'browserUse.summary': '{count} ações na web, priorizando extração de ativos, linguagem de design, movimento, verificações visuais e estrutura de componentes.',
  'browserUse.searchAria': 'Buscar inspiração',
  'browserUse.searchPlaceholder': 'Buscar capturas de tela, fontes, cores, a11y...',
  'browserUse.empty': 'Nenhuma inspiração correspondente',
  'browserUse.unavailable': 'A inspiração não está disponível aqui',
  'browserUse.added': 'Adicionado ao compositor',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Parar carregamento',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'OpenDesign browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Extração de ativos',
  'browserUse.category.tokens': 'Linguagem de design',
  'browserUse.category.motion': 'Movimento',
  'browserUse.category.visual': 'Verificações visuais',
  'browserUse.category.structure': 'Componentes',
  'browserUse.category.project': 'Execução do projeto',
  'browserUse.category.general': 'Geral',
  'browserUse.input.none': 'Sem entrada',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Seletor opcional',
  'browserUse.input.requirementSelector': 'Requisito, seletor opcional',
  'browserUse.input.selectorOptional': 'Seletor opcional',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Seletor, scale=2',
  'browserUse.input.gridOverlay': '12 colunas, máx. 1200, espaçamento 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domínio ou termos de busca',
  'browserUse.input.selector': 'Seletor',
  'browserUse.input.selectorText': 'Seletor e texto',
  'browserUse.input.scroll': 'Pixels, topo, base ou página',
  'browserUse.input.terminalRun': 'Comando, tempo limite 120s',
  'browserUse.input.command': 'Comando',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Melhores candidatos a logo do cabeçalho, navegação, nomes de classe, posição, imagem OG e fallback de favicon.',
  'browserUse.action.list_images.output': 'Todas as imagens de img, srcset, source e de fundo CSS com dimensões e texto alternativo.',
  'browserUse.action.download_assets.output': 'Pasta de ativos baixados mais _manifest.json com suporte a referer e cookie.',
  'browserUse.action.extract_svgs.output': 'SVGs inline e arquivos .svg vinculados salvos como arquivos SVG individuais.',
  'browserUse.action.optimize_svgs.output': 'Arquivos SVG otimizados mais a taxa de compressão.',
  'browserUse.action.extract_colors.output': 'Paleta ponderada mais variáveis de cor CSS :root como palette.json e palette.html.',
  'browserUse.action.extract_fonts.output': 'Principais famílias de fontes, tamanhos, pesos e regras @font-face como typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Raio, sombra, espaçamento e variáveis CSS como tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Escala tipográfica de título, corpo e botão com tamanho, peso, altura de linha e proporções.',
  'browserUse.action.extract_buttons.output': 'Biblioteca de estilos de botão sem duplicatas como buttons.html e buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Containers grid e flex, direção, espaçamentos, colunas e larguras máximas como layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Breakpoints de media query responsivos como breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradientes CSS como gradients.css, gradients.json e HTML de visualização.',
  'browserUse.action.extract_shadows.output': 'Sombras de caixa, sombras de texto e drop shadows como shadows.json mais visualização.',
  'browserUse.action.extract_easings.output': 'Funções de easing de transição e animação como easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js e style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, regras de transition e transform, bibliotecas de movimento detectadas, motion.css e motion.json.',
  'browserUse.action.validate_view.output': 'Caminhos das capturas de tela mais problemas visuais e de layout estruturados.',
  'browserUse.action.audit_layout.output': 'Defeitos de layout incluindo overflow, limites, sobreposição e texto cortado como audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problemas de acessibilidade com seletores, rótulos, roles, foco, contraste e capturas de tela quando úteis.',
  'browserUse.action.responsive_screenshots.output': 'Capturas de tela em mobile 390, tablet 834 e desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Captura de tela da página inteira além da viewport.',
  'browserUse.action.screenshot_element.output': 'Captura de tela de um único elemento em 2x por padrão.',
  'browserUse.action.screenshot_with_grid.output': 'Captura de tela com sobreposição do grid de layout.',
  'browserUse.action.screenshot_dark_mode.output': 'Captura de tela com prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Guia de estilo de uma página com cores, escala tipográfica, raio e sombras.',
  'browserUse.action.extract_html.output': 'HTML limpo e autossuficiente, sem script, noscript ou atributos de evento inline.',
  'browserUse.action.extract_component_inventory.output': 'Padrões de componentes repetidos, seletores, contagens e capturas de tela.',
  'browserUse.action.extract_copy.output': 'Títulos, CTAs, texto de corpo e descrições como copy.md e copy.json.',
  'browserUse.action.extract_nav.output': 'Navegação principal e links de rodapé como sitemap.md e nav.json.',
  'browserUse.action.extract_forms.output': 'Campos de formulário, rótulos, dicas de validação e ações de envio como forms.json.',
  'browserUse.action.run_project.output': 'URL do servidor de desenvolvimento detectada e aberta na aba Browser.',
  'browserUse.action.detect_project.output': 'Framework, gerenciador de pacotes, comando de instalação, comando de desenvolvimento e porta.',
  'browserUse.action.page_info.output': 'URL, título, descrição, imagem OG, cor do tema, favicon e viewport.',
  'browserUse.action.snapshot.output': 'Até 120 elementos interativos e de texto visíveis com tag, rótulo, href e coordenadas.',
  'browserUse.action.navigate.output': 'Abrir a página e retornar page_info.',
  'browserUse.action.click.output': 'Clicar no primeiro elemento correspondente após rolá-lo para a área visível.',
  'browserUse.action.type_text.output': 'Preencher um campo e disparar eventos input e change.',
  'browserUse.action.scroll.output': 'Posição de rolagem atual e máxima.',
  'browserUse.action.extract_og_metadata.output': 'Título meta, descrição, URL canônica, cards OG/Twitter, imagem social e cor do tema.',
  'browserUse.action.terminal_run.output': 'stdout, stderr e código de saída.',
  'browserUse.action.terminal_run_background.output': 'ID da tarefa em segundo plano e saída recente.',
  'browserUse.action.terminal_read.output': 'Saída recente do terminal compartilhado.',
  'chat.designToolbox.title': 'Caixa de ferramentas de design',
  'chat.designToolbox.tooltip': 'Caixa de ferramentas de design',
  'chat.designToolbox.aria': 'Abrir caixa de ferramentas de design',
  'chat.designToolbox.searchPlaceholder': 'Buscar skills / MCP / plugins / connectors / arquivos de design...',
  'chat.designToolbox.searchAria': 'Buscar recursos da caixa de ferramentas de design',
  'chat.designToolbox.followupSection': 'Acompanhamento',
  'chat.designToolbox.resourcesSection': 'Recursos globais',
  'chat.designToolbox.selected': 'Selecionado',
  'chat.designToolbox.noResources': 'Nenhum recurso encontrado para "{query}".',
  'chat.designToolbox.badge.video': 'Vídeo',
  'chat.designToolbox.badge.image': 'Imagem',
  'chat.designToolbox.badge.motion': 'Movimento',
  'chat.designToolbox.badge.polish': 'Refinamento',
  'chat.designToolbox.action.auto-match.title': 'Combinar próximo passo',
  'chat.designToolbox.action.auto-match.badge': 'Combinar',
  'chat.designToolbox.action.auto-match.description': 'Defina primeiro o nível de exigência estética, depois combine skills, MCP, plugins, connectors e arquivos.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Adicionar animação / movimento',
  'chat.designToolbox.action.motion.badge': 'Movimento',
  'chat.designToolbox.action.motion.description': 'Adicione movimento de entrada, de rolagem, de transição de estado e de microinteração ao HTML ou elemento de página atual.',
  'chat.designToolbox.action.motion-polish.title': 'Refinar movimento',
  'chat.designToolbox.action.motion-polish.badge': 'Tempo',
  'chat.designToolbox.action.motion-polish.description': 'Revise tempo, easing, desempenho e fallbacks de reduced-motion para o movimento existente.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Remover cara de IA',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Estética',
  'chat.designToolbox.action.anti-ai-polish.description': 'Remova cara de template, gradientes de IA, pilhas de cards baratas e texto vago.',
  'chat.designToolbox.action.visual-polish.title': 'Refinamento de design / pronto para publicar',
  'chat.designToolbox.action.visual-polish.badge': 'Refinar',
  'chat.designToolbox.action.visual-polish.description': 'Audite a hierarquia visual, tipografia, espaçamento, comportamento responsivo, acessibilidade e qualidade de entrega.',
  'chat.designToolbox.action.image-gen.title': 'Gerar imagens / referências visuais',
  'chat.designToolbox.action.image-gen.badge': 'Imagem',
  'chat.designToolbox.action.image-gen.description': 'Gere referências de seção, assets, ícones, imagens para redes sociais ou um moodboard para a página atual.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Gerar vídeo / roteiro de animação',
  'chat.designToolbox.action.video-gen.badge': 'Vídeo',
  'chat.designToolbox.action.video-gen.description': 'Transforme o design em um vídeo curto, storyboard Remotion / HyperFrames ou prompt pronto para geração.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Modelo de MCP',
  'chat.designToolbox.kind.connector': 'Conector',
  'chat.designToolbox.kind.designFile': 'Arquivo de design',
  'chat.designToolbox.context.browser': 'Navegador',
  'chat.designToolbox.context.designFiles': 'Arquivos de design',
  'chat.designToolbox.context.designSystem': 'Design system',
  'chat.designToolbox.context.folder': 'Pasta',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Chat lateral',
  'chat.designToolbox.context.liveArtifact': 'Artefato ao vivo',
  'chat.designToolbox.context.file': 'Arquivo',
  'chat.designToolbox.prompt.contextGeneric': 'Alvo atual: o arquivo HTML / arquivo de design / elemento web aberto no momento.',
  'chat.designToolbox.prompt.contextSpecific': 'Alvo atual: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Preserve a intenção que já está no compositor: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill selecionada: {skill}. Use-a como o fluxo de trabalho principal neste turno.',
  'chat.designToolbox.prompt.noSkill': 'Se nenhuma skill específica corresponder, primeiro escolha a melhor combinação entre skills, MCP, plugins, conectores e arquivos de design disponíveis.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Atue como o orquestrador Diretor de Criação e conclua um fluxo de trabalho de design:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Primeiro, defina o que significa um “design bonito”: público, objetivo de negócio, identidade da marca, referências de estilo, densidade de informação, padrões de cor/tipografia/movimento/recursos e padrões de IA/templates a evitar.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Pesquise e faça a correspondência com todo o índice de recursos acima. Não use apenas as recomendações da caixa de ferramentas de design; combine skills, MCP, plugins, conectores e arquivos de design quando for útil.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Conclua o fluxo nesta ordem: diagnóstico -> direção de estilo -> seleção de recursos -> edição/geração concreta -> verificação. Em cada etapa, explique por que esses recursos foram escolhidos e o que precisa ser confirmado em seguida.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Revise e refine o tempo, a suavização, o desempenho e a acessibilidade das animações existentes. Remova animações abruptas, baratas ou que prejudicam a legibilidade; use uma linha do tempo mais refinada quando necessário.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Faça uma passagem de refinamento anti-cara-de-IA: remova layouts genéricos, gradientes/brilhos baratos, pilhas de cards sem sentido e textos vagos. Preserve a informação e faça com que pareça que um designer de verdade a entregou.',
  'chat.designToolbox.prompt.visualPolish': 'Refine este design até deixá-lo pronto para publicação: verifique hierarquia, tipografia, espaçamento, comportamento responsivo, estados de botões, estados vazios/de carregamento/de erro e acessibilidade; corrija diretamente os problemas mais importantes.',
  'chat.designToolbox.prompt.imageGen': 'Crie o próximo plano de assets visuais para este design: referências de seção, assets de hero, ilustrações, ícones, imagens para redes sociais ou um moodboard. Primeiro decida que tipo de imagem está faltando e, em seguida, forneça prompts de geração executáveis / plano de arquivos.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Direcione este design para vídeo: crie um storyboard de vídeo curto, uma estrutura de frames HyperFrames / Remotion ou um prompt pronto para Sora/fal. Prefira fazer com que o conteúdo HTML / da página existente se torne naturalmente as cenas.',
  'chat.designToolbox.prompt.useSkill': 'Use {skill} no design atual.',
  'chat.designToolbox.prompt.skillInstruction': 'Primeiro decida o melhor objetivo de continuidade e, em seguida, conclua uma passagem concreta. Se depender de assets externos ou APIs, forneça um fallback executável ou indique o que preciso fornecer.',
  'chat.designToolbox.prompt.selectedResource': 'Recurso selecionado: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Descrição do recurso: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Use este plugin como o contexto principal para o fluxo de design atual. Se ele expuser inputs ou GenUI, oriente-me a escolher quando necessário; se não se adequar ao alvo, escolha um recurso global melhor e explique por quê.',
  'chat.designToolbox.prompt.mcpResource': 'Prefira esta capacidade de MCP para a próxima etapa do design. Quando forem necessários assets externos, captura web, geração de imagem/vídeo ou dados, primeiro decida se ela é capaz de realizar a tarefa e, em seguida, forneça um plano executável.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Este MCP é um modelo configurável. Se for a ferramenta mais útil para esta etapa do design, oriente a configuração primeiro; se houver uma alternativa já configurada, continue com essa alternativa.',
  'chat.designToolbox.prompt.connectorResource': 'Use este conector quando forem necessários dados reais, assets, conteúdo de conta ou acesso a fluxo de trabalho externo. Antes de usá-lo, explique o que será lido ou gravado e peça confirmação quando apropriado.',
  'chat.designToolbox.prompt.fileResource': 'Use este arquivo de design como o alvo de design atual ou asset de referência e conclua a próxima etapa a partir dele. Se for necessário comparar outros arquivos, continue pesquisando em todos os arquivos de design.',
  'chat.designToolbox.prompt.resourceIndex': 'Índice de recursos globais: skills({skills}), plugins({plugins}), MCP({mcpEnabled} ativados / {mcpTemplates} modelos), conectores({connectors} conectados), arquivos de design({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skills pesquisáveis',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugins pesquisáveis',
  'chat.designToolbox.prompt.availableMcp': 'MCP disponíveis',
  'chat.designToolbox.prompt.connectedConnectors': 'Conectores conectados',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Arquivos de design de referência',
  'chat.designToolbox.prompt.mcpTemplateName': 'Modelo {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} mais',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Superfícies de menção',
  'chat.mentionTabAll': 'Todos',
  'chat.mentionTabTabs': 'Abas',
  'chat.mentionTabPlugins': 'Plugins',
  'chat.mentionTabSkills': 'Skills',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Conectores',
  'chat.mentionTabFiles': 'Arquivos de design',
  'chat.mentionNoResults': 'Nenhum resultado para “{query}”.',
  'chat.mentionSearchPrompt': 'Pesquisar arquivos de design, abas, plugins, skills, servidores MCP e conectores.',
  'chat.mentionSectionTabs': 'Abas',
  'chat.mentionSectionPlugins': 'Plugins',
  'chat.mentionSectionSkills': 'Skills',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Conectores',
  'chat.mentionSectionFiles': 'Arquivos de design',
  'chat.mentionActiveSkill': 'Ativo',
  'chat.mentionUseMcpTitle': 'Usar {name}',
  'chat.mentionUseConnectorTitle': 'Usar {name}',
  'chat.mentionPluginOfficial': 'Oficial',
  'chat.mentionPluginMine': 'Meu plugin',
  'chat.linkedFolderRemoveAria': 'Remover pasta vinculada {path}',
  'chat.linkedFolderNotFound': 'A pasta não existe',
  'chat.linkedFolderAlready': 'Esta pasta já está vinculada',
  'chat.linkedFolderPickError': 'Não foi possível abrir o seletor de pasta',
  'chat.queuedHeader': 'Na fila',
  'chat.queuedToSend': 'para enviar',
  'chat.queuedEditQueuedTaskAria': 'Editar tarefa na fila',
  'chat.queuedSave': 'Salvar',
  'chat.queuedCancel': 'Cancelar',
  'chat.queuedReorder': 'Arraste para reordenar',
  'chat.queuedEdit': 'Editar',
  'chat.queuedMore': 'mais na fila',
  'chat.queuedFollowUpFallback': 'Acompanhamento na fila',
  'chat.send': 'Enviar',
  'chat.stop': 'Parar',
  'chat.removeAria': 'Remover {name}',
  'chat.example1Title': 'Pitch deck editorial',
  'chat.example1Tag': 'Revista',
  'chat.example1Prompt': 'Uma apresentação editorial de 10 slides para um estúdio de design levantando uma rodada seed — layout em grid suíço, títulos serifados enormes com capitulares marcantes, números de seção em monoespaçada, bastante espaço negativo e slides com fotos em tela cheia intercalados com slides densos de texto. Capa, visão, mercado, produto, tração, equipe, pedido, contato.',
  'chat.example2Title': 'Dashboard de analytics SaaS',
  'chat.example2Tag': 'Dados',
  'chat.example2Prompt': 'Um dashboard denso de analytics para um SaaS de ferramentas de desenvolvedor — faixa de KPIs com variações semanais, dois gráficos de linha empilhados (MRR e workspaces ativos), um mapa-múndi de calor de uso, uma grade de retenção por coorte, ranking de principais clientes e feed de eventos em tempo real. Tema escuro, números tabulares monoespaçados, acentos em sparklines.',
  'chat.example3Title': 'Relatório anual long-scroll',
  'chat.example3Tag': 'Editorial',
  'chat.example3Prompt': 'Um relatório anual interativo para uma ONG climática — layout editorial long-scroll misturando grandes blocos de citações, visualizações de dados (barras empilhadas, contadores animados, mapa coroplético de locais de projetos), quebras com fotografia, mural de doadores e chamada final para ação. Corpo com serif moderna, rótulos de gráficos sem serifa, paleta terrosa de papel.',
  'home.recommendation.eyebrow': 'Recomendado para você',
  'home.recommendation.primaryCta': 'Começar a criar',
  'home.recommendation.change': 'Tentar outro',
  'home.recommendation.browseAll': 'Todos os tipos',
  'home.recommendation.defaultProjectName': 'Novo projeto',
  'home.recommendation.startFailed': 'Não foi possível iniciar a criação. Tente novamente.',
  'studio.firstArtifactHint.title': 'Seu primeiro design está pronto',
  'studio.firstArtifactHint.body': 'Experimente editar e anotar diretamente — exporte ou compartilhe quando estiver satisfeito.',
  'studio.firstArtifactHint.dismiss': 'Entendi',
  'home.starter.product_ui_prototype.title': 'Comece com um protótipo de produto editável',
  'home.starter.product_ui_prototype.desc': 'Com base no seu objetivo, comece com uma interface clicável que você pode refinar.',
  'home.starter.product_ui_prototype.firstPrompt': 'Projete um protótipo de produto editável para [seu produto] com as telas principais e um fluxo principal claro.',
  'home.starter.product_ui_component.title': 'Comece a partir de um componente reutilizável',
  'home.starter.product_ui_component.desc': 'Crie um componente primeiro e depois combine-o em telas completas.',
  'home.starter.product_ui_component.firstPrompt': 'Projete um componente [nome do componente] reutilizável com seus principais estados e variantes.',
  'home.starter.product_ui_lowfi.title': 'Comece com um protótipo de baixa fidelidade',
  'home.starter.product_ui_lowfi.desc': 'Esboce a estrutura primeiro e depois aumente a fidelidade.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Crie um wireframe de baixa fidelidade das telas principais para [seu produto].',
  'home.starter.marketing_landing.title': 'Comece com uma landing page',
  'home.starter.marketing_landing.desc': 'Transforme sua campanha em uma landing page pronta para publicar.',
  'home.starter.marketing_landing.firstPrompt': 'Projete uma landing page para [seu produto] com um hero, benefícios principais e uma chamada para ação clara.',
  'home.starter.marketing_multivariant.title': 'Comece com várias variantes de landing page',
  'home.starter.marketing_multivariant.desc': 'Gere algumas versões para comparar antes de decidir.',
  'home.starter.marketing_multivariant.firstPrompt': 'Crie 3 variantes de landing page para [seu produto] com mensagens de hero diferentes para comparar.',
  'home.starter.internal_dashboard.title': 'Comece com um painel interno',
  'home.starter.internal_dashboard.desc': 'Comece a partir de um layout de painel para o seu fluxo de trabalho.',
  'home.starter.internal_dashboard.firstPrompt': 'Projete um painel interno mostrando [métricas principais] com filtros e uma tabela de dados.',
  'home.starter.internal_report.title': 'Comece com um relatório',
  'home.starter.internal_report.desc': 'Descreva os dados e campos que você quer ver.',
  'home.starter.internal_report.firstPrompt': 'Crie uma página de relatório resumindo [descreva os dados, campos e métricas que interessam a você].',
  'home.starter.general_menu.title': 'Comece com seu primeiro projeto',
  'home.starter.general_menu.desc': 'Descreva o que você quer e geraremos uma primeira versão editável.',
  'home.starter.general_menu.firstPrompt': 'Crie uma primeira versão editável de [descreva o que você quer criar].',
  'chat.example4Title': 'Vídeo motion de produto',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Crie um storyboard de vídeo motion de 15 segundos para o lançamento de um app de produtividade: gancho inicial, closes de UI, tipografia cinética, transições de recursos, logo final e CTA. Inclua timing, cenas, movimentos de câmera e textos na tela.',
  'preview.usePlugin': 'Usar plugin',
  'preview.usePluginOnly': 'Usar sem prompt',
  'preview.usePluginOnlyDesc': 'Use a estrutura do plugin sem carregar o prompt de exemplo',
  'preview.replicateContent': 'Usar',
  'preview.replicateContentDesc': 'Use o prompt de exemplo para recriar a previa',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remixe este exemplo em um novo projeto editavel',
  'preview.shareMenu': 'Compartilhar',
  'preview.exportMenu': 'Exportar',
  'preview.shareTemplateBadge': 'Modelo',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copiar link do modelo',
  'preview.copyShareText': 'Copiar texto de compartilhamento',
  'preview.shareSocialGroup': 'Compartilhar nas redes sociais',
  'preview.shareCopyGroup': 'Copiar',
  'preview.shareExportGroup': 'Exportar arquivos',
  'preview.shareCopied': 'Copiado',
  'preview.shareCopyFailed': 'Falha ao copiar',
  'preview.shareTextDefault': 'Modelo do OpenDesign: {title}',
  'preview.openInNewTab': 'Abrir em nova aba',
  'preview.exit': '⤓ Sair',
  'preview.fullscreen': '⤢ Tela cheia',
  'preview.closeTitle': 'Fechar (Esc)',
  'preview.loading': 'Carregando {label}…',
  'preview.errorTitle': 'Não foi possível carregar este exemplo.',
  'preview.errorBody': 'A obtenção do HTML do exemplo falhou. Verifique se o OpenDesign está em execução e tente novamente.',
  'preview.retry': 'Tentar novamente',
  'preview.unavailableTitle': 'Nenhuma prévia incluída para {noun}.',
  'preview.unavailableBody': 'Execute o prompt no chat para gerar um resultado {kind}.',
  'preview.nounSkill': 'esta skill',
  'preview.nounPlugin': 'este plugin',
  'preview.nounTemplate': 'este modelo',
  'preview.showSidebar': 'Mostrar {label}',
  'preview.hideSidebar': 'Ocultar {label}',
  'misc.savedTemplate': 'Template salvo',
  'misc.primary': 'Principal',
  'misc.designSystem': 'Sistema de design',
  'workspace.designFiles': 'Arquivos de design',
  'workspace.focusMode': 'Focar no workspace',
  'workspace.showChat': 'Mostrar chat',
  'workspace.closeTab': 'Fechar aba',
  'workspace.fileSyncDownloading': 'Baixando da equipe…',
  'workspace.fileSyncUploading': 'Sincronizando com a equipe…',
  'workspace.deleteFileConfirm': 'Excluir "{name}" da pasta do projeto?',
  'workspace.readonlyNotice': 'Este é um projeto compartilhado — você pode visualizar e comentar, mas não alterar artefatos pelo Chat ou pelas ferramentas de edição.',
  'workspace.readonlyNoticeBy': 'Este é um projeto compartilhado criado por {owner} — você pode visualizar e comentar, mas não alterar artefatos pelo Chat ou pelas ferramentas de edição.',
  'workspace.deleteSelectedFilesConfirm': 'Excluir {n} arquivo(s) selecionado(s) da pasta do projeto?',
  'workspace.deleteSelectedFilesPartial': 'Falha ao excluir {n} arquivo(s).',
  'workspace.openFromDesignFiles': 'Abra um arquivo em',
  'workspace.designFilesLink': 'Arquivos de design',
  'workspace.loadingSketch': 'Carregando esboço…',
  'workspace.newTab': 'Nova aba',
  'workspace.searchFilesPlaceholder': 'Pesquisar arquivos…',
  'workspace.openTabs': 'Abrir abas',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Abrir um arquivo',
  'workspace.noFilesMatch': 'Nenhum arquivo corresponde',
  'workspace.allFiles': 'Todos',
  'workspace.createNew': 'Criar novo',
  'workspace.tabOpen': 'Aberto',
  'workspace.sideChatContextBanner': 'Contexto da conversa atual integrado',
  'workspace.sideChatDefaultTitle': 'Chat lateral',
  'workspace.newTerminal': 'Novo terminal',
  'workspace.newTerminalDescription': 'Abrir um shell no diretório do projeto em uma nova aba',
  'workspace.newBrowser': 'Novo navegador',
  'workspace.newBrowserDescription': 'Abrir uma aba de navegador integrada para sites de referência e tarefas',
  'workspace.newSketchDescription': 'Rascunhe layouts e notas rápidas como contexto de design para o agente',
  'workspace.terminalStarting': 'Iniciando terminal…',
  'workspace.terminalStartingDescription': 'Preparando o shell do projeto. Normalmente leva alguns segundos.',
  'workspace.terminalSessionEnded': 'Sessão encerrada',
  'workspace.terminalReconnecting': 'Reconectando…',
  'workspace.terminalStartFailed': 'Não foi possível iniciar a sessão de terminal',
  'workspace.terminalRestart': 'Reiniciar',
  'designFiles.title': 'Arquivos de design',
  'designFiles.upload': 'Enviar arquivos',
  'designFiles.pasteText': 'Colar como arquivo de texto',
  'designFiles.newSketch': 'Novo esboço',
  'designFiles.newDocument': 'Novo documento',
  'designFiles.newDocumentTitle': 'Criar um novo documento Markdown',
  'designFiles.empty': 'As criações aparecerão aqui',
  'designFiles.syncing': 'Sincronizando os arquivos compartilhados da equipe…',
  'designFiles.refresh': 'Atualizar',
  'designFiles.delete': 'Excluir',
  'designFiles.searchPlaceholder': 'Buscar arquivos…',
  'designFiles.up': 'Subir',
  'designFiles.back': 'Voltar',
  'designFiles.crumbs': 'projeto',
  'designFiles.rowMenu': 'Menu da linha',
  'designFiles.openInTab': 'Abrir em aba',
  'designFiles.download': 'Baixar',
  'designFiles.downloadSelected': 'Baixar {n} selecionados como ZIP',
  'designFiles.deleteSelected': 'Excluir {n}',
  'designFiles.clearSelection': 'Limpar seleção',
  'designFiles.selectPage': 'Selecionar tudo na página',
  'designFiles.selectAll': 'Selecionar tudo',
  'designFiles.dropTitle': '⤓ Solte arquivos aqui',
  'designFiles.dropDesc': 'Imagens, docs, referências ou pastas — o agente usará tudo como contexto.',
  'designFiles.dropLabel': 'Solte os arquivos aqui',
  'designFiles.upload.title': 'Enviar arquivos',
  'designFiles.paste.title': "Colar texto como arquivo",
  'designFiles.upload.label': 'Enviar',
  'designFiles.paste.label': "Colar",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what OpenDesign should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The OpenDesign agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask OpenDesign to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Abrir',
  'designFiles.previewClose': 'Fechar prévia',
  'designFiles.modified': 'Modificado {time} · {size}',
  'designFiles.weeksAgo': 'há {n} sem',
  'designFiles.groupBy': 'Agrupar por',
  'designFiles.groupByKind': 'Tipo',
  'designFiles.groupByModified': 'Modificado',
  'designFiles.filterBy': 'Filtrar por tipo',
  'designFiles.filterClear': 'Limpar',
  'designFiles.filterCount': '{n} tipos',
  'designFiles.expandGroup': 'Expandir',
  'designFiles.collapseGroup': 'Recolher',
  'designFiles.sectionPages': 'Páginas',
  'designFiles.sectionScripts': 'Scripts',
  'designFiles.sectionImages': 'Imagens',
  'designFiles.sectionSketches': 'Esboços',
  'designFiles.sectionLiveArtifacts': 'Artefatos live',
  'designFiles.sectionOther': 'Outros',
  'designFiles.modifiedToday': 'Hoje',
  'designFiles.modifiedYesterday': 'Ontem',
  'designFiles.modifiedPrevious7Days': 'Últimos 7 dias',
  'designFiles.modifiedPrevious30Days': 'Últimos 30 dias',
  'designFiles.modifiedOlder': 'Mais antigos',
  'designFiles.showMore': 'Mostrar +{n} mais',
  'designFiles.kindHtml': 'Página HTML',
  'designFiles.kindImage': 'Imagem',
  'designFiles.kindSketch': 'Esboço',
  'designFiles.kindText': 'Texto',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Documento',
  'designFiles.kindPresentation': 'Apresentação',
  'designFiles.kindSpreadsheet': 'Planilha',
  'designFiles.kindLiveArtifact': 'Artefato live',
  'designFiles.kindBinary': 'Binário',
  'designFiles.kindFolder': 'Pasta',
  'designFiles.folderCount': '{n} arquivos',
  'designFiles.newFolderTitle': 'Nova pasta',
  'designFiles.newFolderLabel': 'Nome da pasta',
  'designFiles.moveTitle': 'Mover para a pasta',
  'designFiles.moveLabel': 'Pasta de destino',
  'designFiles.moveRoot': 'Raiz do projeto',
  'designFiles.moveNewFolder': 'Nova pasta…',
  'designFiles.move': 'Mover',
  'designFiles.copyPath': 'Copiar caminho',
  'designFiles.copiedPath': 'Caminho copiado',
  'designFiles.copyLocalPath': 'Copiar caminho do arquivo local',
  'designFiles.copiedLocalPath': 'Caminho do arquivo local copiado',
  'designFiles.deleteFolderConfirm': 'Excluir a pasta "{name}" e todo o seu conteúdo?',
  'designFiles.folderCreated': 'Pasta "{name}" criada',
  'designFiles.folderDeleted': 'Pasta "{name}" excluída',
  'designFiles.filesMoved': '{n} movido(s) para {dest}',
  'designFiles.colName': 'Nome',
  'designFiles.colKind': 'Tipo',
  'designFiles.colModified': 'Modificado',
  'designFiles.perPage': 'Mostrar',
  'designFiles.all': 'Todos',
  'designFiles.prev': 'Anterior',
  'designFiles.next': 'Próximo',
  'designFiles.jumpToPage': 'Ir para a página',
  'designFiles.pageInfo': '{start}–{end} de {total}',
  'designFiles.sectionFolders': 'Pastas',
  'designFiles.sectionStylesheets': 'Folhas de estilo',
  'designFiles.sectionDocuments': 'Documentos',
  'designFiles.kindStylesheet': 'Folha de estilo',
  'designFiles.modifiedExt': 'Modificado em {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Informações úteis',
  'designFiles.usefulInfoTip': 'Clique duas vezes em qualquer arquivo para abri-lo em uma aba completa.',
  'designFiles.usefulInfoTip2': 'Digite @ no chat para referenciar um arquivo como contexto.',
  'designFiles.usefulInfoTip4': 'Escolha um design system para manter o resultado alinhado à marca.',
  'designFiles.usefulInfoTip5': 'Sem ideias? Experimente um template de plugin na Comunidade, na página inicial.',
  'designFiles.usefulInfoTip6': 'Dúvidas ou sugestões? Entre no nosso Discord.',
  'designFiles.usefulInfoTip7': 'Gostou do OpenDesign? Deixe uma estrela no GitHub.',
  'designFiles.usefulInfoTip8': 'Siga @OpenDesignHQ no X para acompanhar as novidades.',
  'designFiles.usefulInfoTip9': 'Arraste imagens, documentos ou pastas inteiras para este painel — o agente usará tudo como contexto.',
  'designFiles.usefulInfoTip10': 'Clique em «Novo rascunho», desenhe um layout e deixe o agente gerá-lo.',
  'designFiles.usefulInfoTip11': 'Selecione qualquer elemento na prévia para comentar — o agente fará ajustes pontuais.',
  'designFiles.usefulInfoTip12': 'Não gostou do resultado? Marcar o elemento é mais rápido que descrever de novo.',
  'designFiles.usefulInfoTip13': 'Exporte qualquer design como PDF, imagem ou HTML independente em um clique.',
  'designFiles.usefulInfoTip14': 'Gostou de um projeto? Salve-o como template pelo menu Compartilhar.',
  'designFiles.usefulInfoTip15': 'Depois do deploy, gere cartões de compartilhamento social na hora.',
  'designFiles.usefulInfoTip16': 'Siga @opendesign.ai no Threads para novidades dos bastidores.',
  'designFiles.usefulInfoTip17': 'Siga @opendesign.ai no Instagram para inspiração de design.',
  'designFiles.usefulInfoTip18': 'Inscreva-se na OpenDesign no YouTube para tutoriais e demos.',
  'designFiles.usefulInfoTip19': 'Siga a OpenDesign no LinkedIn para novidades do produto.',
  'designFiles.usefulInfoTip20': 'Siga a OpenDesign no Xiaohongshu para dicas e inspiração.',
  'quickSwitcher.placeholder': 'Abrir arquivo…',
  'quickSwitcher.empty': 'Nenhum arquivo neste projeto',
  'quickSwitcher.noMatches': 'Sem resultados',
  'quickSwitcher.navigate': 'navegar',
  'quickSwitcher.open': 'abrir',
  'quickSwitcher.close': 'fechar',
  'pasteDialog.title': 'Colar texto',
  'pasteDialog.hint': 'Salvo na pasta do projeto. Escolha qualquer nome.',
  'pasteDialog.fileNameLabel': 'Nome do arquivo',
  'pasteDialog.namePlaceholder': 'notas.txt',
  'pasteDialog.contentLabel': 'Conteúdo',
  'pasteDialog.contentPlaceholder': 'Cole qualquer coisa…',
  'pasteDialog.save': 'Salvar',
  'pasteDialog.cancel': 'Cancelar',
  'sketch.save': 'Salvar esboço',
  'sketch.cancel': 'Cancelar',
  'sketch.saving': 'Salvando…',
  'sketch.saved': 'Salvo',
  'sketch.tooltipMainMenu': 'Menu principal: salvar, exportar, ajuda e ajustes da tela',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Alterações não salvas',
  'sketch.tooltipClean': 'Salvo',
  'fileViewer.empty': 'Selecione um arquivo para visualizar.',
  'fileViewer.loading': 'Carregando…',
  'fileViewer.exportPptx': 'Exportar como PPTX',
  'fileViewer.openInNewTab': 'Abrir em nova aba',
  'fileViewer.copyPath': 'Copiar caminho',
  'fileViewer.copied': 'Copiado!',
  'fileViewer.share': 'Compartilhar',
  'fileViewer.binaryMeta': 'Binário · {size}',
  'fileViewer.binaryNote': 'Arquivo binário ({size} bytes). Baixe ou abra do disco para inspecionar.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Documento',
  'fileViewer.presentationMeta': 'Apresentação',
  'fileViewer.spreadsheetMeta': 'Planilha',
  'fileViewer.previewUnavailable': 'Prévia indisponível. Baixe ou abra o arquivo para inspecionar.',
  'fileViewer.download': 'Baixar',
  'fileViewer.open': 'Abrir',
  'fileViewer.imageMeta': 'Imagem · {size}',
  'fileViewer.reactMeta': 'Componente React · {size}',
  'fileViewer.sketchMeta': 'Esboço · {size}',
  'fileViewer.markdownStreamingMeta': 'Prévia em streaming…',
  'fileViewer.markdownErrorMeta': 'A prévia pode estar incompleta (erro de geração).',
  'fileViewer.markdownStreamingStatus': 'Streaming… mostrando markdown parcial.',
  'fileViewer.markdownErrorStatus': 'Erro de geração. Mostrando o último conteúdo disponível.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Vídeo · {size}',
  'fileViewer.audioMeta': 'Áudio · {size}',
  'fileViewer.reload': 'Recarregar',
  'fileViewer.reloadDisk': 'Recarregar do disco',
  'fileViewer.copy': 'Copiar',
  'fileViewer.copyTitle': 'Copiar conteúdo do arquivo',
  'fileViewer.saveDisabled': 'Salvar (visualizador somente leitura)',
  'fileViewer.save': 'Salvar',
  'fileViewer.preview': 'Prévia',
  'fileViewer.source': 'Código-fonte',
  'fileViewer.tweaks': 'Ajustes',
  'fileViewer.tweaksUnavailable': 'Sem painel de ajustes neste artefato',
  'fileViewer.jsxModuleTitle': 'Sem visualização independente',
  'fileViewer.jsxModuleBody': 'Este arquivo é um módulo de componente carregado por outra página.',
  'fileViewer.jsxModuleCta': 'Abra a página que o renderiza:',
  'fileViewer.comment': 'Comentar',
  'fileViewer.edit': 'Editar',
  'fileViewer.draw': 'Desenhar',
  'fileViewer.mark': 'Marcar',
  'fileViewer.markTool': 'Ferramenta de marcação',
  'fileViewer.boxSelect': 'Selecionar área',
  'fileViewer.textTool': 'Texto',
  'fileViewer.textAnnotationRemove': 'Remover texto',
  'fileViewer.screenshot': 'Captura de tela',
  'fileViewer.versions.entry': 'Versões',
  'fileViewer.versions.entryFull': 'Histórico de versões',
  'fileViewer.versions.title': 'Versões',
  'fileViewer.versions.countOne': '1 versão',
  'fileViewer.versions.countMany': '{count} versões',
  'fileViewer.versions.current': 'Atual',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Versão {version}',
  'fileViewer.versions.listAria': 'Versões do arquivo',
  'fileViewer.versions.loading': 'Carregando versões...',
  'fileViewer.versions.empty': 'Ainda não há versões.',
  'fileViewer.versions.loadFailed': 'Não foi possível carregar as versões.',
  'fileViewer.versions.previewFailed': 'Não foi possível carregar a prévia desta versão.',
  'fileViewer.versions.previewLoading': 'Carregando prévia da versão...',
  'fileViewer.versions.noPrompt': 'Nenhum prompt registrado',
  'fileViewer.versions.noPromptBody': 'Nenhum prompt foi registrado para esta versão.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Copiar prompt',
  'fileViewer.versions.fullscreen': 'Prévia em tela cheia',
  'fileViewer.versions.open': 'Abrir prévia',
  'fileViewer.versions.currentHelp': 'Esta já é a versão atual.',
  'fileViewer.versions.restoreHelp': 'Ao alternar, este HTML será restaurado como uma nova versão atual.',
  'fileViewer.versions.restore': 'Alternar para esta versão',
  'fileViewer.versions.restoreConfirmTitle': 'Mudar para esta versão?',
  'fileViewer.versions.restoreConfirmCta': 'Mudar',
  'fileViewer.versions.restoring': 'Alternando...',
  'fileViewer.versions.restoreFailed': 'Não foi possível alternar para esta versão.',
  'fileViewer.versions.restoreSuccess': 'Alternado para esta versão.',
  'fileViewer.editScreenshotToChat': 'Captura de tela para o chat',
  'manualEdit.layers': 'Camadas',
  'manualEdit.editableCount': '{count} editáveis',
  'manualEdit.hiddenBadge': 'Oculto',
  'manualEdit.title': 'Editor manual',
  'manualEdit.fallbackTitle': 'Editar',
  'manualEdit.movePanel': 'Mover painel de edição',
  'manualEdit.editParams': 'Editar parâmetros',
  'manualEdit.closePanel': 'Fechar painel de edição',
  'manualEdit.selectLayer': 'Selecione uma camada',
  'manualEdit.empty': 'Clique em um elemento na pré-visualização ou escolha uma camada.',
  'manualEdit.noEditableLayers': 'Nenhuma camada editável encontrada.',
  'manualEdit.noClass': 'sem classe',
  'manualEdit.tabsAria': 'Abas de edição manual',
  'manualEdit.tabContent': 'Conteúdo',
  'manualEdit.tabStyle': 'Estilo',
  'manualEdit.tabAttributes': 'Atributos',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Código-fonte',
  'manualEdit.attributesJson': 'JSON de atributos',
  'manualEdit.selectedHtml': 'HTML do elemento selecionado',
  'manualEdit.fullSource': 'Código-fonte completo do artefato',
  'manualEdit.applyContent': 'Aplicar conteúdo',
  'manualEdit.applyStyle': 'Aplicar estilo',
  'manualEdit.applyAttributes': 'Aplicar atributos',
  'manualEdit.applyHtml': 'Aplicar HTML',
  'manualEdit.applySource': 'Aplicar código-fonte',
  'manualEdit.invalidAttributes': 'JSON de atributos inválido.',
  'manualEdit.changes': 'Alterações',
  'manualEdit.undo': 'Desfazer',
  'manualEdit.redo': 'Refazer',
  'manualEdit.noChanges': 'Nenhuma edição manual ainda.',
  'manualEdit.imageUrl': 'URL da imagem',
  'manualEdit.altText': 'Texto alternativo',
  'manualEdit.label': 'Rótulo',
  'manualEdit.text': 'Texto',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Cor do texto',
  'manualEdit.background': 'Plano de fundo',
  'manualEdit.fontSize': 'Tamanho da fonte',
  'manualEdit.weight': 'Espessura',
  'manualEdit.align': 'Alinhamento',
  'manualEdit.textAlignLeft': 'Alinhar à esquerda',
  'manualEdit.textAlignCenter': 'Centralizar',
  'manualEdit.textAlignRight': 'Alinhar à direita',
  'manualEdit.padding': 'Preenchimento',
  'manualEdit.margin': 'Margem',
  'manualEdit.radius': 'Raio',
  'manualEdit.referenceValues': 'Valores de referência',
  'manualEdit.referenceValuesEmpty': 'Nenhum valor de referência correspondente',
  'manualEdit.referenceValuesLoading': 'Carregando…',
  'manualEdit.lineHeight': 'Altura da linha',
  'manualEdit.letterSpacing': 'Espaçamento entre letras',
  'manualEdit.borderStyle': 'Estilo da borda',
  'manualEdit.borderStyleSolid': 'Sólida',
  'manualEdit.borderStyleDashed': 'Tracejada',
  'manualEdit.borderStyleDotted': 'Pontilhada',
  'manualEdit.borderStyleDouble': 'Dupla',
  'manualEdit.borderStyleNone': 'Nenhuma',
  'manualEdit.border': 'Borda',
  'manualEdit.width': 'Largura',
  'manualEdit.minHeight': 'Altura mínima',
  'manualEdit.deleteElement': 'Excluir elemento',
  'manualEdit.deleteElementConfirm': 'Excluir o elemento selecionado? Isso pode ser revertido com Desfazer.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Enviar imagem',
  'manualEdit.uploadingImage': 'Enviando imagem…',
  'manualEdit.uploadImageFailed': 'Não foi possível enviar a imagem.',
  'manualEdit.focusSlides': 'Focar nos slides',
  'manualEdit.showPanels': 'Mostrar painéis',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Diminuir zoom',
  'fileViewer.zoomIn': 'Aumentar zoom',
  'fileViewer.resetZoom': 'Redefinir zoom',
  'fileViewer.viewportAria': 'Viewport de pré-visualização',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Pré-visualização em desktop de largura total',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Visualização em tablet a 820 × 1180 (referência moderna em retrato)',
  'fileViewer.viewportMobile': 'Celular',
  'fileViewer.viewportMobileTitle': 'Visualização em celular a 390 × 844',
  'fileViewer.reloadAria': 'Recarregar',
  'fileViewer.previousSlide': 'Slide anterior',
  'fileViewer.nextSlide': 'Próximo slide',
  'fileViewer.slideNavAria': 'Navegação de slides',
  'fileViewer.speakerNotes': 'Notas do apresentador',
  'fileViewer.speakerNotesSlide': 'Slide {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Sem notas do apresentador para este slide.',
  'fileViewer.speakerNotesEdit': 'Editar',
  'fileViewer.speakerNotesSave': 'Salvar notas',
  'fileViewer.speakerNotesSaving': 'Salvando…',
  'fileViewer.speakerNotesSaved': 'Salvo',
  'fileViewer.speakerNotesSaveFailed': 'Não foi possível salvar as notas do apresentador.',
  'fileViewer.speakerNotesPlaceholder': 'Adicione notas do apresentador para este slide…',
  'fileViewer.previewAssetBlockedTitle': 'Recurso da prévia bloqueado',
  'fileViewer.previewAssetBlockedDetail': 'Não foi possível carregar {filePath}. Substitua symlinks externos por arquivos dentro deste projeto.',
  'fileViewer.presenterReset': 'Redefinir',
  'fileViewer.present': 'Apresentar',
  'fileViewer.presentInTab': 'Nesta aba',
  'fileViewer.presentFullscreen': 'Tela cheia',
  'fileViewer.presentNewTab': 'Nova aba',
  'fileViewer.presentFromBeginning': 'Iniciar do começo',
  'fileViewer.presentFromCurrentSlide': 'Iniciar do slide atual',
  'fileViewer.presenterMode': 'Modo do apresentador',
  'fileViewer.exitPresentation': 'Sair da apresentação',
  'fileViewer.shareLabel': 'Compartilhar',
  'fileViewer.shareMenuShareLink': 'COMPARTILHAR',
  'fileViewer.shareMenuPublishOnline': 'COMPARTILHAR NA SUA HOSPEDAGEM',
  'fileViewer.shareMenuDownload': 'BAIXAR',
  'fileViewer.shareMenuPresentation': 'Apresentação',
  'fileViewer.shareMenuSourceFiles': 'Arquivos-fonte',
  'fileViewer.shareMenuSave': 'SALVAR',
  'fileViewer.shareMenuPublishViaOd': 'COMPARTILHAMENTO RÁPIDO · OPENDESIGN',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Obter link de compartilhamento',
  'fileViewer.publishSingleFileDescription': 'Qualquer pessoa com o link pode vê-lo online. Por enquanto só é possível compartilhar um único arquivo — recursos locais incorporados, como imagens, ainda não são suportados.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Criando link…',
  'fileViewer.unpublishFile': 'Parar de compartilhar',
  'fileViewer.shareEmptyStateTitle': 'Nada para compartilhar ainda',
  'fileViewer.shareEmptyStateDescription': 'Crie ou participe de uma equipe para compartilhar este arquivo com colegas',
  'fileViewer.shareEmptyStateCreateTeam': 'Criar equipe',
  'fileViewer.shareTeamMissingTitle': 'Ainda não há uma equipe para compartilhar',

  'fileViewer.publishFileRequiresTeam': 'Publicar um link público exige um espaço de trabalho de equipe. Mude para um espaço de equipe ou use Implantar para publicar este arquivo.',
  'fileViewer.publishFileRequiresWorkspace': 'Um link de compartilhamento exige um workspace conectado. Entre no OpenDesign Cloud ou compartilhe este arquivo por deploy.',
  'fileViewer.publishFileFailed': 'Não foi possível criar o link de compartilhamento. Tente novamente ou use uma opção de deploy abaixo.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Copiar link de compartilhamento',
  'fileViewer.openSharePage': 'Abrir página compartilhada',
  'fileViewer.shareLinkRequiresDeploy': 'Publique online primeiro para obter um link',
  'fileViewer.shareLinkPublishGuide': 'Publique online acima para habilitar o compartilhamento ↑',
  'fileViewer.shareAfterGenerationComplete': 'Compartilhamento disponível após a geração',
  'fileViewer.copyProviderLink': 'Copiar link do {provider}',
  'fileViewer.copyCloudflareLink': 'Copiar link do Cloudflare',
  'fileViewer.screenshotCopying': 'Copiando captura de tela...',
  'fileViewer.screenshotCopied': 'Captura de tela copiada para a área de transferência',
  'fileViewer.screenshotClipboardDenied': 'O navegador bloqueou o acesso à área de transferência',
  'fileViewer.screenshotPreviewLoading': 'A pré-visualização ainda está carregando. Tente novamente em instantes.',
  'fileViewer.screenshotCaptureFailed': 'Não foi possível capturar a pré-visualização. Tente novamente.',
  'fileViewer.exportPdf': 'Exportar como PDF',
  'fileViewer.exportPdfAllSlides': 'Exportar como PDF (todos os slides)',
  'fileViewer.exportPptxBusy': 'Aguarde o turno atual terminar.',
  'fileViewer.exportPptxHint': 'Envie uma solicitação ao agente para converter este design em PPTX.',
  'fileViewer.exportPptxNa': 'Exportação PPTX não está disponível aqui.',
  'fileViewer.exportZip': 'Baixar como .zip',
  'fileViewer.exportHtml': 'Exportar como HTML independente',
  'fileViewer.exportMd': 'Exportar como Markdown',
  'fileViewer.exportImage': 'Exportar como imagem',
  'fileViewer.exportPptxImages': 'Exportar como PPTX (imagens)',
  'fileViewer.exportPptxEditable': 'Exportar como PPTX (editável)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Exportando…',
  'fileViewer.exportSlideProgress': 'Exportando slide {current}/{total}…',
  'fileViewer.exportingElapsed': 'Exportando… {seconds}s',
  'fileViewer.exportSlideEta': 'Slide {current}/{total} · ~{seconds}s restantes',
  'fileViewer.exportFailed': 'Falha na exportação. Tente novamente.',
  'fileViewer.exportDone': 'Exportação concluída',
  'fileViewer.exportImageFailed': 'Falha ao capturar a imagem. Tente novamente ou use a ferramenta de captura de tela do seu navegador.',
  'fileViewer.exportImageModalSubtitle': 'Escolha um formato e baixe a prévia atual como imagem.',
  'fileViewer.exportImageFormatLabel': 'Formato',
  'fileViewer.exportImageSaving': 'Salvando imagem…',
  'fileViewer.exportImageSaved': 'Imagem salva',
  'fileViewer.exportImageDownloadStarted': 'Download iniciado',
  'fileViewer.exportImageDownloadDetails': '{filename} está nos downloads do navegador se a janela Salvar como não apareceu.',
  'fileViewer.exportJsx': 'Exportar como JSX',
  'fileViewer.exportReactHtml': 'Exportar prévia como HTML',
  'fileViewer.exportStarted': 'Exportação iniciada',
  'fileViewer.saveAsTemplate': 'Salvar como template…',
  'fileViewer.savingTemplate': 'Salvando template…',
  'fileViewer.savedTemplate': 'Salvo como "{name}"',
  'fileViewer.savedTemplateFail': 'Não foi possível salvar o template — tente novamente.',
  'fileViewer.templateNamePrompt': 'Nome do template',
  'fileViewer.templateNameDefault': 'Template sem título',
  'fileViewer.templateDescPrompt': 'Descrição curta (opcional — o que torna este template útil?)',
  'liveArtifact.refresh.button': 'Atualizar',
  'liveArtifact.refresh.buttonTitle': 'Atualizar este artefato ao vivo',
  'liveArtifact.refresh.loadingTitle': 'Carregando artefato ao vivo…',
  'liveArtifact.refresh.noSourceTitle': 'Ainda não há fonte de atualização somente leitura aprovada.',
  'liveArtifact.refresh.running': 'Atualizando…',
  'liveArtifact.refresh.runningMessage': 'Atualizando dados e prévia. Isso pode levar um momento.',
  'liveArtifact.refresh.runningAction': 'A prévia anterior continua visível até a atualização ter sucesso.',
  'liveArtifact.refresh.successOne': 'Atualização concluída. Dados atualizados.',
  'liveArtifact.refresh.successMany': 'Atualização concluída. Dados atualizados.',
  'liveArtifact.refresh.successAction': 'A prévia foi recarregada com os dados confirmados mais recentes.',
  'liveArtifact.refresh.previousFailure': 'Atualização anterior falhou: {message}',
  'liveArtifact.refresh.failureAction': 'Revise o histórico de atualização, corrija a fonte ou permissão e tente novamente.',
  'liveArtifact.refresh.networkFailure': 'A solicitação de atualização falhou. Verifique sua conexão e tente novamente.',
  'liveArtifact.refresh.genericFailure': 'Atualização falhou.',
  'liveArtifact.refresh.statusNever': 'Não atualizável',
  'liveArtifact.refresh.statusReady': 'Pronto para atualizar',
  'liveArtifact.refresh.statusSucceeded': 'Atualizado',
  'liveArtifact.refresh.statusFailed': 'Atualização falhou',
  'liveArtifact.refresh.statusRunning': 'Atualizando',
  'liveArtifact.refresh.statusRunningDescription': 'Uma execução de atualização está em andamento no momento.',
  'liveArtifact.refresh.statusSucceededDescription': 'A última atualização foi concluída com sucesso.',
  'liveArtifact.refresh.statusFailedDescription': 'A última tentativa de atualização não foi concluída com sucesso.',
  'liveArtifact.refresh.statusReadyDescription': 'Fontes atualizáveis estão configuradas, mas nenhuma execução está em andamento.',
  'liveArtifact.refresh.statusNeverDescription': 'Este artefato ao vivo ainda não tem fonte de atualização.',
  'liveArtifact.refresh.eventStarted': 'Iniciada',
  'liveArtifact.refresh.eventSucceeded': 'Bem-sucedida',
  'liveArtifact.refresh.eventFailed': 'Falhou',
  'liveArtifact.refresh.eventStartedDetail': 'Atualização iniciada…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} fonte atualizada',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} fontes atualizadas',
  'liveArtifact.refresh.timelineEmpty': 'Ainda não há atividade de atualização nesta sessão. Acione Atualizar para registrar uma linha do tempo ou aguarde execuções automáticas.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Última atualização',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Nunca',
  'liveArtifact.refresh.justNow': 'agora mesmo',
  'liveArtifact.refresh.factCreated': 'Criado',
  'liveArtifact.refresh.factLastUpdated': 'Última atualização',
  'liveArtifact.refresh.factUnknown': 'Desconhecido',
  'liveArtifact.refresh.persistedTitle': 'Histórico de atualizações persistido',
  'liveArtifact.refresh.persistedHint': 'Entradas carregadas de refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Ainda não há histórico de atualizações persistido.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'bem-sucedida',
  'liveArtifact.refresh.persistedStatusRunning': 'em execução',
  'liveArtifact.refresh.persistedStatusFailed': 'falhou',
  'liveArtifact.refresh.persistedStatusCancelled': 'cancelada',
  'liveArtifact.refresh.persistedStatusSkipped': 'ignorada',
  'liveArtifact.refresh.sessionTitle': 'Atividade da sessão',
  'liveArtifact.refresh.sessionHint': 'Eventos observados enquanto esta aba está aberta',
  'liveArtifact.refresh.docSourceTitle': 'Fonte do documento',
  'liveArtifact.refresh.docSourceHint': 'Fonte configurada',
  'liveArtifact.refresh.docSourceType': 'Tipo',
  'liveArtifact.refresh.docSourceTool': 'Ferramenta',
  'liveArtifact.refresh.docSourceConnector': 'Conector',
  'liveArtifact.refresh.debugSummary': 'Metadados avançados de depuração',
  'liveArtifact.refresh.debugNote': 'Pode incluir IDs de conectores, nomes de arquivos, metadados de fonte e caminhos internos de artefatos.',
  'liveArtifact.viewer.tabPreview': 'Prévia',
  'liveArtifact.viewer.tabCode': 'Código',
  'liveArtifact.viewer.tabData': 'Dados',
  'liveArtifact.viewer.tabRefreshHistory': 'Histórico de atualização',
  'liveArtifact.viewer.dataEmpty': 'Nenhum cache data.json disponível.',
  'liveArtifact.viewer.code.templateHeading': 'HTML do modelo',
  'liveArtifact.viewer.code.renderedHeading': 'HTML renderizado',
  'liveArtifact.viewer.code.templateHelp': 'O modelo editável usado com data.json para gerar a prévia.',
  'liveArtifact.viewer.code.renderedHelp': 'O index.html gerado atualmente carregado pela Prévia.',
  'liveArtifact.viewer.code.variantAria': 'Variante de código',
  'liveArtifact.viewer.code.variantTemplate': 'Modelo',
  'liveArtifact.viewer.code.variantRendered': 'Renderizado',
  'liveArtifact.viewer.code.loading': 'Carregando código…',
  'liveArtifact.viewer.code.unavailable': 'O código ainda não está disponível.',
  'liveArtifact.viewer.code.empty': 'Este arquivo de código está vazio.',
  'fileViewer.deployToVercel': 'Implantar na Vercel',
  'fileViewer.redeployToVercel': 'Implantar novamente',
  'fileViewer.deployingToVercel': 'Implantando na Vercel…',
  'fileViewer.deployProviderLabel': 'Provedor',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Destino',
  'fileViewer.deployTargetPreview': 'Pré-visualização',
  'fileViewer.deployTargetProduction': 'Produção',
  'fileViewer.deployToProvider': 'Implantar em {provider}',
  'fileViewer.redeployToProvider': 'Implantar novamente em {provider}',
  'fileViewer.deployingToProvider': 'Implantando em {provider}…',
  'fileViewer.preparingPublicLink': 'Preparando link público…',
  'fileViewer.copyDeployLink': 'Copiar link',
  'fileViewer.deployModalTitle': 'Implantar',
  'fileViewer.deployModalSubtitle': 'Use a conta do provedor selecionado para implantar esta prévia HTML.',
  'fileViewer.vercelToken': 'Token da Vercel',
  'fileViewer.vercelTokenGetLink': 'Obter token da Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Cole seu token da Vercel',
  'fileViewer.vercelTokenReuseHint': 'O token salvo será usado. Insira um novo token para substituí-lo.',
  'fileViewer.vercelTokenRequired': 'Insira e salve primeiro um token da Vercel.',
  'fileViewer.cloudflareApiToken': 'Token de API da Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Obter token de API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cole seu token de API da Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'O token de API da Cloudflare salvo será usado. Insira um novo token para substituí-lo.',
  'fileViewer.cloudflareApiTokenRequired': 'Insira e salve primeiro um token de API da Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Selecione Pages Edit ao criar o token de API; domínios personalizados precisam de Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID da equipe',
  'fileViewer.vercelTeamSlug': 'Slug da equipe',
  'fileViewer.cloudflareAccountId': 'ID da conta',
  'fileViewer.cloudflareAccountIdHint': 'Encontre o ID da conta no painel da Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Insira e salve primeiro um Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Domínio',
  'fileViewer.cloudflareZonePlaceholder': 'Salve as configurações do Cloudflare para carregar os domínios',
  'fileViewer.cloudflareZoneRequired': 'Selecione primeiro um domínio do Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Carregando domínios da Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Atualizar domínios',
  'fileViewer.cloudflareZonesLoadFailed': 'Não foi possível carregar os domínios do Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Nenhum domínio completo ativo do Cloudflare foi encontrado para esta conta.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefixo de subdomínio',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use apenas um rótulo DNS: letras minúsculas, números e hífens.',
  'fileViewer.cloudflareHostnamePreview': 'Prévia do domínio personalizado: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opcional: vincule um domínio personalizado. Se deixar em branco, um link pages.dev ainda será criado.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL do pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Domínio personalizado',
  'fileViewer.optional': 'Opcional',
  'fileViewer.vercelPreviewOnly': 'As implantações são apenas Preview por enquanto.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages usa Direct Upload.',
  'fileViewer.savingConfig': 'Salvando…',
  'fileViewer.deployConfigSaveFailed': 'Não foi possível salvar as configurações da Vercel.',
  'fileViewer.deployFailed': 'Falha na implantação. Verifique as configurações da Vercel e tente novamente.',
  'fileViewer.deployProviderConfigSaveFailed': 'Não foi possível salvar as configurações de {provider}.',
  'fileViewer.deployProviderFailed': 'A implantação em {provider} falhou. Verifique as configurações e tente novamente.',
  'fileViewer.deployResultLabel': 'URL implantada',
  'fileViewer.deployLinkReady': 'Pronto',
  'fileViewer.deploySuccessToast': 'Implantação enviada com sucesso',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Link público pendente',
  'fileViewer.deployLinkDelayed': 'Seu site foi implantado. O provedor ainda está preparando o link público.',
  'fileViewer.deployLinkFailed': 'Falha no domínio personalizado',
  'fileViewer.deployLinkProtectedLabel': 'Proteção da implantação ativada',
  'fileViewer.deployLinkProtected': 'O site foi implantado, mas este link de prévia exige autenticação. Desative Deployment Protection ou use um domínio personalizado.',
  'fileViewer.retryLink': 'Tentar novamente agora',
  'questionForm.submit': 'Enviar',
  'questionForm.skip': 'Pular',
  'questionForm.locked': 'Respondido',
  'conv.switch': 'Trocar conversa',
  'conv.label': 'Conversa',
  'conv.heading': 'Conversas',
  'conv.new': '+ Nova',
  'conv.empty': 'Ainda não há conversas.',
  'conv.untitled': 'Conversa sem título',
  'conv.renameTooltip': 'Clique duas vezes para renomear',
  'conv.delete': 'Excluir conversa',
  'conv.deleteConfirm': 'Excluir "{title}"? Isso remove as mensagens.',
  'agentPicker.label': 'Agente',
  'agentPicker.modeChoose': 'Escolha o modo de execução',
  'agentPicker.localCli': 'CLI local',
  'agentPicker.daemonOff': 'daemon desligado',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Selecione uma CLI de agente de código detectada',
  'agentPicker.noAgents': 'nenhum agente no PATH',
  'agentPicker.notInstalled': 'não instalado',
  'agentPicker.rescan': 'Reescanear agentes no PATH local',
  'tool.openInTab': 'Abrir {name} em uma aba',
  'tool.open': 'abrir',
  'tool.todos': 'Tarefas',
  'tool.todosExpand': 'Mostrar tarefas',
  'tool.todosCollapse': 'Ocultar tarefas',
  'tool.todosDone': 'Concluído',
  'tool.todosDismiss': 'Fechar lista de tarefas',
  'tool.write': 'Escrever',
  'tool.edit': 'Editar',
  'tool.read': 'Ler',
  'tool.delete': 'Excluir',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Buscar',
  'tool.search': 'Pesquisar',
  'tool.lines': '{n} linhas',
  'tool.changeSingular': 'alteração',
  'tool.changePlural': 'alterações',
  'tool.in': 'em {path}',
  'tool.hide': 'ocultar',
  'tool.output': 'saída',
  'tool.running': 'executando…',
  'tool.error': 'erro',
  'tool.done': 'concluído',
  'assistant.role': 'Assistente',
  'assistant.workingLabel': 'Trabalhando',
  'assistant.doneLabel': 'Concluído',
  'assistant.canceledLabel': 'Cancelado',
  'assistant.copyMarkdown': 'Copiar Markdown da resposta',
  'assistant.forkConversation': 'Bifurcar daqui',
  'assistant.forkingConversation': 'Bifurcando…',
  'assistant.shareToOpenDesign': 'Compartilhar com OpenDesign',
  'assistant.shareToOpenDesignBusy': 'Preparando pacote…',
  'assistant.feedbackPrompt': 'Feedback',
  'assistant.feedbackPositive': 'Útil',
  'assistant.feedbackNegative': 'Não útil',
  'assistant.feedbackReasonTitle': 'Diga-nos o motivo',
  'assistant.feedbackReasonPositiveMatched': 'Entendeu meu pedido',
  'assistant.feedbackReasonPositiveVisual': 'Ficou bom',
  'assistant.feedbackReasonPositiveUseful': 'Estrutura útil',
  'assistant.feedbackReasonPositiveEasy': 'Fácil de continuar editando',
  'assistant.feedbackReasonPositiveDesignSystem': 'Seguiu o design system',
  'assistant.feedbackReasonNegativeMissed': 'Não atendeu ao meu pedido',
  'assistant.feedbackReasonNegativeVisual': 'A qualidade visual precisa melhorar',
  'assistant.feedbackReasonNegativeIncomplete': 'Saída incompleta',
  'assistant.feedbackReasonNegativeHard': 'Difícil de usar',
  'assistant.feedbackReasonNegativeDesignSystem': 'Não seguiu o design system',
  'assistant.feedbackReasonOther': 'Outro',
  'assistant.feedbackReasonPlaceholder': 'Adicione uma nota curta...',
  'assistant.feedbackReasonSubmit': 'Enviar',
  'assistant.emptyResponseLabel': 'Sem saída',
  'assistant.emptyResponseMessage': 'O provedor encerrou a solicitação sem retornar texto ou artefato. Tente outro modelo ou provedor, verifique a cota ou tente novamente.',
  'assistant.unfinishedLabel': 'Interrompido com trabalho pendente',
  'assistant.unfinishedSummary': '{n} tarefa(s) restante(s)',
  'assistant.unfinishedMore': '+{n} mais',
  'assistant.continueRemaining': 'Continuar tarefas restantes',
  'chat.resumeRunCta': 'Continuar a execução',
  'assistant.outTokens': '{n} saída',
  'assistant.producedFiles': 'Arquivos deste turno',
  'assistant.openFile': 'Abrir',
  'assistant.downloadFile': 'Baixar',
  'nextStep.title': 'Próximo passo',
  'nextStep.more': 'Mais',
  'nextStep.share': 'Compartilhar',
  'nextStep.download': 'Baixar',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Contribuir',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Criando design...',
  'assistant.thinking': 'Pensando',
  'assistant.thought': 'Pensou',
  'assistant.thoughtFor': 'Pensou por {s}s',
  'assistant.systemReminder': 'Lembrete do sistema',
  'assistant.possiblePromptInjection': 'Possível injeção de prompt',
  'assistant.waitingFirstOutput': 'Aguardando primeira saída',
  'assistant.statusBootingAgent': 'Iniciando agente',
  'assistant.statusPreparing': 'Preparando...',
  'assistant.statusStarting': 'Iniciando',
  'assistant.statusRequesting': 'Enviando solicitação',
  'assistant.statusThinking': 'Pensando',
  'assistant.statusStreaming': 'Transmitindo',
  'assistant.slowHint': 'Está demorando mais que o normal. O formulário geralmente aparece em 5–10 s — você pode Parar e reformular.',
  'assistant.verbEditing': 'Editando',
  'assistant.verbWriting': 'Escrevendo',
  'assistant.verbReading': 'Lendo',
  'assistant.verbSearching': 'Pesquisando',
  'assistant.verbRunning': 'Executando',
  'assistant.verbTodos': 'Tarefas',
  'assistant.verbFetching': 'Buscando',
  'assistant.verbCalling': 'Chamando',
  'qf.answered': 'respondido',
  'qf.choose': 'Escolha…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'Outro',
  'qf.required': 'obrigatório',
  'qf.lockedSubmitted': 'Respostas enviadas — o agente usará isso pelo resto da sessão.',
  'qf.lockedPrev': 'Este formulário é de um turno anterior.',
  'qf.hint': 'Escolha o que se encaixa. Pule campos opcionais se não se importar — o agente usará padrões sensatos.',
  'qf.submitDefault': 'Enviar respostas',
  'qf.submitDisabledTitle': 'Preencha os campos obrigatórios primeiro',
  'qf.submitTitle': 'Enviar respostas',
  'qf.cardSelected': 'selecionado',
  'qf.cardRefs': 'Refs:',
  'qf.cardSampleText': 'A rápida raposa marrom · 0123',
  'questions.tabLabel': 'Perguntas',
  'questions.banner': 'Posso fazer algumas perguntas rápidas?',
  'questions.bannerAnswered': 'Perguntas respondidas',
  'questions.continue': 'Continuar',
  'questions.generating': 'Gerando perguntas…',
  'questions.skipAll': 'Pular tudo',
  'questions.autoSkipHint': 'Continua automaticamente quando o cronômetro termina',
  'questions.submitting': 'Enviando…',
  'sketch.toolSelect': 'Selecionar (sem ação)',
  'sketch.toolPen': 'Caneta',
  'sketch.toolText': 'Texto',
  'sketch.toolRect': 'Retângulo',
  'sketch.toolArrow': 'Seta',
  'sketch.toolEraser': 'Borracha',
  'sketch.color': 'Cor',
  'sketch.strokeSize': 'Espessura do traço',
  'sketch.undo': 'Desfazer',
  'sketch.clear': 'Limpar',
  'sketch.close': 'Fechar',
  'sketch.closeConfirm': 'Fechar o esboço e descartar as alterações não salvas?',
  'sketch.textPrompt': 'Texto:',
  'sketch.textModalTitle': 'Adicionar texto',
  'critiqueTheater.userFacingName': 'Júri de Design',
  'critiqueTheater.roleDesigner': 'Designer',
  'critiqueTheater.roleCritic': 'Crítico',
  'critiqueTheater.roleBrand': 'Marca',
  'critiqueTheater.roleA11y': 'Acessibilidade',
  'critiqueTheater.roleCopy': 'Texto',
  'critiqueTheater.roundLabel': 'Rodada {n} de {m}',
  'critiqueTheater.mustFix': '{n} correção obrigatória',
  'critiqueTheater.composite': 'Composto',
  'critiqueTheater.threshold': 'Limite',
  'critiqueTheater.consensus': 'Consenso',
  'critiqueTheater.interrupt': 'Interromper',
  'critiqueTheater.interrupting': 'Interrompendo…',
  'critiqueTheater.interrupted': 'Interrompido',
  'critiqueTheater.degradedHeading': 'Painel offline nesta execução',
  'critiqueTheater.degradedReasonMalformed': 'Saída do painel malformada (o parser rejeitou o bloco).',
  'critiqueTheater.degradedReasonOversize': 'A saída do painel excedeu o limite seguro de bytes.',
  'critiqueTheater.degradedReasonAdapter': 'O adaptador {adapter} não suportou o protocolo Critique.',
  'critiqueTheater.degradedReasonProtocol': 'O adaptador {adapter} enviou uma versão de protocolo não suportada.',
  'critiqueTheater.degradedReasonMissingArtifact': 'A execução terminou sem um artefato final.',
  'critiqueTheater.replay': 'Reproduzir',
  'critiqueTheater.replaySpeed': 'Velocidade de reprodução',
  'critiqueTheater.readOnly': 'Somente leitura',
  'critiqueTheater.shippedSummary': 'Entregue na rodada {round} · composto {composite}',
  'critiqueTheater.interruptedSummary': 'Interrompido na rodada {round} · melhor composto {composite}',
  'critiqueTheater.shippedBadge': 'Publicado',
  'critiqueTheater.belowThresholdBadge': 'Abaixo do limite',
  'critiqueTheater.timedOutBadge': 'Tempo esgotado',
  'critiqueTheater.failedHeading': 'Falha na execução',
  'critiqueTheater.failedReasonCliExit': 'O Agent CLI saiu com código diferente de zero antes do painel poder concluir.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Uma rodada excedeu seu limite de tempo.',
  'critiqueTheater.failedReasonTotalTimeout': 'A execução completa excedeu seu limite total de tempo.',
  'critiqueTheater.failedReasonOrchestrator': 'Erro interno do orquestrador.',
  'critiqueTheater.transcriptEmpty': 'Ainda não há transcrição para reproduzir. Execute uma crítica para gravar uma.',
  'critiqueTheater.transcriptLoading': 'Carregando transcrição…',
  'critiqueTheater.transcriptError': 'Não foi possível carregar a transcrição: {error}',
  'critiqueTheater.replaySpeedPaused': 'Pausado',
  'critiqueTheater.replaySpeedInstant': 'Instantâneo',
  'critiqueTheater.replaySpeedLive': 'Ao vivo',
  'critiqueTheater.replaySpeedFast': 'Rápido',
  'critiqueTheater.settingsNav': 'Júri de Design',
  'critiqueTheater.settingsNavHint': 'Revisão de design com cinco painéis para suas execuções',
  'critiqueTheater.settingsEnabledLabel': 'Mostrar o Design Jury durante as execuções do agent',
  'critiqueTheater.settingsEnabledDescription': 'Quando ativado, uma revisão com cinco painéis aparece junto às gerações do agent e avalia a saída antes da publicação. Você pode interromper a qualquer momento.',
  'critiqueTheater.settingsEnabledProjectHint': 'Salvo para este projeto. Novas execuções neste projeto serão roteadas pelo Design Jury no servidor.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Abra um projeto para persistir isso no servidor. Até lá, isso altera apenas a preferência no navegador.',
  'pet.title': 'Bichinhos',
  'pet.subtitle': 'Adote um companheirinho que flutua sobre o seu workspace.',
  'pet.navTitle': 'Bichinhos',
  'pet.navHint': 'Adote ou personalize',
  'pet.tabBuiltIn': 'Inclusos',
  'pet.tabBuiltInHint': 'Companheiros incluídos no OpenDesign — escolha um e adote.',
  'pet.builtInEmpty': 'Os pets integrados não estão disponíveis agora. Atualize a aba Comunidade quando o daemon voltar.',
  'pet.tabCustom': 'Personalizado',
  'pet.tabCustomHint': 'Defina nome, glifo, cor ou envie um sprite.',
  'pet.tabCommunity': 'Comunidade',
  'pet.tabCommunityHint': 'Bichinhos chocados pelo Codex — adote ou gere um novo com IA.',
  'pet.tabsAria': 'Fonte do bichinho',
  'pet.adopt': 'Adotar',
  'pet.adoptedBadge': 'Adotado',
  'pet.adoptCallout': 'Adote um bichinho',
  'pet.changePet': 'Trocar bichinho',
  'pet.wake': 'Acordar',
  'pet.tuck': 'Esconder',
  'pet.wakeTitle': 'Acordar o bichinho — mostrar o overlay.',
  'pet.tuckTitle': 'Esconder o bichinho — ocultar o overlay.',
  'pet.settingsTitle': 'Abrir configurações do bichinho',
  'pet.useCustom': 'Usar meu bichinho',
  'pet.customTitle': 'Crie o seu',
  'pet.customHint': 'Escolha nome, símbolo e cor de destaque — o overlay atualiza ao vivo.',
  'pet.customGreetingPlaceholder': 'Diga oi pelo seu bichinho…',
  'pet.fieldName': 'Nome',
  'pet.fieldGlyph': 'Símbolo',
  'pet.fieldGlyphHint': 'Um único emoji funciona melhor (por ex. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Saudação',
  'pet.fieldAccent': 'Cor de destaque',
  'pet.fieldAccentCustom': 'Cor personalizada',
  'pet.fieldAccentDefault': 'Cor de destaque padrão',
  'pet.overlayAria': 'Companheiro',
  'pet.spriteAria': '{name} — arraste para mover, clique para conversar',
  'pet.spriteTitle': 'Olá de {name}! Clique para conversar.',
  'pet.taskSummarySingle': '{count} tarefa do agent em execução.',
  'pet.taskSummaryMultiple': '{count} tarefas do agent em execução em {projects} projetos.',
  'pet.taskSummaryRecentSingle': '{count} tarefa do agent concluída recentemente.',
  'pet.taskSummaryRecentMultiple': '{count} tarefas de agent concluídas recentemente.',
  'pet.taskListAria': 'Tarefas de agent ativas',
  'pet.taskOpenProject': 'Abrir {project}',
  'pet.taskGroup.running': 'Em execução',
  'pet.taskGroup.queued': 'Aguardando',
  'pet.taskGroup.recent': 'Concluídas recentemente',
  'pet.idleQuote.leonardo.text': 'Aprender nunca esgota a mente.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Vi o anjo no mármore e esculpi até libertá-lo.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Há dois recursos que podem ajudar o escultor: a luz e a sombra.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Quando se está pintando, não se pensa.',
  'pet.idleQuote.raphael.author': 'Rafael',
  'pet.idleQuote.caravaggio.text': 'Todas as obras, não importa o quê ou por quem pintadas, não passam de bagatelas e ninharias infantis, a menos que sejam feitas e pintadas a partir da vida.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'O essencial é se comover, amar, esperar, tremer, viver.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Bichinhos — acordar, esconder ou escolher',
  'pet.composerMenuTitle': 'Bichinhos',
  'pet.composerMenuHint': 'dica: digite /pet para alternar',
  'pet.composerOpenSettings': 'Gerenciar pets',
  'pet.welcomeTeaserTitle': 'Adote um bichinho',
  'pet.welcomeTeaserBody': 'Um companheirinho que flutua pelo workspace.',
  'pet.welcomeTeaserCta': 'Escolher',
  'pet.imageUpload': 'Enviar sprite',
  'pet.imageReplace': 'Substituir sprite',
  'pet.imageRemove': 'Usar emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF ou SVG. Spritesheet? Envie uma faixa horizontal e ajuste o número de frames.',
  'pet.imageHintActive': 'Mostrando seu sprite. Defina frames > 1 para animar um spritesheet horizontal.',
  'pet.fieldFrames': 'Frames',
  'pet.fieldFramesHint': '1 = estático. > 1 = spritesheet horizontal.',
  'pet.fieldFps': 'Velocidade (fps)',
  'pet.fieldFpsHint': 'Velocidade da animação dos frames.',
  'pet.atlasImport': 'Importar sprite do Codex',
  'pet.atlasImportTitle': 'Importe um atlas hatch-pet 8x9 / 192x208 (PNG ou WebP).',
  'pet.atlasPickerTitle': 'Escolha uma linha de animação',
  'pet.atlasPickerHint': 'Os pets do Codex trazem 9 linhas de animação. Por padrão mantemos o atlas inteiro para que o pet troque de linha ao passar o mouse, conforme a direção do arrasto e após longa ociosidade. Você também pode fixar uma única linha.',
  'pet.atlasCancel': 'Descartar atlas',
  'pet.atlasAdopt': 'Fixar nesta linha',
  'pet.atlasAdoptFull': 'Usar atlas inteiro (animado)',
  'pet.atlasAdoptFullTitle': 'Mantém todas as linhas para o pet reagir a hover, direção do arrasto e ociosidade longa.',
  'pet.atlasAdoptRowTitle': 'Corta apenas a linha destacada em uma tira de loop único.',
  'pet.atlasActiveHint': 'Atlas animado ativo — o pet escolhe a linha com base na sua interação (hover, arrasto, ociosidade).',
  'pet.atlasRow.idle': 'Parado',
  'pet.atlasRow.running-right': 'Corre à direita',
  'pet.atlasRow.running-left': 'Corre à esquerda',
  'pet.atlasRow.waving': 'Acenando',
  'pet.atlasRow.jumping': 'Pulando',
  'pet.atlasRow.failed': 'Falhou',
  'pet.atlasRow.waiting': 'Esperando',
  'pet.atlasRow.running': 'Correndo',
  'pet.atlasRow.review': 'Revisão',
  'pet.hatchTitle': 'Choque um novo pet com IA',
  'pet.hatchHint': 'Use a skill hatch-pet incluída no chat para gerar um spritesheet estilo Codex e depois importe-o aqui.',
  'pet.hatchConcept': 'Conceito do pet (opcional)',
  'pet.hatchConceptPlaceholder': 'ex.: um shiba pixel art com um suéter aconchegante',
  'pet.hatchCopy': 'Copiar prompt',
  'pet.hatchCopied': 'Copiado!',
  'pet.hatchFoot': 'Quando a skill salvar seu pet, volte aqui e clique em "Importar sprite do Codex".',
  'pet.slashPopoverAria': 'Comandos slash',
  'pet.slashPopoverTitle': 'Comandos',
  'pet.slashPopoverHint': '↑↓ navegar · enter escolher · esc fechar',
  'pet.slashPet': 'Alternar, adotar ou abrir as configurações do pet.',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': 'Acordar o pet flutuante.',
  'pet.slashPetTuck': 'Guardar o pet por agora.',
  'pet.slashHatch': 'Gere um pet Codex com a skill hatch-pet.',
  'pet.slashHatchArg': '<conceito>',
  'pet.slashSearch': 'Pesquise na web pelo comando OD research.',
  'pet.slashSearchArg': '<consulta>',
  'pet.codexTitle': 'Recém-chocados',
  'pet.codexSubtitle': 'Pets empacotados pela skill hatch-pet aparecem aqui para adoção em um clique.',
  'pet.codexSubtitleWithDir': 'Verificando {dir} em busca de pacotes do hatch-pet.',
  'pet.codexEmpty': 'Ainda sem pets chocados. Digite /hatch no chat para gerar um.',
  'pet.codexLoading': 'Procurando pets chocados…',
  'pet.codexRefresh': 'Atualizar',
  'pet.codexAdopt': 'Adotar',
  'pet.codexAdopting': 'Adotando…',
  'pet.communitySync': 'Baixar pets da comunidade',
  'pet.communitySyncing': 'Baixando…',
  'pet.communitySyncTitle': 'Sincronizar os pets mais recentes do Codex Pet Share + j20 Hatchery em ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} pets novos sincronizados ({total} no total).',
  'pet.communitySyncFailed': 'Falha na sincronização: {error}',
  'pet.codexBundled': 'Incluído',
  'pet.codexBundledTitle': 'Já vem com o OpenDesign — sem download.',
  'settings.systemPrefsTitle': 'Preferências do sistema',
  'settings.systemPrefsHint': 'Som de conclusão, notificações do navegador e alertas de status das tarefas.',
  'settings.notifications': 'Notificações',
  'settings.notificationsHint': 'Som e notificação na conclusão da tarefa',
  'settings.notifyCompletionSound': 'Som de conclusão',
  'settings.notifyCompletionSoundHint': 'Toca ao terminar uma rodada. Desativado por padrão.',
  'settings.notifySuccessSound': 'Som de sucesso',
  'settings.notifyFailureSound': 'Som de falha',
  'settings.notifyDesktop': 'Notificação na área de trabalho',
  'settings.notifyDesktopHint': 'Enviada quando a janela não está em foco.',
  'settings.notifyDesktopBlocked': 'Bloqueadas pelo navegador. Habilite nas configurações do site.',
  'settings.notifyDesktopUnsupported': 'Notificações na área de trabalho indisponíveis neste ambiente.',
  'settings.notifyTest': 'Enviar teste',
  'settings.notifyTestSent': 'Notificação de teste enviada. Se nenhum banner aparecer, verifique as notificações do navegador e do sistema.',
  'settings.notifyTestFailed': 'Falha ao chamar a notificação. Verifique as notificações do navegador e do sistema.',
  'settings.notifySoundDing': 'Tilim',
  'settings.notifySoundChime': 'Carrilhão',
  'settings.notifySoundTwoToneUp': 'Dois tons crescente',
  'settings.notifySoundPluck': 'Dedilhado',
  'settings.notifySoundBuzz': 'Zumbido',
  'settings.notifySoundTwoToneDown': 'Dois tons descendente',
  'settings.notifySoundThud': 'Baque',
  'settings.skills': 'Habilidades',
  'settings.skillsHint': 'Habilidades funcionais que o agente pode invocar durante a tarefa',
  'settings.skillsNew': 'Nova habilidade',
  'settings.skillsEmpty': 'Selecione uma habilidade à esquerda ou crie uma nova.',
  'settings.skillsEdit': 'Editar',
  'settings.skillsDelete': 'Excluir',
  'settings.skillsDeleteConfirm': 'Confirmar exclusão',
  'settings.skillsName': 'Nome',
  'settings.skillsTriggers': 'Gatilhos (separados por vírgulas ou novas linhas)',
  'settings.skillsDescription': 'Descrição',
  'settings.skillsBody': 'Corpo do SKILL.md',
  'settings.skillsCreate': 'Criar',
  'settings.skillsSave': 'Salvar',
  'settings.skillsSaving': 'Salvando…',
  'settings.skillsOverrideCreate': 'Criar substituição do usuário',
  'settings.skillsOverrideSave': 'Salvar como substituição do usuário',
  'settings.skillsBuiltInOverrideWarning': 'Editar esta habilidade integrada cria uma substituição do usuário. A entrada integrada ficará oculta na lista até você excluir a substituição. Continuar?',
  'settings.skillsFiles': 'Arquivos',
  'settings.skillsNoFiles': 'Nenhum arquivo nesta pasta de habilidade.',
  'settings.skillsNameRequired': 'O nome da habilidade é obrigatório.',
  'settings.skillsBodyRequired': 'O conteúdo da habilidade é obrigatório.',
  'settings.designSystems': 'Design systems',
  'settings.designSystemsHint': 'Explore e ative os design systems disponíveis',
  'settings.designSystemsInstalled': 'Instalados',
  'settings.designSystemsAdd': 'Adicionar design system',
  'settings.designSystemsHiddenCount': '{count} ocultos da galeria inicial',
  'settings.designSystemsShowAll': 'Mostrar todos',
  'settings.designSystemsShowHidden': 'Mostrar ocultos',
  'settings.designSystemsSource': 'Origem',
  'settings.designSystemsSourceLocal': 'Local',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Referência do registro shadcn',
  'settings.designSystemsImportShadcn': 'Importar do shadcn',
  'settings.designSystemsStructure': 'Estrutura',
  'settings.designSystemsModeHybrid': 'Híbrido',
  'settings.designSystemsModeNormalized': 'Normalizado',
  'settings.designSystemsModeVerbatim': 'Literal',
  'settings.designSystemsCraft': 'Ofício',
  'settings.designSystemsCraftColor': 'Cor',
  'settings.designSystemsCraftAccessibility': 'Acessibilidade',
  'settings.designSystemsGithubUrl': 'URL do GitHub',
  'settings.designSystemsProjectPath': 'Caminho do projeto',
  'settings.designSystemsImportGithub': 'Importar do GitHub',
  'settings.designSystemsImportProject': 'Importar do projeto',
  'settings.designSystemsImportedStatus': '{title} importado',
  'settings.designSystemsViewImported': 'Ver design system importado',
  'settings.designSystemsCategory': 'Categoria',
  'settings.designSystemsAllCategories': 'Todas as categorias',
  'settings.designSystemsShowInHomeGallery': 'Mostrar na galeria inicial',
  'settings.projectLocations': 'Locais de projetos',
  'settings.projectLocationsHint': 'Raízes de armazenamento do workspace',
  'settings.projectLocationsDescription': 'Adicione bases de trabalho que podem conter várias pastas de projetos do OpenDesign. Novos projetos são salvos como uma pasta dentro da base selecionada.',
  'settings.projectLocationsSaveError': 'Não foi possível salvar os locais de projetos. Verifique se cada caminho é uma pasta acessível.',
  'settings.projectLocationsSaved': 'Locais de projetos salvos.',
  'settings.projectLocationsScanError': 'Não foi possível escanear os locais de projetos.',
  'settings.projectLocationsScanComplete': 'Escaneamento concluído: {imported} importados, {existing} já registrados.',
  'settings.projectLocationsNoFolderSelected': 'Nenhuma pasta selecionada.',
  'settings.projectLocationsDuplicate': 'Essa base de trabalho já foi adicionada.',
  'settings.projectLocationsWorkBaseMeta': 'Base de trabalho · projetos são criados aqui como subpastas',
  'settings.projectLocationsAddFolder': 'Adicionar pasta…',
  'settings.projectLocationsDefaultBadge': 'Local padrão',
  'settings.projectLocationsMakeDefault': 'Tornar padrão',
  'settings.projectLocationsDefaultSaved': 'Local padrão do projeto atualizado.',
  'settings.librarySkills': 'Habilidades',
  'settings.libraryDesignSystems': 'Sistemas de design',
  'settings.librarySearch': 'Pesquisar...',
  'settings.libraryAll': 'Todos',
  'settings.libraryPreview': 'Visualizar',
  'settings.libraryPreviewClose': 'Fechar',
  'settings.libraryLoading': 'Carregando...',
  'settings.libraryNoResults': 'Nenhum item corresponde à sua pesquisa.',
  'settings.libraryEnabled': 'Ativado',
  'settings.libraryDisabled': 'Desativado',
  'settings.connectorsNavHint': 'Conexões com sistemas externos',
  'settings.connectorsHint': 'Gerencie configurações de conectores e provedores de ferramentas para este dispositivo.',
  'settings.connectorsComposioApiKey': 'Chave de API da Composio',
  'settings.connectorsSavedTitle': 'Salva no daemon local',
  'settings.connectorsSavedWithTail': 'Salva · ••••{tail}',
  'settings.connectorsSaved': 'Salva',
  'settings.connectorsGetApiKey': 'Obter chave de API',
  'settings.connectorsReplaceKeyPlaceholder': 'Cole uma nova chave para substituir a salva',
  'settings.connectorsApiKeyPlaceholder': 'Cole a chave de API da Composio',
  'settings.connectorsClear': 'Limpar',
  'settings.connectorsClearConfirmTitle': 'Limpar a chave de API do Composio salva?',
  'settings.connectorsClearConfirmBody': 'Remover a chave desconecta todos os conectores do Composio vinculados a este workspace. Contas conectadas, autorizações OAuth e acessos a ferramentas serão removidos.',
  'settings.connectorsClearConfirmContinue': 'Continuar',
  'settings.connectorsClearFinalTitle': 'Isso vai desconectar todos os conectores',
  'settings.connectorsClearFinalBody': 'Não há como desfazer. Você precisará reconectar cada integração do zero depois de colar uma nova chave.',
  'settings.connectorsClearFinalConfirm': 'Apagar chave e desconectar',
  'settings.connectorsClearArming': 'Um instante…',
  'settings.connectorsClearCancel': 'Cancelar',
  'settings.connectorsSaveKey': 'Salvar chave',
  'settings.connectorsSaveKeyTitle': 'Enviar esta chave para o daemon local',
  'settings.connectorsKeySaving': 'Salvando…',
  'settings.connectorsKeySaved': 'Salvo ✓',
  'settings.connectorsKeyError': 'Não foi possível salvar a chave. Confirme que o daemon local está ativo e tente novamente.',
  'settings.connectorsHelpSaved': 'Sua chave desbloqueia o catálogo abaixo e permanece no daemon local. Cole uma nova chave para substituí-la ou limpe para remover.',
  'settings.connectorsHelpUnsaved': 'Alterações não salvas — clique em Salvar chave para armazenar esta credencial no daemon local e desbloquear o catálogo abaixo.',
  'settings.connectorsHelpEmpty': 'Adicione uma chave para desbloquear o catálogo abaixo. As chaves são armazenadas localmente no daemon e nunca enviadas por variáveis de ambiente.',
  'settings.connectorsLoadingSavedKey': 'Procurando uma chave salva no daemon local…',
  'settings.autosaveSaving': 'Salvando…',
  'settings.autosaveSaved': 'Todas as alterações foram salvas',
  'settings.autosaveError': 'Não foi possível salvar as alterações. O daemon local pode estar offline.',
  'settings.libraryToggleLabel': 'Alternar',
  'settings.memory': 'Memória',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.customInstructionsTitle': 'Regras globais',
  'settings.customInstructionsHint': 'Instruções fixas que o OpenDesign deve seguir em todos os chats. Salve fatos, preferências e contexto do projeto como memórias.',
  'settings.customInstructionsPlaceholder': 'ex.: "Sempre use TypeScript. Prefira componentes funcionais. Mantenha as respostas concisas."',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Ativada',
  'settings.memoryDisabled': 'Desativada',
  'settings.memoryEnableLabel': 'Ativar injeção de memória',
  'settings.memoryDisabledBanner': 'A memória está atualmente DESATIVADA. Os fatos existentes são preservados no disco, mas não serão incorporados a novos chats e os novos turnos não extrairão nada novo.',
  'settings.memoryNew': 'Nova memória',
  'settings.memoryEdit': 'Editar',
  'settings.memoryDelete': 'Excluir',
  'settings.memoryPreview': 'Visualizar',
  'settings.memoryEmpty': 'Nenhuma memória ainda.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Prefiro o modo escuro',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Precisa de um ponto de partida? Clique para preencher o formulário:',
  'settings.memoryStarterUserName': 'Minha função',
  'settings.memoryStarterUserDesc': 'Sou engenheiro de frontend trabalhando em uma ferramenta de design SaaS',
  'settings.memoryStarterUserBody': '- Função: engenheiro frontend sênior\n- Stack: React, TypeScript, Vite\n- Domínio: ferramentas de design / colaboração\n- Fuso horário: GMT+8 (Asia/Shanghai)\n\nQuando aplicar: qualquer chat — baseie os exemplos em frontend web.',
  'settings.memoryStarterFeedbackName': 'Preferências de interface',
  'settings.memoryStarterFeedbackDesc': 'Modo escuro, texto do corpo grande, baixa densidade de informação',
  'settings.memoryStarterFeedbackBody': '- Tema: escuro por padrão\n- Texto do corpo: ≥ 18px\n- Densidade de informação: prefira espaços em branco, menos itens por tela\n\nPor quê: menos cansaço visual em sessões longas.\nQuando aplicar: sempre que você gerar UI, páginas web ou slides.',
  'settings.memoryStarterProjectName': 'Projeto atual',
  'settings.memoryStarterProjectDesc': 'OpenDesign v0.5 — editor de design conduzido por chat',
  'settings.memoryStarterProjectBody': '- Objetivo: lançar o editor orientado por chat neste trimestre\n- Prioridades: renderização em streaming, multimodal local, offline-first\n- Stack: Next.js 16, daemon Express, SQLite\n\nQuando aplicar: em qualquer conversa sobre este projeto.',
  'settings.memorySaveHint': 'Não salvo automaticamente — clique em Criar / Salvar para aplicar.',
  'settings.memoryIndexSaveHint': 'As edições no índice não são salvas automaticamente — clique em Salvar índice para aplicar.',
  'settings.memoryIndexUnsaved': 'Alterações não salvas',
  'settings.memoryFlashCreated': '✓ Memória criada',
  'settings.memoryFlashSaved': '✓ Memória salva',
  'settings.memoryFlashDeleted': '✓ Memória excluída',
  'settings.memoryFlashIndexSaved': '✓ Índice salvo',
  'settings.memoryFlashPathCopied': '✓ Caminho copiado',
  'settings.memoryNameLabel': 'Título',
  'settings.memoryTypeLabel': 'Tipo',
  'settings.memoryDescLabel': 'Descrição',
  'settings.memoryBodyLabel': 'Conteúdo',
  'settings.memoryTypeUser': 'Usuário',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Projeto',
  'settings.memoryTypeReference': 'Referência',
  'artifact.odCardTaskBriefChip': 'Memória aplicada · ver briefing',
  'artifact.odCardScorecardTitle': 'Autoverificação',
  'artifact.odCardScorecardStatusPass': 'Aprovado',
  'artifact.odCardScorecardStatusPartial': 'Parcial',
  'artifact.odCardScorecardStatusFail': 'Precisa de ajustes',
  'artifact.odCardRuleKicker': 'Regra proposta',
  'artifact.odCardRuleNameLabel': 'Nome',
  'artifact.odCardRuleDescriptionLabel': 'Descrição',
  'artifact.odCardRuleAssertionLabel': 'Deve valer',
  'artifact.odCardRuleCheckLabel': 'Como verificar',
  'artifact.odCardRuleRationaleLabel': 'Por quê',
  'artifact.odCardRuleKeep': 'Manter',
  'artifact.odCardRuleEdit': 'Editar',
  'artifact.odCardRuleDone': 'Concluído',
  'artifact.odCardRuleDiscard': 'Descartar',
  'artifact.odCardRuleSaving': 'Salvando…',
  'artifact.odCardRuleSaved': 'Salvou “{name}” como regra',
  'artifact.odCardRuleError': 'Não foi possível salvar a regra. Tente novamente.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryTypeProfile': 'Perfil',
  'settings.memoryTypeRule': 'Regra',
  'settings.memoryTabMemories': 'Memórias',
  'settings.memoryTabMemoriesCaption': 'Ver e gerenciar a memória salva',
  'settings.memoryTabHow': 'Como funciona',
  'settings.memoryTabHowCaption': 'Os dois loops e seus controles',
  'settings.memoryAddDisclosure': 'Adicionar ou importar memórias',
  'settings.memoryAddDisclosureHint': 'Perfil, entrada manual ou apps conectados',
  'settings.memoryProfileTab': 'Perfil de trabalho',
  'settings.memoryProfileTabCaption': 'Quem você é e seus padrões',
  'settings.memoryProfileTitle': 'Seu perfil de trabalho',
  'settings.memoryProfileHint':
    'Alguns fatos sobre você e seus padrões. A memória injeta isso antes de cada tarefa para que o agente entenda o que você quer a partir de um pedido curto.',
  'settings.memoryProfileName': 'Perfil de trabalho',
  'settings.memoryProfileDescription':
    'Função, empresa, domínio, público, gosto e padrões que o assistente deve reutilizar.',
  'settings.memoryProfileSave': 'Salvar perfil',
  'settings.memoryProfileSaving': 'Salvando…',
  'settings.memoryProfileSaved': 'Perfil salvo',
  'settings.memoryProfileRole': 'Função',
  'settings.memoryProfileRolePlaceholder': 'ex.: Founder, designer, PM',
  'settings.memoryProfileCompany': 'Empresa / Equipe',
  'settings.memoryProfileCompanyPlaceholder': 'ex.: Acme, equipe de growth',
  'settings.memoryProfileDomain': 'Domínio',
  'settings.memoryProfileDomainPlaceholder': 'ex.: B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Público principal',
  'settings.memoryProfileAudiencePlaceholder': 'ex.: executivos, engenheiros, usuários finais',
  'settings.memoryProfileAesthetic': 'Estética / gosto',
  'settings.memoryProfileAestheticPlaceholder':
    'ex.: clean e editorial, fundos claros, bastante espaço em branco',
  'settings.memoryProfileDeliverables': 'Entregáveis padrão',
  'settings.memoryProfileDeliverablesPlaceholder': 'ex.: landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'Idioma / Região',
  'settings.memoryProfileLocalePlaceholder': 'ex.: English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Objetivos atuais',
  'settings.memoryProfileGoalsPlaceholder':
    'ex.: lançar a nova página de preços, aumentar a conversão no fluxo de teste',
  'settings.memoryHooksTitle': 'Hooks de memória',
  'settings.memoryHooksHint':
    'Escolha quais partes da memória rodam automaticamente. O interruptor principal acima desliga todas elas.',
  'settings.memoryHooksProfileLabel': 'Usar meu perfil',
  'settings.memoryHooksProfileDesc': 'Injeta seu perfil de trabalho em cada tarefa.',
  'settings.memoryHooksRewriteLabel': 'Reescrever pedidos curtos',
  'settings.memoryHooksRewriteDesc': 'PRE: expande um pedido curto em um briefing de tarefa completo.',
  'settings.memoryHooksVerifyLabel': 'Autoverificar resultado',
  'settings.memoryHooksVerifyDesc': 'POST: verifica o resultado em relação às suas regras e mostra um placar.',
  'settings.memoryHooksExtractionLabel': 'Aprender com os chats',
  'settings.memoryHooksExtractionDesc': 'Captura fatos úteis e preferências a partir dos turnos de chat.',
  'settings.memoryIndex': 'MEMORY.md (índice)',
  'settings.memoryIndexSave': 'Salvar índice',
  'settings.memoryIndexReset': 'Redefinir',
  'settings.memoryToastChanged': 'Memória atualizada',
  'settings.memoryToastClickHint': 'Ver',
  'settings.memoryAll': 'Todas',
  'settings.memoryExtractions': 'Histórico de extração',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Nenhuma extração ainda. O próximo turno do chat preencherá esta lista.',
  'settings.memoryExtractionsRefresh': 'Atualizar',
  'settings.memoryExtractionsRefreshing': 'Atualizando…',
  'settings.memoryExtractionPhaseRunning': 'Executando…',
  'settings.memoryExtractionPhaseSuccess': 'Sucesso',
  'settings.memoryExtractionPhaseSkipped': 'Ignorado',
  'settings.memoryExtractionPhaseFailed': 'Falhou',
  'settings.memoryExtractionSkipNoProvider': 'Nenhuma API key configurada para extração de memória por LLM.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'A memória está desativada.',
  'settings.memoryExtractionSkipEmpty': 'Mensagem do usuário vazia — nada a extrair.',
  'settings.memoryExtractionSkipNoMatch': 'Nenhum padrão regex correspondeu a esta interação.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'configurações de mídia',
  'settings.memoryExtractionProviderOverride': 'configurações de memória',
  'settings.memoryExtractionProposed': 'proposto',
  'settings.memoryExtractionWritten': 'gravado',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Excluir',
  'settings.memoryExtractionsClear': 'Limpar',
  'settings.memoryExtractionsClearTitle': 'Limpar todo o histórico de extração',
  'settings.memoryExtractionsClearConfirm': 'Limpar todo o histórico de extração? Isso não pode ser desfeito.',
  'settings.memoryNoProviderBannerTitle': 'A extração de memória por LLM não está em execução',
  'settings.memoryNoProviderBannerBody': 'Nenhuma API key encontrada para o extrator de memória. Adicione uma chave da OpenAI em provedores de mídia, ou defina ANTHROPIC_API_KEY / OPENAI_API_KEY no ambiente, para ativar a extração baseada em LLM. A extração heurística por regex continua ativa.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'Instalar',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Caminho local',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Instalar',
  'settings.libraryUninstall': 'Desinstalar',
  'settings.libraryBuiltIn': 'Integrado',
  'settings.libraryInstalled': 'Instalado',
  'notify.successTitle': 'Tarefa concluída',
  'notify.failureTitle': 'Tarefa falhou',
  'notify.successBody': 'Uma rodada foi concluída.',
  'notify.failureBody': 'A tarefa terminou com erro.',
  'updater.available': 'Atualização disponível',
  'updater.activeRunsTitle': 'O OpenDesign ainda está trabalhando',
  'updater.activeRunsBody': '{count} tarefas ativas ainda estão em execução. Reiniciar agora irá interrompê-las.',
  'updater.activeRunsUnknownBody': 'O OpenDesign não conseguiu confirmar se há tarefas em execução. Reiniciar agora pode interromper um trabalho ativo.',
  'updater.availableBody': 'OpenDesign {version} está disponível. Ela será baixada antes que o instalador possa abrir.',
  'updater.checking': 'Verificando atualizações',
  'updater.download': 'Baixar atualização',
  'updater.downloading': 'Baixando atualização',
  'updater.downloadingPercent': 'Baixando atualização {percent}%',
  'updater.done': 'Concluído',
  'updater.failed': 'Falha na atualização',
  'updater.installerOpenBody': 'O instalador está aberto. O OpenDesign está saindo para que você conclua a atualização.',
  'updater.installerOpened': 'Instalador aberto',
  'updater.later': 'Mais tarde',
  "updater.allowSilentUpdates": "Permitir instalação automática de futuras atualizações no app",
  'updater.openFailedFallback': 'Não foi possível abrir o instalador.',
  'updater.installRestart': 'Instalar e reiniciar',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Instalar atualização',
  'updater.opening': 'Abrindo instalador...',
  'updater.dialogAvailableGeneric': 'Há uma nova versão disponível.\nBaixe-a para instalar a atualização.',
  'updater.dialogAvailableVersion': 'A v{version} está disponível.\nBaixe-a para instalar a atualização.',
  'updater.dialogCheckFailed': 'Não foi possível buscar atualizações.\nTente novamente em instantes.',
  'updater.dialogReadyGeneric': 'Há uma nova versão pronta.\nMelhor experiência, design mais inteligente.',
  'updater.dialogReadyVersion': 'A v{version} está pronta.\nMelhor experiência, design mais inteligente.',
  'updater.dialogUnsupported': 'As atualizações no app não estão disponíveis aqui.\nBaixe a versão mais recente na página de lançamentos.',
  'updater.payloadReadyGeneric': 'A new OpenDesign update is ready. OpenDesign will close and restart automatically.',
  'updater.payloadReadyVersion': 'OpenDesign {version} is ready. OpenDesign will close and restart automatically.',
  'updater.quitButton': 'Sair do OpenDesign',
  'updater.quitFailedBody': 'O instalador está aberto, mas não foi possível sair do OpenDesign. Saia do OpenDesign antes de substituir o app.',
  'updater.quitFailedTitle': 'Não foi possível sair',
  'updater.quitting': 'Saindo...',
  'updater.ready': 'Atualização pronta',
  'updater.readyGeneric': 'Uma nova versão está pronta. O OpenDesign será fechado e abrirá o instalador.',
  'updater.readyVersion': 'OpenDesign {version} está pronto. O OpenDesign será fechado e abrirá o instalador.',
  'updater.reinstallLearnMore': 'Saiba mais',
  'updater.reinstallReadyGeneric': 'Esta atualização exige uma reinstalação completa. O OpenDesign será fechado e o instalador será aberto.',
  'updater.reinstallReadyVersion': 'O OpenDesign {version} exige uma reinstalação completa. O OpenDesign será fechado e o instalador será aberto.',
  'updater.restartAnyway': 'Reiniciar mesmo assim',
  'updater.upToDate': 'Você já está na versão mais recente.',
  'updater.viewVersionFeatures': 'Conhecer os novos recursos',
  'updater.manualDownload': 'Baixar manualmente',
  'whatsNew.updatedTitle': 'O OpenDesign {version} chegou',
  'whatsNew.cta': 'Ver as notas da versão',
  'newsletter.label': 'Newsletter (opcional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automação',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Resumo diário de conectores',
  'settings.orbit.lede': 'Coletar atividade dos conectores em uma agenda e publicar o resultado como um live artifact atualizável.',
  'settings.orbit.statusOnTitle': 'execuções diárias agendadas estão ativadas',
  'settings.orbit.statusOffTitle': 'execuções diárias agendadas estão desativadas',
  'settings.orbit.statusActive': 'Ativo',
  'settings.orbit.statusOff': 'Desativado',
  'settings.orbit.runTitle': 'Iniciar uma execução Orbit e abrir a conversa ao vivo',
  'settings.orbit.running': 'Executando…',
  'settings.orbit.runOpen': 'Executar agora',
  'settings.orbit.dailySummaryTitle': 'Resumo diário',
  'settings.orbit.dailySummarySub': 'Executa uma vez por dia no horário local agendado.',
  'settings.orbit.on': 'Ativado',
  'settings.orbit.off': 'Desativado',
  'settings.orbit.runTimeTitle': 'Horário de execução',
  'settings.orbit.runTimeSub': 'Padrão 08:00. Salve para aplicar à agenda do daemon.',
  'settings.orbit.runTimeAria': 'Horário diário de execução Orbit',
  'settings.orbit.nextRun': 'Próxima execução',
  'settings.orbit.nextRunScheduledAfterSave': 'Agendada após salvar',
  'settings.orbit.schedule': 'Agenda',
  'settings.orbit.pausedManualOnly': 'Pausado — apenas execuções manuais',
  'settings.orbit.templateTitle': 'Modelo de prompt',
  'settings.orbit.templateMissing': 'O modelo {id} não está instalado.',
  'settings.orbit.templateMissingOption': '{id} (ausente)',
  'settings.orbit.templateMissingInstall': 'Instale uma skill Orbit para orientar o prompt.',
  'settings.orbit.templateMissingPickAnother': 'Escolha outro modelo no menu.',
  'settings.orbit.templateResetTitle': 'Redefinir para {id}',
  'settings.orbit.templateReset': 'Redefinir',
  'settings.orbit.templateHelp': 'Oriente Orbit com uma skill — o prompt de exemplo do modelo selecionado é injetado em cada execução Orbit para que os resumos sigam esse formato.',
  'settings.orbit.templateAria': 'Modelo de prompt Orbit',
  'settings.orbit.templatesLoading': 'Carregando modelos…',
  'settings.orbit.templatesOptgroup': 'Modelos de skills Orbit',
  'settings.orbit.lastRun': 'Última execução',
  'settings.orbit.triggerManual': 'Manual',
  'settings.orbit.triggerScheduled': 'Agendada',
  'settings.orbit.meterAria': '{succeeded} bem-sucedidos, {skipped} ignorados, {failed} com falha de {checked} verificados',
  'settings.orbit.countChecked': 'Verificados',
  'settings.orbit.countSucceeded': 'Bem-sucedidos',
  'settings.orbit.countSkipped': 'Ignorados',
  'settings.orbit.countFailed': 'Falharam',
  'settings.orbit.runError': 'Não foi possível executar Orbit. Verifique se o daemon local está em execução e se os conectores estão configurados.',
  'settings.orbit.gateAriaLabel': 'Conectores são necessários para usar o Orbit',
  'settings.orbit.gateEyebrow': 'Configuração necessária',
  'settings.orbit.gateTitle': 'Conecte uma ferramenta para alimentar o Orbit',
  'settings.orbit.gateBody': 'O Orbit resume a atividade dos seus conectores. Você ainda não conectou nada — adicione ao menos uma integração para o Orbit ter o que reportar.',
  'settings.orbit.gateBodyNoKey': 'O Orbit resume a atividade dos conectores, e os conectores operam via Composio. Adicione uma chave de API do Composio em Conectores para desbloquear o catálogo e escolher sua primeira integração.',
  'settings.orbit.gateAction': 'Abrir Conectores',
  'settings.orbit.gateActionNoKey': 'Configurar Composio',
  'settings.orbit.gateLoading': 'Verificando seus conectores…',
  'settings.orbit.controlsLockedBadge': 'Bloqueado',
  'settings.orbit.controlsLockedHint': 'Conecte uma ferramenta para desbloquear a programação e o modelo do Orbit.',
  'settings.orbit.artifactKickerLive': 'artefato ao vivo',
  'settings.orbit.artifactKickerLegacy': 'Resumo legado',
  'settings.orbit.artifactTitle': 'Resumo diário de atividade Orbit',
  'settings.orbit.artifactMetaLive': 'Artefato HTML atualizável gerado da atividade dos conectores.',
  'settings.orbit.artifactMetaLegacy': 'Gerado antes de ativar o suporte a live artifact — execute Orbit novamente para publicar um.',
  'settings.orbit.copyMarkdownTitle': 'Copiar resumo Markdown para a área de transferência',
  'settings.orbit.copied': 'Copiado',
  'settings.orbit.copy': 'Copiar',
  'settings.orbit.openArtifact': 'Abrir artefato',
  'settings.orbit.sourceMarkdown': 'Markdown de origem',
  'settings.memoryModelInlineHintByokNeutral': 'A memória usa um modelo separado do chat. O padrão é o seu modelo de chat.',
  'diagnostics.exportTitle': 'Exportar diagnósticos',
  'diagnostics.exportButton': 'Exportar diagnósticos',
  'diagnostics.exportHint': 'Empacota logs recentes do app e informações do dispositivo em um zip para enviar à equipe.',
  'diagnostics.exporting': 'Exportando…',
  'diagnostics.exportSuccess': 'Diagnósticos salvos em {path}',
  'diagnostics.exportFailed': 'Falha ao exportar diagnósticos: {message}',
  'automations.eyebrow': 'Sessões de agentes agendadas',
  'automations.title': 'Automações',
  'automations.lede': 'Planeje conversas recorrentes para trabalho de projeto, resumos do Orbit e artefatos ao vivo.',
  'automations.summaryAria': 'Resumo de automações',
  'automations.metricActive': 'Ativas',
  'automations.metricPaused': 'Pausadas',
  'automations.metricTemplates': 'Modelos',
  'automations.newAutomation': 'Nova automação',
  'automations.yourAutomations': 'Suas automações',
  'automations.loading': 'Carregando',
  'automations.emptyTitle': 'Nenhuma automação ainda',
  'automations.emptyBody': 'Crie uma a partir de um modelo ou comece com um agendamento em branco.',
  'automations.targetNewEachRun': 'Novo projeto a cada execução',
  'automations.targetCreateEachRun': 'Novo projeto a cada execução',
  'automations.lastRun': 'Última execução {time}',
  'automations.openResult': 'Abrir resultado',
  'automations.run': 'Executar',
  'automations.runNowTitle': 'Executar agora e abrir a conversa',
  'automations.history': 'Histórico',
  'automations.hideHistory': 'Ocultar histórico',
  'automations.edit': 'Editar',
  'automations.pause': 'Pausar',
  'automations.resume': 'Retomar',
  'automations.deleteAria': 'Excluir automação',
  'automations.deleteTitle': 'Excluir esta automação',
  'automations.deleteConfirm': 'Excluir esta automação? As execuções anteriores e seus projetos são mantidos.',
  'automations.proposalsTitle': 'Propostas de evolução',
  'automations.proposalsSub': 'Revise a saída da automação antes que ela altere memória, skills ou design systems.',
  'automations.proposalsPending': '{n} pendentes',
  'automations.apply': 'Aplicar',
  'automations.reject': 'Rejeitar',
  'automations.proposalsDismissReason': 'Descartada em Automações',
  'automations.templatesTitle': 'Modelos',
  'automations.templatesSub': 'Orbit e artefatos ao vivo são modelos dentro do mesmo fluxo de automação.',
  'automations.templatesCount': '{filtered} de {total}',
  'automations.templateFiltersAria': 'Filtros de modelos',
  'automations.templatesEmptyTitle': 'Nenhum modelo nesta categoria ainda.',
  'automations.templatesEmptyBody': 'Experimente um filtro diferente ou comece com uma automação em branco.',
  'automations.useTemplate': 'Usar modelo',
  'automations.runHistoryLoading': 'Carregando histórico de execuções...',
  'automations.runHistoryEmpty': 'Nenhuma execução ainda.',
  'automations.runHistoryTitle': 'Histórico de execuções',
  'automations.runHistoryLatest': 'Últimas 10',
  'automations.crystallize': 'Cristalizar',
  'automations.crystallizing': 'Cristalizando',
  'automations.crystallizeTitle': 'Rascunhar propostas de skill e memória a partir desta execução',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Abrir conversa',
  'automations.runHistoryAria': 'Histórico de execuções da automação',
  'automations.proposalsAria': 'Propostas de evolução da automação',
  'automations.templatesAria': 'Modelos de automação',
  'automations.runInProgress': 'Em andamento',
  'automations.promptPlaceholder': 'Buscar a atividade de ontem no GitHub + Linear e resumir o que mudou.',
  'automations.scheduleStatusPaused': 'Pausada',
  'automations.nextRunManualOnly': 'Somente manual',
  'automations.nextRunScheduled': 'Agendada',
  'automations.nextRunAt': 'Próxima {time}',
  'automations.statusSucceeded': 'Concluída',
  'automations.statusFailed': 'Falhou',
  'automations.statusRunning': 'Em execução',
  'automations.statusQueued': 'Na fila',
  'automations.statusCanceled': 'Cancelada',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefato ao vivo',
  'automations.kindAutomation': 'Automação',
  'automations.proposalTargetMemory': 'Memória',
  'automations.proposalTargetDesignSystem': 'Design system',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Modelo de automação',
  'automations.proposalActionCreate': 'Criar',
  'automations.proposalActionUpdate': 'Atualizar',
  'automations.proposalActionMerge': 'Mesclar',
  'automations.proposalActionMove': 'Mover',
  'automations.proposalActionDelete': 'Excluir',
  'automations.proposalActionPromote': 'Promover',
  'automations.filterAll': 'Todas',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefatos ao vivo',
  'automations.filterMemory': 'Memória',
  'automations.filterDesignSystems': 'Design systems',
  'automations.filterSkills': 'Skills',
  'automations.filterConnectors': 'Conectores',
  'automations.filterCompression': 'Compressão',
  'automations.filterRelease': 'Versão',
  'automations.filterQuality': 'Qualidade',
  'automations.tpl.memoryRefresh.title': 'Atualizar a memória do projeto com base no trabalho recente.',
  'automations.tpl.memoryRefresh.desc': 'Transforma decisões, preferências e feedback recorrentes em atualizações de memória reutilizáveis.',
  'automations.tpl.designSystemRefresh.title': 'Atualizar design systems a partir de artefatos entregues.',
  'automations.tpl.designSystemRefresh.desc': 'Encontra tokens, componentes e regras reutilizáveis em trabalhos de design recentes.',
  'automations.tpl.liveArtifactRegistry.title': 'Auditar artefatos ao vivo e atualizar versões desatualizadas.',
  'automations.tpl.liveArtifactRegistry.desc': 'Mantém dashboards, relatórios e previews persistentes atualizados em vez de duplicá-los.',
  'automations.tpl.orbitDashboard.title': 'Criar um dashboard de atividade de conectores.',
  'automations.tpl.orbitDashboard.desc': 'Agrega os conectores selecionados em um dashboard ao vivo no estilo Orbit.',
  'automations.tpl.releaseNotes.title': 'Rascunhar notas de versão a partir do trabalho de design entregue.',
  'automations.tpl.releaseNotes.desc': 'Conecta PRs mesclados, artefatos e mudanças voltadas ao produto em notas de versão.',
  'automations.tpl.qualityRegressionWatch.title': 'Monitorar regressões de design e implementação.',
  'automations.tpl.qualityRegressionWatch.desc': 'Compara mudanças recentes com benchmarks, traces e referências aprovadas.',
  'automations.tpl.orbitDaily.title': 'Resumo diário de conectores.',
  'automations.tpl.orbitDaily.desc': 'Atualiza um resumo de atividade de conectores em um agendamento.',
  'automations.tpl.liveStatusBoard.title': 'Manter um artefato de status ao vivo atualizado.',
  'automations.tpl.liveStatusBoard.desc': 'Atualiza um único artefato persistente em vez de criar um novo relatório a cada execução.',
  'dsManager.areaAria': 'Área de design systems',
  'dsManager.tabDesignSystem': 'Design system',
  'dsManager.tabTemplate': 'Modelo',
  'dsManager.sourceAria': 'Origem do design system',
  'dsManager.templateSourceAria': 'Origem do modelo',
  'dsManager.yourSystems': 'Seus sistemas',
  'dsManager.officialPresets': 'Presets oficiais',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Sincronizar com a equipe',
  'dsManager.syncToTeamFailed': 'Não foi possível sincronizar com a equipe',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'Seus modelos',
  'dsManager.yourSystemsAria': 'Seus design systems',
  'dsManager.eyebrowDesignSystems': 'Design Systems',
  'dsManager.yourSystemsHeading': 'Seus sistemas',
  'dsManager.filterAria': 'Filtrar design systems',
  'dsManager.filterAll': 'Todos',
  'dsManager.filterPublished': 'Publicados',
  'dsManager.filterDraft': 'Rascunho',
  'dsManager.createTitle': 'Criar novo design system',
  'dsManager.createBody': 'Ensine ao OpenDesign sua marca, produto, código, ativos e referências de design.',
  'dsManager.createAction': 'Criar',
  'dsManager.emptyMine': 'Nenhum design system ainda. Crie um a partir do contexto real do produto, revise o rascunho e publique-o para projetos futuros.',
  'dsManager.badgeDefault': 'Padrão',
  'dsManager.rowMetaUpdated': 'Você · atualizado {date}',
  'dsManager.edit': 'Editar',
  'dsManager.openSystem': 'Abrir',
  'dsManager.editWithAgent': 'Editar com Agent',
  'dsManager.downloadTitle': 'Baixar design system (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Baixar {title} como .zip',
  'dsManager.downloadFailed': 'Não foi possível baixar o design system. Tente novamente.',
  'dsManager.deleteConfirm': 'Excluir "{title}"? Isso remove o rascunho do design system deste dispositivo.',
  'dsManager.makeDefault': 'Tornar padrão',
  'dsManager.statusPublished': 'Publicado',
  'dsManager.statusDraft': 'Rascunho',
  'dsManager.openSystemAria': 'Abrir {title}',
  'dsManager.deleteSystemAria': 'Excluir {title}',
  'dsManager.deletePermissionDenied': 'Você não tem permissão para excluir este design system.',
  'dsManager.presetsAria': 'Presets oficiais de design system',
  'dsManager.eyebrowLibrary': 'Biblioteca',
  'dsManager.eyebrowTemplates': 'Modelos',
  'dsManager.yourTemplatesAria': 'Seus modelos',
  'dsManager.emptyTemplates': 'Nenhum modelo ainda. Crie um a partir de qualquer projeto gerado via Compartilhar assim que a publicação de modelos for habilitada.',
  'dsManager.templateDescFallback': 'Criado a partir de um projeto',
  'dsManager.comingSoonBadge': 'Em breve',
  'dsManager.enterpriseDsTitle': 'Design systems Enterprise',
  'dsManager.enterpriseDsBody': 'Design systems compartilhados de equipe e bibliotecas de marca governadas estão chegando em breve.',
  'dsManager.enterpriseTplTitle': 'Modelos Enterprise',
  'dsManager.enterpriseTplBody': 'Modelos aprovados pela equipe e publicação em toda a organização estão chegando em breve.',
  'settings.instructionsTitle': 'Instruções e regras',
  'settings.instructionsSubtitle': 'Comportamento fixo que o assistente deve seguir',
  'settings.instructionsNavSub': 'Comportamento fixo do assistente',
  'settings.customInstructionsDesc': 'Instruções fixas que o OpenDesign segue em todas as conversas. Estas não são memórias salvas; use a Memória para fatos, preferências e contexto de projeto.',
  'mcpClient.forwardedToLabel': 'Encaminhado para:',
  'mcpClient.notForwardedToLabel': 'Não encaminhado para:',
  'mcpClient.forwardedAcpNote': 'Adaptadores ACP marcados como stdio recebem apenas servidores MCP stdio desta lista; entradas HTTP e SSE são descartadas no momento da inicialização.',
  'mcpClient.notForwardedNote': 'Para esses agentes, configure os servidores MCP no próprio arquivo de configuração do agente (ex.: ~/.codex/config.toml, ~/.gemini/settings.json); os servidores abaixo ficam sem uso silenciosamente nesse caso.',

  // Brands library + extraction
  'brand.libraryTitle': 'Kit de marca',
  'brand.librarySubtitle': 'Teach OpenDesign your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Cole um site, ou escolha uma marca abaixo, e extrairemos suas cores, fontes e logo.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Kit de marca',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'Limpar cache de atualização',
  'settings.clearUpdaterCacheHint': 'Remove atualizações baixadas e caches antigos do atualizador e redefine o estado de atualização. Use quando as atualizações parecerem travadas.',
  'settings.clearUpdaterCacheButton': 'Limpar cache',
  'settings.clearUpdaterCacheConfirmButton': 'Confirmar limpeza',
  'settings.clearUpdaterCacheSuccess': 'Cache de atualização limpo.',
  'settings.clearUpdaterCacheFailed': 'Não foi possível limpar o cache de atualização.',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Crie uma vez, construa em todo lugar',
  'onboarding.buildBody': 'O OpenDesign transforma sua marca em um sistema de design reutilizável — e mantém tudo o que você cria fiel à marca e consistente.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Criar um sistema de design',
  'onboarding.buildHome': 'Ir para o início',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. OpenDesign first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Comece com uma marca que você ama',
  'brandPicker.subtext': 'Clique em qualquer marca para extrair o kit direto do site dela.',
  'brandPicker.quickPicksLabel': 'Marcas populares — clique para extrair',
  'brandPicker.searchPlaceholder': 'Buscar marcas…',
  'brandPicker.allCategories': 'Todas',
  'brandPicker.extractAction': 'Extrair',
  'brandPicker.showMore': 'Mostrar mais',
  'brandPicker.opening': 'Iniciando a extração — abrindo {brand}…',
  'ds.kitVisualize': 'Visualizar',
  'ds.kitEdit': 'Editar',
  'ds.kitSource': 'Código',
  'ds.saveDesignMd': 'Salvar DESIGN.md',
  'ds.saving': 'Salvando…',
  'ds.copyDesignMd': 'Copiar DESIGN.md',
  'ds.editDesignMd': 'Editar DESIGN.md',
  'ds.openDesignMd': 'Abrir DESIGN.md',
  'ds.copyDesignMdModule': 'Copiar seção {module}',
  'ds.editDesignMdModule': 'Editar seção {module}',
  'ds.openDesignMdModule': 'Abrir seção {module}',
  'ds.uploadMd': 'Enviar MD',
  'ds.uploadFont': 'Adicionar arquivo de fonte',
  'ds.pasteImage': 'Colar imagem',
  'ds.refresh': 'Atualizar',
  'ds.download': 'Baixar',
  'ds.importFolder': 'Importar pasta',
  'ds.reset': 'Redefinir',
  'ds.editingDesignMdHint': 'Editar este Markdown atualiza os módulos renderizados do kit.',
  'ds.editingModuleHint': 'Apenas o módulo {module} está sendo editado.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Salvar módulo',
  'ds.uploadLogo': 'Enviar logo',
  'ds.uploadImage': 'Enviar imagem',
  'ds.uploading': 'Enviando…',
  'ds.moduleEmptyLogo': 'Ainda sem logo',
  'ds.moduleEmptyFonts': 'Nenhuma fonte capturada.',
  'ds.actionDone': 'Concluído',
  'ds.actionFailed': 'Algo deu errado. Tente novamente.',
  'ds.uploadDone': 'Enviado',
  'ds.uploadFailed': 'Falha no envio. Tente novamente.',
  'ds.deleteLogo': 'Excluir logo',
  'ds.deleteImage': 'Excluir {caption}',
  'ds.deleteProjectConfirm': 'Excluir "{title}"? Isso remove permanentemente este design system e seu projeto deste dispositivo.',
  'ds.deleteProjectAction': 'Excluir {title}',
  'ds.editColor': 'Editar {name}',
  'ds.colorLabel': 'Cor',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Valor Hex',
  'ds.saveColor': 'Salvar cor',
  'ds.invalidHexColor': 'Insira uma cor Hex válida, como #FF6A3D.',
  'ds.colorSaveFailed': 'Não foi possível salvar esta cor.',
  'ds.colorResetFailed': 'Não foi possível redefinir esta cor.',
  'ds.designMdSectionLabel': 'Seção {module} do DESIGN.md',
  'ds.kitErrorTitle': 'Esta visualização encontrou um problema.',
  'ds.kitErrorRetry': 'Recarregar',
  'ds.shortcutsLabel': 'Atalhos do teclado',
  'ds.shortcutsHint': 'Atalhos: E editar · C copiar · U enviar · R atualizar · ⌫ excluir logo',
  'ds.moduleEmptyImages': 'Ainda sem imagens',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'OpenDesign is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so OpenDesign can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'Começar de',
  'newproj.startBlank': 'Em branco',
  'newproj.startBlankHint': 'Começar do zero',
  'workspace.pages': 'Páginas',
  'workspace.allProjectFiles': 'Todos os arquivos do projeto',
  'workspace.newBlankPage': 'Nova página em branco',
  'workspace.noPagesYet': 'Nenhuma página ainda',
  'workspace.pageCreateFailed': 'Não foi possível criar a página.',
  'workspace.pageCreatorTitle': 'Criar página',
  'workspace.pageCreatorSearch': 'Buscar modelos',
  'workspace.pageCreatorCategoryAll': 'Todos os cenários',
  'workspace.pageCreatorEmpty': 'Nenhum tipo de página corresponde à sua busca.',
  'workspace.pageCreatorPreview': 'Pré-visualizar',
  'workspace.pageCreatorUse': 'Usar',
  'fileViewer.presentInTabDeckHint': 'Notas do apresentador em janela popup',
  'fileViewer.presentEscHint': 'Pressione Esc para sair',
  'fileViewer.presenterPause': 'Pausar',
  'fileViewer.presenterResume': 'Retomar',
  'fileViewer.presenterPrevious': 'Anterior',
  'fileViewer.presenterNext': 'Próximo',
  'questions.uploadingFiles': 'Enviando arquivos…',
  'questions.uploadNeedsProject': 'O envio de arquivos precisa de um projeto ativo.',
  'questions.uploadPartialFailed': '{uploaded} arquivo(s) enviado(s), mas {failed} falharam.',
  'questions.uploadFailed': 'Falha no envio de {failed} arquivo(s).',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.usePrompt': 'Usar prompt',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the OpenDesign Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the OpenDesign Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and OpenDesign will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'OpenDesign will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'OpenDesign account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by OpenDesign; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'OpenDesign is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'OpenDesign is rebuilding tokens',
  'dsFlow.jobRevising': 'OpenDesign is revising',
  'dsFlow.jobStillWorking': 'OpenDesign is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask OpenDesign to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'OpenDesign is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'OpenDesign is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'OpenDesign is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'OpenDesign official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'Desta vez, inteligência de ponta. Sem limites.',
  'campaign.deepseekV4Flash.description': 'Landings, sites, decks e imagens — o quanto precisar.',
  'campaign.deepseekV4Flash.benefit': 'DeepSeek V4 Pro e V4 Flash ilimitados',
  'campaign.deepseekV4Flash.timing': '13–27 ago: grátis durante a campanha',
  'campaign.deepseekV4Flash.ruleSummary': 'De 13 a 27 de ago, usuários pagantes podem usar o DeepSeek V4 Pro e o V4 Flash gratuitamente no OpenDesign. Abuso em larga escala pode pausar o acesso à campanha.',
  'campaign.deepseekV4Flash.windowLabel': '13–27 ago',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'duas semanas grátis',
  'campaign.deepseekV4Flash.boundary': 'A cota ilimitada do modelo e as gerações grátis do plano valem só dentro do OpenDesign — não via MCP, CLI, API ou outras superfícies. A interpretação final é do OpenDesign. Alguns modelos podem exigir fila em horários de pico.',
  'campaign.deepseekV4Flash.countdownLabel': 'Contagem regressiva',
  'campaign.deepseekV4Flash.countdownEnded': 'Campanha encerrada',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}d {hms}',
  'campaign.deepseekV4Flash.closeAria': 'Fechar',
  'campaign.deepseekV4Flash.unlocked': 'Desbloqueado',
  'campaign.deepseekV4Flash.locked': 'Bloqueado',
  'campaign.deepseekV4Flash.later': 'Agora não',
  'campaign.deepseekV4Flash.paid.eyebrow': 'Duas semanas grátis',
  'campaign.deepseekV4Flash.paid.status': 'Desbloqueado · 13–27 ago',
  'campaign.deepseekV4Flash.paid.cta': 'Usar agora',
  'campaign.deepseekV4Flash.paid.modelBadge': 'Ilimitado',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'Grátis em planos pagos',
  'campaign.deepseekV4Flash.unpaid.status': 'Faça upgrade para desbloquear · até 27 ago',
  'campaign.deepseekV4Flash.unpaid.cta': 'Fazer upgrade e usar',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'Precisa de upgrade',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'Assine durante a campanha para usar de graça; termina em 27 ago.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'Pausado',
  'campaign.deepseekV4Flash.restricted.tooltip': 'Uso anômalo em alto volume detectado; o acesso à campanha foi pausado. Fale com o suporte se precisar de ajuda.',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash ilimitados e grátis',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro e V4 Flash ilimitados e grátis — ver preços',

  'experienceSurvey.tag': "Queremos seu feedback — ajude a melhorar o OpenDesign",
  'experienceSurvey.close': "Fechar",
  'experienceSurvey.recommendation': "Qual a probabilidade de você recomendar o OpenDesign a um colega ou amigo?",
  'experienceSurvey.recommendationLow': "Nada provável",
  'experienceSurvey.recommendationHigh': "Extremamente provável",
  'experienceSurvey.improvement': "O que devemos melhorar primeiro?",
  'experienceSurvey.improvement.wrongOutput': "Não é o que eu pedi",
  'experienceSurvey.improvement.falseDone': "Diz que terminou e nada mudou",
  'experienceSurvey.improvement.hardToUse': "Difícil de usar",
  'experienceSurvey.improvement.upgradePrompts': "Muitos avisos de assinatura",
  'experienceSurvey.improvement.stuck': "Trava ou falha",
  'experienceSurvey.improvement.slow': "Lento demais",
  'experienceSurvey.improvement.looks': "O resultado não fica bom",
  'experienceSurvey.improvement.regression': "Quebra outras coisas",
  'experienceSurvey.improvement.other': "Outra coisa",
  'experienceSurvey.otherPlaceholder': "Conte com suas palavras",
  'experienceSurvey.submit': "Enviar",
  'experienceSurvey.skip': "Pular",
  'experienceSurvey.thanksTitle': "Obrigado!",
  'experienceSurvey.thanksBody': "Seu feedback vai direto para o time.",
};
